import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

export enum AcTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Payment = 'PAYMENT',
  Purchase = 'PURCHASE',
  Signup = 'SIGNUP',
  Transfer = 'TRANSFER'
}

export enum AccountType {
  Main = 'MAIN',
  Sub = 'SUB'
}

export enum AceCoinTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Payment = 'PAYMENT',
  Purchase = 'PURCHASE',
  Transfer = 'TRANSFER'
}

export type Admin = SystemUser & {
  __typename?: 'Admin';
  authorizedClubhouses?: Maybe<Array<Maybe<Scalars['String']>>>;
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  permissions: Array<Maybe<Scalars['String']>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminActivateMembership = {
  __typename?: 'AdminActivateMembership';
  payment?: Maybe<HitPayPaymentRequest>;
};

export type AdminActivateMembershipInput = {
  activationOrderNo: Scalars['String'];
  membershipUuid: Scalars['String'];
  paymentOption: AdminCreateMembershipPaymentOption;
  paymentRef?: InputMaybe<Scalars['String']>;
};

export type AdminAdminUpdatePasswordInput = {
  adminId: Scalars['String'];
  password: Scalars['String'];
};

export type AdminArgs = {
  userId: Scalars['String'];
};

export type AdminAuthResponse = {
  __typename?: 'AdminAuthResponse';
  accessToken: Scalars['String'];
  authenticatedAdmin: AuthenticatedAdmin;
};

export type AdminBasic = {
  __typename?: 'AdminBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminBooking = {
  __typename?: 'AdminBooking';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationNotificationByAppSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationByEmailSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationBySmsSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationMessage?: Maybe<Scalars['String']>;
  cancellationNotificationSentBy?: Maybe<SentBy>;
  cancellationNotificationSentByAdminId?: Maybe<Scalars['String']>;
  cancellationNotificationSentByAdminName?: Maybe<Scalars['String']>;
  cancellationNotificationSentDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  cancelledByAdminName?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  id: Scalars['String'];
  lateCancellationDetails?: Maybe<Scalars['JSON']>;
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type AdminBookingArgs = {
  bookingId: Scalars['String'];
};

export type AdminBookingAvailabilityArgs = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  durationType?: InputMaybe<DurationType>;
  facilityType?: InputMaybe<FacilityType>;
};

export type AdminBookingBasic = {
  __typename?: 'AdminBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  id: Scalars['String'];
  member: AdminBookingBasicMember;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type AdminBookingBasicMember = {
  __typename?: 'AdminBookingBasicMember';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminBookingBlackoutBasic = {
  __typename?: 'AdminBookingBlackoutBasic';
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseName?: Maybe<Scalars['String']>;
  coachDisplayName?: Maybe<Scalars['String']>;
  coachSlug?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCode>;
  date: Scalars['String'];
  type: Scalars['String'];
};

export type AdminBookingBlackoutClubhouse = {
  __typename?: 'AdminBookingBlackoutClubhouse';
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  clubhouseCode?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  facilityObjs: Array<Maybe<AdminClubhouseFacilityAvailabilityFacilityObj>>;
  isDayBlocked: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AdminBookingBlackoutClubhouseArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
};

export type AdminBookingBlackoutClubhouseUpdateInput = {
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  blockDay: Scalars['Boolean'];
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  facilityAvailability: Array<InputMaybe<AdminBookingBlackoutCreateFacilityAvailabilityInput>>;
};

export type AdminBookingBlackoutCoach = {
  __typename?: 'AdminBookingBlackoutCoach';
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  coachDisplayName: Scalars['String'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminBookingBlackoutCoachArgs = {
  coachSlug: Scalars['String'];
  date: Scalars['String'];
};

export type AdminBookingBlackoutCoachUpdateInput = {
  block09: Scalars['Boolean'];
  block10: Scalars['Boolean'];
  block11: Scalars['Boolean'];
  block12: Scalars['Boolean'];
  block13: Scalars['Boolean'];
  block14: Scalars['Boolean'];
  block15: Scalars['Boolean'];
  block16: Scalars['Boolean'];
  block17: Scalars['Boolean'];
  block18: Scalars['Boolean'];
  block19: Scalars['Boolean'];
  block20: Scalars['Boolean'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminBookingBlackoutCreate = {
  __typename?: 'AdminBookingBlackoutCreate';
  errorMessage: Scalars['String'];
  isCreateAllowed: Scalars['Boolean'];
};

export type AdminBookingBlackoutCreateFacilityAvailabilityInput = {
  facilityCode: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  time: Scalars['String'];
};

export type AdminBookingBlackoutCreateInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  coachSlug?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCode>;
  date: Scalars['String'];
  type: AdminBookingBlackoutCreateType;
};

export enum AdminBookingBlackoutCreateType {
  Clubhouse = 'CLUBHOUSE',
  Coach = 'COACH',
  Country = 'COUNTRY'
}

export type AdminBookingBlackoutDeleteInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  coachSlug?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<CountryCode>;
  date: Scalars['String'];
  type?: InputMaybe<AdminBookingBlackoutCreateType>;
};

export type AdminBookingBlackoutsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminBookingCancelInput = {
  bookingId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
  imposePenalty?: InputMaybe<Scalars['Boolean']>;
  isSameDay?: InputMaybe<Scalars['Boolean']>;
  nextHour?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  removeFromSystem?: InputMaybe<Scalars['Boolean']>;
};

export type AdminBookingCheckout = {
  __typename?: 'AdminBookingCheckout';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  balanceBefore: Scalars['String'];
  description: Scalars['String'];
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
};

export type AdminBookingCoach = {
  __typename?: 'AdminBookingCoach';
  baseCountryCode?: Maybe<CountryCode>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AdminBookingCoachAvailabilityCalendarItems = {
  __typename?: 'AdminBookingCoachAvailabilityCalendarItems';
  calendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  clubhouses: Array<Maybe<CoachClubhouse>>;
};

export type AdminBookingCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
  mode: CoachAvailabilityCalendarItemsMode;
};

export type AdminBookingCoachAvailabilityDayItem = {
  __typename?: 'AdminBookingCoachAvailabilityDayItem';
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  blockedClubhousesDay: Array<Maybe<Scalars['String']>>;
  blockedClubhousesHours: Array<Maybe<Scalars['String']>>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
};

export type AdminBookingCoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type AdminBookingCoachAvailabilitySlotItem = {
  __typename?: 'AdminBookingCoachAvailabilitySlotItem';
  hr1?: Maybe<SlotItem>;
  hr2?: Maybe<SlotItem>;
};

export type AdminBookingCoachAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  dateId: Scalars['String'];
  time: Scalars['String'];
};

export type AdminBookingCombinedCoachAvailabilityDayItem = {
  __typename?: 'AdminBookingCombinedCoachAvailabilityDayItem';
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  biOutdoor?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<CoachClubhouse>>;
  date?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
};

export type AdminBookingCombinedCoachAvailabilityDayItemArgs = {
  coachId: Scalars['String'];
  dateId: Scalars['String'];
};

export type AdminBookingEdge = {
  __typename?: 'AdminBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBookingBasic>;
};

export type AdminBookingFacilityAvailabilityCalendarItems = {
  __typename?: 'AdminBookingFacilityAvailabilityCalendarItems';
  calendarItems: Array<Maybe<FacilityAvailabilityCalendarItems>>;
};

export type AdminBookingFacilityAvailabilityCalendarItemsArgs = {
  clubhouseCode: Scalars['String'];
  currentDate: Scalars['String'];
};

export type AdminBookingFacilityAvailabilityDayItem = {
  __typename?: 'AdminBookingFacilityAvailabilityDayItem';
  nonPutting?: Maybe<NonPuttingFacilityDayItem>;
  putting?: Maybe<PuttingFacilityDayItem>;
};

export type AdminBookingFacilityAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type AdminBookingFacilityAvailabilitySlotItem = {
  __typename?: 'AdminBookingFacilityAvailabilitySlotItem';
  hr1?: Maybe<SlotItem>;
  hr2?: Maybe<SlotItem>;
  hr3?: Maybe<SlotItem>;
  hr4?: Maybe<SlotItem>;
  hr5?: Maybe<SlotItem>;
  putting30?: Maybe<SlotItem>;
  putting60?: Maybe<SlotItem>;
};

export type AdminBookingFacilityAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  isPutting: Scalars['Boolean'];
  time: Scalars['String'];
};

export type AdminBookingGameCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
};

export type AdminBookingGameCreate = {
  __typename?: 'AdminBookingGameCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingGameCreateInput = {
  clubhouseCode: Scalars['String'];
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityCode: Scalars['String'];
  gameType: GameType;
  isTrial: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  noOfPlayers: Scalars['Int'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type AdminBookingLessonIndoorCheckoutArgs = {
  coachId: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
  memberUuid: Scalars['String'];
};

export type AdminBookingLessonIndoorCreate = {
  __typename?: 'AdminBookingLessonIndoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingLessonIndoorCreateInput = {
  clubhouseCode: Scalars['String'];
  coachSlug: Scalars['String'];
  commentAdminToCoach?: InputMaybe<Scalars['String']>;
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  facilityCode: Scalars['String'];
  isTrial: Scalars['Boolean'];
  isTwoHours: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type AdminBookingLessonOutdoorCheckoutArgs = {
  coachId: Scalars['String'];
  memberUuid: Scalars['String'];
};

export type AdminBookingLessonOutdoorCreate = {
  __typename?: 'AdminBookingLessonOutdoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingLessonOutdoorCreateInput = {
  coachSlug: Scalars['String'];
  commentAdminToCoach?: InputMaybe<Scalars['String']>;
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  details: Scalars['String'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  venue: Scalars['String'];
};

export type AdminBookingPractiseCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
};

export type AdminBookingPractiseCreate = {
  __typename?: 'AdminBookingPractiseCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type AdminBookingPractiseCreateInput = {
  clubhouseCode: Scalars['String'];
  commentAdminToMember?: InputMaybe<Scalars['String']>;
  commentInternal?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityCode: Scalars['String'];
  isTrial: Scalars['Boolean'];
  memberUuid?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
  rebookId?: InputMaybe<Scalars['String']>;
  time: Scalars['String'];
};

export type AdminBookingResponse = {
  __typename?: 'AdminBookingResponse';
  edges?: Maybe<Array<Maybe<AdminBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminBookingSendCancellationNotificationInput = {
  bookingId: Scalars['String'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
};

export type AdminBookingSettings = {
  __typename?: 'AdminBookingSettings';
  cancellationConditions: CancellationConditions;
};

export type AdminBookingSettingsArgs = {
  bookingId: Scalars['String'];
};

export type AdminBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<BookingType>;
  coachId?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BookingStatus>;
};

export type AdminClientLoginGuestInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  nickName: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClientSetupInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
};

export type AdminClientStatusArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClubhouse = {
  __typename?: 'AdminClubhouse';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressCountryIso?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseId: Scalars['String'];
  colorCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  kGolfClientId?: Maybe<Scalars['String']>;
  kGolfClientSecret?: Maybe<Scalars['String']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfShopGuid?: Maybe<Scalars['String']>;
  kGolfUsername?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfPrivateRooms?: Maybe<Scalars['Int']>;
  noOfPuttingGreen?: Maybe<Scalars['Int']>;
  noOfSimulators?: Maybe<Scalars['Int']>;
  organization: ClubhouseOrganization;
  organizationId: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminClubhouseArgs = {
  clubhouseId: Scalars['String'];
};

export type AdminClubhouseBasic = {
  __typename?: 'AdminClubhouseBasic';
  addressCountry?: Maybe<Scalars['String']>;
  clubhouseCode: Scalars['String'];
  clubhouseId: Scalars['String'];
  name: Scalars['String'];
};

export type AdminClubhouseEdge = {
  __typename?: 'AdminClubhouseEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminClubhouseBasic>;
};

export type AdminClubhouseFacilitiesArgs = {
  shopGuid: Scalars['String'];
};

export type AdminClubhouseFacilityAvailability = {
  __typename?: 'AdminClubhouseFacilityAvailability';
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  facilityObjs: Array<Maybe<AdminClubhouseFacilityAvailabilityFacilityObj>>;
  isDayBlocked: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AdminClubhouseFacilityAvailabilityArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
};

export type AdminClubhouseFacilityAvailabilityFacilityObj = {
  __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj';
  availability: AdminClubhouseFacilityAvailabilityFacilityObjAvailability;
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export type AdminClubhouseFacilityAvailabilityFacilityObjAvailability = {
  __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability';
  bi0900?: Maybe<Scalars['String']>;
  bi0930?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1030?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1130?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1230?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1330?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1430?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1530?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1630?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1730?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1830?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi1930?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  bi2030?: Maybe<Scalars['String']>;
};

export type AdminClubhouseResponse = {
  __typename?: 'AdminClubhouseResponse';
  edges?: Maybe<Array<Maybe<AdminClubhouseEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminClubhousesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCoach = {
  __typename?: 'AdminCoach';
  baseCountryCode?: Maybe<CountryCode>;
  clubhouses?: Maybe<Array<Maybe<CoachClubhouse>>>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type AdminCoachArgs = {
  userId: Scalars['String'];
};

export type AdminCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
};

export type AdminCoachBasic = {
  __typename?: 'AdminCoachBasic';
  baseCountryCode?: Maybe<CountryCode>;
  coachPublished?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
};

export type AdminCoachCombinedAvailability = {
  __typename?: 'AdminCoachCombinedAvailability';
  coachId: Scalars['String'];
  coachSlug: Scalars['String'];
  dateObjs: Array<Maybe<AdminCoachCombinedAvailabilityDateObj>>;
  name: Scalars['String'];
};

export type AdminCoachCombinedAvailabilityArgs = {
  currentDate: Scalars['String'];
};

export type AdminCoachCombinedAvailabilityDateObj = {
  __typename?: 'AdminCoachCombinedAvailabilityDateObj';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  hasIndoorBooking: Scalars['Boolean'];
  hasOutdoorBooking: Scalars['Boolean'];
  isDayBlocked: Scalars['Boolean'];
};

export type AdminCoachEdge = {
  __typename?: 'AdminCoachEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminCoachBasic>;
};

export type AdminCoachResponse = {
  __typename?: 'AdminCoachResponse';
  edges?: Maybe<Array<Maybe<AdminCoachEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminCoachesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCreateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
  userType?: InputMaybe<UserType>;
};

export type AdminCreateMembershipInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  companyContactPersonDesignation?: InputMaybe<Scalars['String']>;
  companyContactPersonEmail?: InputMaybe<Scalars['String']>;
  companyContactPersonFirstName?: InputMaybe<Scalars['String']>;
  companyContactPersonLastName?: InputMaybe<Scalars['String']>;
  companyIndustry?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  mainMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
  membershipSlug: Scalars['String'];
  paymentOption: AdminCreateMembershipPaymentOption;
  paymentRef?: InputMaybe<Scalars['String']>;
  reservedId?: InputMaybe<Scalars['String']>;
  subMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
};

export enum AdminCreateMembershipPaymentOption {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Hitpay = 'HITPAY',
  Later = 'LATER',
  Na = 'NA',
  Paynow = 'PAYNOW'
}

export type AdminCreditTransactionEdge = {
  __typename?: 'AdminCreditTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CreditTransaction>;
};

export type AdminCreditTransactionResponse = {
  __typename?: 'AdminCreditTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminCreditTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminDeleteAdminInput = {
  userId: Scalars['String'];
};

export type AdminDeleteCoachInput = {
  userId: Scalars['String'];
};

export type AdminDeleteMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminEdge = {
  __typename?: 'AdminEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBasic>;
};

export type AdminExtendClientTimeInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
  timeInSeconds: Scalars['Int'];
};

export type AdminForgotPasswordInput = {
  email: Scalars['String'];
};

export type AdminForgotPasswordResponse = {
  __typename?: 'AdminForgotPasswordResponse';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type AdminForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type AdminGameHistory = {
  __typename?: 'AdminGameHistory';
  currentPage: Scalars['Int'];
  list: Array<Maybe<AdminGameHistoryListItem>>;
  maxPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminGameHistoryArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  bays?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  gameTypeField?: InputMaybe<Scalars['Boolean']>;
  gameTypeFourSome?: InputMaybe<Scalars['Boolean']>;
  gameTypePutting?: InputMaybe<Scalars['Boolean']>;
  gameTypeShot?: InputMaybe<Scalars['Boolean']>;
  gameTypeShotContest?: InputMaybe<Scalars['Boolean']>;
  gameTypeStroke?: InputMaybe<Scalars['Boolean']>;
  nickName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AdminGameHistoryListItem = {
  __typename?: 'AdminGameHistoryListItem';
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  endTime?: Maybe<Scalars['Float']>;
  gameRoundId: Scalars['Int'];
  gameType: Scalars['String'];
  gameTypeCode: Scalars['Int'];
  playerCount: Scalars['Int'];
  startTime: Scalars['Float'];
};

export type AdminGameRoundScoreCard = {
  __typename?: 'AdminGameRoundScoreCard';
  gameRoundInfo: GameRoundGameInfo;
  players: Array<Maybe<GameRoundPlayerInfo>>;
};

export type AdminJwtAccessToken = {
  __typename?: 'AdminJwtAccessToken';
  adminName?: Maybe<Scalars['String']>;
  baseCountryCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  ud?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminJwtRefreshToken = {
  __typename?: 'AdminJwtRefreshToken';
  adminName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminKGolfMember = {
  __typename?: 'AdminKGolfMember';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  connectKakao?: Maybe<Scalars['Boolean']>;
  connectWechat?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  handed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isTermsAgreeNotificationEmail?: Maybe<Scalars['Boolean']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminKGolfMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminLockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AdminManagementSystemProps = {
  __typename?: 'AdminManagementSystemProps';
  currentAppVersion: Scalars['String'];
};

export type AdminManagementSystemUserTelemetryInput = {
  pageName: Scalars['String'];
  resourceId?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<UserTelemetryResourceType>;
  ts?: InputMaybe<Scalars['String']>;
};

export type AdminMember = {
  __typename?: 'AdminMember';
  accountType?: Maybe<AccountType>;
  activationLineItems: Array<Maybe<AdminMemberActivationLineItem>>;
  activationOrderNo: Scalars['String'];
  activationPrice: Scalars['Float'];
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  companyContactPersonEmail?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  credit: Scalars['Float'];
  creditSpent: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gameCredit: Scalars['Float'];
  gender?: Maybe<Gender>;
  handed: Handed;
  hasSubscriptions: Scalars['Boolean'];
  individualId: Scalars['String'];
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locker: Scalars['Boolean'];
  memberStatus: MemberStatus;
  memberUuid: Scalars['String'];
  members: Array<Maybe<AdminMemberMember>>;
  membershipStatus: MembershipStatus;
  membershipType?: Maybe<MembershipTypeBasic>;
  membershipUuid: Scalars['String'];
  mobileNumber?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  partialNricOrFin?: Maybe<Scalars['String']>;
  practiseCredit: Scalars['Float'];
  profileImageUrl?: Maybe<Scalars['String']>;
  pushTokens: Array<Maybe<Scalars['String']>>;
  relationshipToMainMember?: Maybe<Relationship>;
  serviceNote?: Maybe<Scalars['String']>;
  signUpSidasInsoles: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  termEndDate?: Maybe<Scalars['DateTime']>;
  voucherField: Scalars['Int'];
  voucherIndoor: Scalars['Int'];
};

export type AdminMemberActivationLineItem = {
  __typename?: 'AdminMemberActivationLineItem';
  itemName: Scalars['String'];
  salesPrice: Scalars['Float'];
};

export type AdminMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminMemberBasic = {
  __typename?: 'AdminMemberBasic';
  accountType?: Maybe<AccountType>;
  appVersion?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  individualId: Scalars['String'];
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  memberStatus?: Maybe<MemberStatus>;
  membershipId: Scalars['String'];
  membershipType?: Maybe<MembershipTypeBasic>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberCreateKGolfAccountInput = {
  memberUuid: Scalars['String'];
};

export type AdminMemberCreditUpdateInput = {
  amount: Scalars['Float'];
  description: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  transactionType: TransactionType;
  type: AceCoinTransactionType;
};

export type AdminMemberEdge = {
  __typename?: 'AdminMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMemberBasic>;
};

export type AdminMemberMember = {
  __typename?: 'AdminMemberMember';
  accountType?: Maybe<AccountType>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminMemberNotificationEdge = {
  __typename?: 'AdminMemberNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminNotificationBasic>;
};

export type AdminMemberNotificationResponse = {
  __typename?: 'AdminMemberNotificationResponse';
  edges?: Maybe<Array<Maybe<AdminMemberNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMemberProfileUpdate = {
  __typename?: 'AdminMemberProfileUpdate';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  member: AdminMember;
};

export type AdminMemberProfileUpdateInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay?: InputMaybe<Scalars['String']>;
  birthdayMonth?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['String']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  handed?: InputMaybe<Handed>;
  lastName?: InputMaybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
  serviceNote?: InputMaybe<Scalars['String']>;
};

export type AdminMemberReassignMembershipIdInput = {
  membershipUuid?: InputMaybe<Scalars['String']>;
  proposedId?: InputMaybe<Scalars['String']>;
};

export type AdminMemberResendOnboardingEmailInput = {
  membershipUuid: Scalars['String'];
};

export type AdminMemberResponse = {
  __typename?: 'AdminMemberResponse';
  edges?: Maybe<Array<Maybe<AdminMemberEdge>>>;
  pageInfo?: Maybe<AdminMemberResponsePageInfo>;
};

export type AdminMemberResponsePageInfo = {
  __typename?: 'AdminMemberResponsePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  failedKGolfAccounts?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type AdminMemberSendResetPasswordEmailInput = {
  memberUuid: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type AdminMemberServiceTransactionEdge = {
  __typename?: 'AdminMemberServiceTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ServiceTransactionBasic>;
};

export type AdminMemberServiceTransactionResponse = {
  __typename?: 'AdminMemberServiceTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminMemberServiceTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMemberServiceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMemberServiceUpdateInput = {
  amount: Scalars['Int'];
  comment: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
  direction: ServiceTransactionDirection;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  serviceId?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Scalars['String']>;
  transactionType: ServiceTransactionType;
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminMemberSubscriptionEdge = {
  __typename?: 'AdminMemberSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscription>;
};

export type AdminMemberSubscriptionResponse = {
  __typename?: 'AdminMemberSubscriptionResponse';
  balance?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  daysLeft?: Maybe<Scalars['Int']>;
  edges?: Maybe<Array<Maybe<AdminMemberSubscriptionEdge>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  membershipUuid?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<PageInfo>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionEndDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMemberSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMemberTierUpdateInput = {
  adjustment: Scalars['Int'];
  award: Scalars['Int'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  purchase: Scalars['Int'];
  versionSlug: Scalars['String'];
};

export type AdminMemberUpdatePasswordInput = {
  memberUuid: Scalars['String'];
  password: Scalars['String'];
};

export type AdminMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMembershipService = {
  __typename?: 'AdminMembershipService';
  amount: Scalars['Int'];
  dateAdded?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  hasExtended?: Maybe<Scalars['Boolean']>;
  orderNo?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  serviceName: Scalars['String'];
  unitType: Scalars['String'];
};

export type AdminMembershipServices = {
  __typename?: 'AdminMembershipServices';
  services?: Maybe<Array<Maybe<AdminMembershipService>>>;
};

export type AdminMembershipServicesArgs = {
  membershipUuid?: InputMaybe<Scalars['String']>;
};

export type AdminMembershipSubscription = {
  __typename?: 'AdminMembershipSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMembershipSubscriptionBasic = {
  __typename?: 'AdminMembershipSubscriptionBasic';
  credit: Scalars['Float'];
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberMainId: Scalars['String'];
  mainMemberName: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  status?: Maybe<SubscriptionStatus>;
};

export type AdminMembershipSubscriptionEdge = {
  __typename?: 'AdminMembershipSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscriptionBasic>;
};

export type AdminMembershipSubscriptionPauseInput = {
  endPauseDate?: InputMaybe<Scalars['DateTime']>;
  membershipUuid: Scalars['String'];
};

export type AdminMembershipSubscriptionPayOutstandingInput = {
  membershipUuid: Scalars['String'];
};

export type AdminMembershipSubscriptionResponse = {
  __typename?: 'AdminMembershipSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminMembershipSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMembershipSubscriptionStartInput = {
  membershipUuid: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AdminMembershipSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMembershipType = {
  __typename?: 'AdminMembershipType';
  baseCountryCode?: Maybe<CountryCode>;
  compDailySimulatorUse?: Maybe<Scalars['Int']>;
  compDailySimulatorUseType?: Maybe<CompDailySimulatorUseType>;
  compFieldLessons?: Maybe<Scalars['Int']>;
  compIndoorLessons?: Maybe<Scalars['Int']>;
  compLocker?: Maybe<Scalars['Boolean']>;
  designatedPrivateRoom?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  initialCredits?: Maybe<Scalars['Int']>;
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  lineItemCode?: Maybe<Scalars['String']>;
  loungeAccess?: Maybe<Scalars['Boolean']>;
  mainTypeSlug?: Maybe<Scalars['String']>;
  monthlySub?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  publicName?: Maybe<Scalars['String']>;
  signupProductSidasInsoles?: Maybe<Scalars['Boolean']>;
  subscriptionlineItemCode?: Maybe<Scalars['String']>;
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  tagBgColorCode?: Maybe<Scalars['String']>;
  tagText?: Maybe<Scalars['String']>;
  tagTextColorCode?: Maybe<Scalars['String']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypeArgs = {
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminMembershipTypeBasic = {
  __typename?: 'AdminMembershipTypeBasic';
  baseCountryCode?: Maybe<CountryCode>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypes = {
  __typename?: 'AdminMembershipTypes';
  lifestyle?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  numberOfTypes?: Maybe<Scalars['Int']>;
  premium?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  vip?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
};

export type AdminMembershipTypesArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminNewMembership = {
  __typename?: 'AdminNewMembership';
  fileUploadCredentials?: Maybe<AdminNewMembershipFileUploadCredentials>;
  memberUuid?: Maybe<Scalars['String']>;
  payment?: Maybe<HitPayPaymentRequest>;
};

export type AdminNewMembershipFileUploadCredentials = {
  __typename?: 'AdminNewMembershipFileUploadCredentials';
  mainMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
  subMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
};

export type AdminNotification = {
  __typename?: 'AdminNotification';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminNotificationArgs = {
  notificationId: Scalars['String'];
};

export type AdminNotificationBasic = {
  __typename?: 'AdminNotificationBasic';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminNotificationCreateInput = {
  expiry: Scalars['Boolean'];
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  mode: NotificationMode;
  title: Scalars['String'];
};

export type AdminNotificationDeleteInput = {
  notificationId: Scalars['String'];
};

export type AdminNotificationEdge = {
  __typename?: 'AdminNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminNotificationBasic>;
};

export type AdminNotificationMemberDeleteInput = {
  memberUuid: Scalars['String'];
  notificationId: Scalars['String'];
};

export type AdminNotificationResponse = {
  __typename?: 'AdminNotificationResponse';
  edges?: Maybe<Array<Maybe<AdminNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  mode: NotificationMode;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminOrganization = {
  __typename?: 'AdminOrganization';
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<BasicClubhouseDetails>>>;
  id: Scalars['String'];
};

export type AdminPaySubscriptionsInput = {
  membershipUuid: Scalars['String'];
};

export type AdminProduct = {
  __typename?: 'AdminProduct';
  baseCountryCode: CountryCode;
  name: Scalars['String'];
};

export type AdminProductBasic = {
  __typename?: 'AdminProductBasic';
  baseCountryCode: CountryCode;
  itemCode: Scalars['String'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  validity?: Maybe<Scalars['String']>;
};

export type AdminProductEdge = {
  __typename?: 'AdminProductEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminProductBasic>;
};

export type AdminProductPackageAddInput = {
  itemCode: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminProductPackageExtension = {
  __typename?: 'AdminProductPackageExtension';
  authorizedAdjusterName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  dateExtended?: Maybe<Scalars['DateTime']>;
  daysAdded?: Maybe<Scalars['Int']>;
  newExpiryDate?: Maybe<Scalars['DateTime']>;
  prevExpiryDate?: Maybe<Scalars['DateTime']>;
};

export type AdminProductPackageExtensions = {
  __typename?: 'AdminProductPackageExtensions';
  extensions?: Maybe<Array<Maybe<AdminProductPackageExtension>>>;
};

export type AdminProductPackageExtensionsArgs = {
  serviceId: Scalars['String'];
};

export type AdminProductPackageManageInput = {
  comment?: InputMaybe<Scalars['String']>;
  days?: InputMaybe<Scalars['Int']>;
  mode: AdminProductPackageManageMode;
  serviceId: Scalars['String'];
};

export enum AdminProductPackageManageMode {
  Extend = 'EXTEND',
  Forfeit = 'FORFEIT'
}

export type AdminProductResponse = {
  __typename?: 'AdminProductResponse';
  edges?: Maybe<Array<Maybe<AdminProductEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  mainCategory?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminReportAcTransaction = {
  __typename?: 'AdminReportAcTransaction';
  account: Scalars['String'];
  amount: Scalars['Float'];
  date: Scalars['DateTime'];
  direction: Scalars['Int'];
  id: Scalars['String'];
  membershipId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type?: Maybe<AcTransactionType>;
};

export type AdminReportAcTransactionEdge = {
  __typename?: 'AdminReportAcTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportAcTransaction>;
};

export type AdminReportAcTransactionResponse = {
  __typename?: 'AdminReportAcTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminReportAcTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportAcTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportCreditTransaction = {
  __typename?: 'AdminReportCreditTransaction';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  member?: Maybe<AdminReportCreditTransactionMember>;
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  type?: Maybe<AceCoinTransactionType>;
};

export type AdminReportCreditTransactionEdge = {
  __typename?: 'AdminReportCreditTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportCreditTransaction>;
};

export type AdminReportCreditTransactionMember = {
  __typename?: 'AdminReportCreditTransactionMember';
  firstName?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminReportCreditTransactionResponse = {
  __typename?: 'AdminReportCreditTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminReportCreditTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportHitPayCharge = {
  __typename?: 'AdminReportHitPayCharge';
  amount?: Maybe<Scalars['String']>;
  buyer_email?: Maybe<Scalars['String']>;
  buyer_name: Scalars['String'];
  buyer_phone?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payment_method?: Maybe<Scalars['String']>;
  payment_type?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  refunded_amount?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type AdminReportHitPayChargeEdge = {
  __typename?: 'AdminReportHitPayChargeEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportHitPayCharge>;
};

export type AdminReportHitPayChargeResponse = {
  __typename?: 'AdminReportHitPayChargeResponse';
  edges?: Maybe<Array<Maybe<AdminReportHitPayChargeEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportHitPayChargesArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportMemberStat = {
  __typename?: 'AdminReportMemberStat';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  stat?: Maybe<Scalars['Float']>;
};

export type AdminReportMemberStatEdge = {
  __typename?: 'AdminReportMemberStatEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportMemberStat>;
};

export type AdminReportMemberStatResponse = {
  __typename?: 'AdminReportMemberStatResponse';
  edges?: Maybe<Array<Maybe<AdminReportMemberStatEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum AdminReportMemberStatType {
  CreditTransactionCount = 'CREDIT_TRANSACTION_COUNT',
  LessonRedemptionCount = 'LESSON_REDEMPTION_COUNT',
  OrderCount = 'ORDER_COUNT',
  SubscriptionCount = 'SUBSCRIPTION_COUNT'
}

export type AdminReportMemberStatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Direction>;
  statType: AdminReportMemberStatType;
};

export type AdminReportOrderArgs = {
  orderNo: Scalars['String'];
};

export type AdminReportOrderEdge = {
  __typename?: 'AdminReportOrderEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OrderBasic>;
};

export type AdminReportOrderPageInfo = {
  __typename?: 'AdminReportOrderPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  noOfNonConnectedOrders?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type AdminReportOrderRecordStatusUpdate = {
  __typename?: 'AdminReportOrderRecordStatusUpdate';
  status?: Maybe<OrderRecordUpdateStatus>;
};

export type AdminReportOrderRecordStatusUpdateInput = {
  orderNo: Scalars['String'];
};

export type AdminReportOrderResponse = {
  __typename?: 'AdminReportOrderResponse';
  edges?: Maybe<Array<Maybe<AdminReportOrderEdge>>>;
  pageInfo?: Maybe<AdminReportOrderPageInfo>;
};

export type AdminReportOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  nonConnectedFilter?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportSubscription = {
  __typename?: 'AdminReportSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminReportSubscriptionEdge = {
  __typename?: 'AdminReportSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportSubscription>;
};

export type AdminReportSubscriptionResponse = {
  __typename?: 'AdminReportSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminReportSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportUpdateOrderConnectionInput = {
  memberUuid?: InputMaybe<Scalars['String']>;
  membershipUuid?: InputMaybe<Scalars['String']>;
  nonMemberCustomer?: InputMaybe<Scalars['Boolean']>;
  orderNo: Scalars['String'];
};

export type AdminResendOnboardingEmailInput = {
  userId: Scalars['String'];
};

export type AdminReservedId = {
  __typename?: 'AdminReservedId';
  id?: Maybe<Scalars['Int']>;
  membershipId?: Maybe<Scalars['String']>;
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  onHoldFor?: Maybe<Scalars['String']>;
  status?: Maybe<ReservedIdStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminReservedIds = {
  __typename?: 'AdminReservedIds';
  idOnHold?: Maybe<Scalars['String']>;
  idOnHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  reservedIds?: Maybe<Array<Maybe<AdminReservedId>>>;
};

export type AdminReservedIdsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminResponse = {
  __typename?: 'AdminResponse';
  edges?: Maybe<Array<Maybe<AdminEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminScoreCard = {
  __typename?: 'AdminScoreCard';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<AdminGameRoundScoreCard>>;
};

export type AdminScoreCardArgs = {
  accessToken: Scalars['String'];
  gameRoundId: Scalars['Int'];
};

export type AdminShopDetails = {
  __typename?: 'AdminShopDetails';
  CDN?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  clientType?: Maybe<AdminShopDetailsClientType>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  isEquipmentStorage?: Maybe<Scalars['Boolean']>;
  isLeftHanded?: Maybe<Scalars['Boolean']>;
  isParking?: Maybe<Scalars['Boolean']>;
  isProLesson?: Maybe<Scalars['Boolean']>;
  isShopCloseNextDay?: Maybe<Scalars['Boolean']>;
  isSwingplate?: Maybe<Scalars['Boolean']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerMobilePhone?: Maybe<Scalars['String']>;
  ownerMobilePhoneCountry?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  shopCloseTime?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  shopOpenTime?: Maybe<Scalars['String']>;
  shopPhone?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminShopDetailsArg = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopDetailsClientType = {
  __typename?: 'AdminShopDetailsClientType';
  lesson?: Maybe<Scalars['Boolean']>;
  practice?: Maybe<Scalars['Boolean']>;
  screen?: Maybe<Scalars['Boolean']>;
};

export type AdminShopGetNotificationInput = {
  accessToken: Scalars['String'];
  notificationId: Scalars['String'];
};

export type AdminShopNotification = {
  __typename?: 'AdminShopNotification';
  message: Scalars['String'];
};

export type AdminShopOptionsDrivingRange = {
  __typename?: 'AdminShopOptionsDrivingRange';
  courseId?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['Int']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  isBallTrajectory?: Maybe<Scalars['Boolean']>;
  isFixedCamera?: Maybe<Scalars['Boolean']>;
  isSwingVideo?: Maybe<Scalars['Boolean']>;
  teeHeight?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsDrivingRangeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRealTime = {
  __typename?: 'AdminShopOptionsRealTime';
  drivingRangeTimeLimit?: Maybe<Scalars['Int']>;
  gameHoleTypeLimit?: Maybe<Scalars['Int']>;
  gameTypeLimit?: Maybe<Scalars['Int']>;
  isContentLimit?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<Scalars['Int']>;
  playerCountLimit?: Maybe<Scalars['Int']>;
  usageTime?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRealTimeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRound = {
  __typename?: 'AdminShopOptionsRound';
  concede?: Maybe<Scalars['Float']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  greenLocation?: Maybe<Scalars['Int']>;
  greenSpeed?: Maybe<Scalars['Int']>;
  holeCupLocation?: Maybe<Scalars['Int']>;
  isBestVideo?: Maybe<Scalars['Boolean']>;
  isCaddyVoice?: Maybe<Scalars['Boolean']>;
  isUseObHazardTee?: Maybe<Scalars['Boolean']>;
  mulliganCount?: Maybe<Scalars['Int']>;
  puttingLine?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRoundArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopSendNotificationInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  message: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopTokensInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminSimulatorUsageArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminStaffBasic = {
  __typename?: 'AdminStaffBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
};

export type AdminStaffEdge = {
  __typename?: 'AdminStaffEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminStaffBasic>;
};

export type AdminStaffResponse = {
  __typename?: 'AdminStaffResponse';
  edges?: Maybe<Array<Maybe<AdminStaffEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminStaffsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export enum AdminStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type AdminTerminateMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminUnlockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  drivingRangeTimeLimit: Scalars['Int'];
  gameHoleTypeLimit: Scalars['String'];
  gameTypeLimit: Scalars['String'];
  isContentLimit: Scalars['Boolean'];
  paymentType: Scalars['String'];
  playerCountLimit: Scalars['String'];
  shopGuid: Scalars['String'];
  usageTime: Scalars['Int'];
};

export type AdminUpdateAdminArgs = {
  userId: Scalars['String'];
};

export type AdminUpdateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
};

export type AdminUpdateClientContentLimitInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  players: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminUpdateCoachArgs = {
  userId: Scalars['String'];
};

export type AdminUpdateCoachBookable = {
  __typename?: 'AdminUpdateCoachBookable';
  isBookable: Scalars['Boolean'];
};

export type AdminUpdateCoachBookableInput = {
  isBookable: Scalars['Boolean'];
};

export type AdminUpdateCoachInput = {
  baseCountryCode?: InputMaybe<CountryCode>;
  coachBirthPlace?: InputMaybe<Scalars['String']>;
  coachBirthdate?: InputMaybe<Scalars['String']>;
  coachExperiences?: InputMaybe<Scalars['JSON']>;
  coachExpertise?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coachLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coachLevel?: InputMaybe<CoachLevel>;
  coachListOrder?: InputMaybe<Scalars['Int']>;
  coachPGANo?: InputMaybe<Scalars['String']>;
  coachPGAType?: InputMaybe<Scalars['String']>;
  coachPGAYear?: InputMaybe<Scalars['String']>;
  coachPublished?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
};

export type AdminUpdateFacilityInput = {
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<FacilityType>;
  id: Scalars['String'];
};

export type AdminUpdateMembershipTypeInput = {
  baseCountryCode?: InputMaybe<CountryCode>;
  compDailySimulatorUse?: InputMaybe<Scalars['Int']>;
  compDailySimulatorUseType?: InputMaybe<CompDailySimulatorUseType>;
  compFieldLessons?: InputMaybe<Scalars['Int']>;
  compIndoorLessons?: InputMaybe<Scalars['Int']>;
  compLocker?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  designatedPrivateRoom?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Int']>;
  imageFile?: InputMaybe<File>;
  initialCredits?: InputMaybe<Scalars['Int']>;
  internalName?: InputMaybe<Scalars['String']>;
  isCorporate?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lineItemCode?: InputMaybe<Scalars['String']>;
  loungeAccess?: InputMaybe<Scalars['Boolean']>;
  mainTypeSlug?: InputMaybe<Scalars['String']>;
  monthlySub?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  publicName?: InputMaybe<Scalars['String']>;
  signupProductSidasInsoles?: InputMaybe<Scalars['Boolean']>;
  subscriptionlineItemCode?: InputMaybe<Scalars['String']>;
  supplementaryTypeSlug?: InputMaybe<Scalars['String']>;
  tagBgColorCode?: InputMaybe<Scalars['String']>;
  tagText?: InputMaybe<Scalars['String']>;
  tagTextColorCode?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<MembershipTypeTier>;
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateNicknameInput = {
  memberUuid: Scalars['String'];
  newNickname: Scalars['String'];
};

export type AdminUpdateOrganizationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AdminUpdatePricingInput = {
  sgBayHourlyRate?: InputMaybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgBayMaxHours?: InputMaybe<Scalars['Int']>;
  sgBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  sgHole9MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgHole18MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgLessonField?: InputMaybe<Scalars['Int']>;
  sgLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoor?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBayHourlyRate?: InputMaybe<Scalars['Int']>;
  viBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viBayMaxHours?: InputMaybe<Scalars['Int']>;
  viBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  viBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  viHole9MaxHours?: InputMaybe<Scalars['Int']>;
  viHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viHole18MaxHours?: InputMaybe<Scalars['Int']>;
  viHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viLessonField?: InputMaybe<Scalars['Int']>;
  viLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoor?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateReservedId = {
  __typename?: 'AdminUpdateReservedId';
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
};

export type AdminUpdateReservedIdInput = {
  hold?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopDetailsInput = {
  CDN?: InputMaybe<Scalars['String']>;
  accessToken?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  introImage?: InputMaybe<Scalars['String']>;
  isParking?: InputMaybe<Scalars['Boolean']>;
  isShopCloseNextDay?: InputMaybe<Scalars['Boolean']>;
  logoImage?: InputMaybe<Scalars['String']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  ownerMobilePhone?: InputMaybe<Scalars['String']>;
  ownerMobilePhoneCountry?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  shopCloseTime?: InputMaybe<Scalars['String']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  shopName?: InputMaybe<Scalars['String']>;
  shopOpenTime?: InputMaybe<Scalars['String']>;
  shopPhone?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopOptionsDrivingRangeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  difficulty?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  isBallTrajectory?: InputMaybe<Scalars['Boolean']>;
  isFixedCamera?: InputMaybe<Scalars['Boolean']>;
  isSwingVideo?: InputMaybe<Scalars['Boolean']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  teeHeight?: InputMaybe<Scalars['Int']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRealTimeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  drivingRangeTimeLimit?: InputMaybe<Scalars['Int']>;
  gameHoleTypeLimit?: InputMaybe<Scalars['Int']>;
  gameTypeLimit?: InputMaybe<Scalars['Int']>;
  isContentLimit?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['Int']>;
  playerCountLimit?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  usageTime?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRoundInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  concede?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  greenLocation?: InputMaybe<Scalars['Int']>;
  greenSpeed?: InputMaybe<Scalars['Int']>;
  holeCupLocation?: InputMaybe<Scalars['Int']>;
  isBestVideo?: InputMaybe<Scalars['Boolean']>;
  isCaddyVoice?: InputMaybe<Scalars['Boolean']>;
  isUseObHazardTee?: InputMaybe<Scalars['Boolean']>;
  mulliganCount?: InputMaybe<Scalars['Int']>;
  puttingLine?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateSidasInsolesInput = {
  memberUuid: Scalars['String'];
  transactionType: AdminUpdateSidasInsolesTransactionType;
};

export enum AdminUpdateSidasInsolesTransactionType {
  Adjustment = 'ADJUSTMENT',
  Complimentary = 'COMPLIMENTARY',
  Redemption = 'REDEMPTION'
}

export type AdminsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdmnUpdateSubscriptionInput = {
  isPaused: Scalars['Boolean'];
  membershipUuid: Scalars['String'];
};

export type AppDineMenu = {
  __typename?: 'AppDineMenu';
  foodUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  wineUri?: Maybe<Scalars['String']>;
};

export type AppDineMenuArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSlider = {
  __typename?: 'AppMainSlider';
  slides: Array<AppMainSliderSlide>;
};

export type AppMainSliderArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSliderSlide = {
  __typename?: 'AppMainSliderSlide';
  id: Scalars['ID'];
  link?: Maybe<AppMainSliderSlideLink>;
  posterTitle?: Maybe<Scalars['String']>;
  posterUri?: Maybe<Scalars['String']>;
  slideUri?: Maybe<Scalars['String']>;
};

export type AppMainSliderSlideLink = {
  __typename?: 'AppMainSliderSlideLink';
  route?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AppManifest = {
  __typename?: 'AppManifest';
  androidUrl: Scalars['String'];
  androidVersion: Scalars['String'];
  bookingVersion: Scalars['String'];
  cancellationConditions: CancellationConditions;
  iosUrl: Scalars['String'];
  iosVersion: Scalars['String'];
  promptMessage: Scalars['String'];
  promptUser: Scalars['Boolean'];
  whatsapp: Scalars['String'];
};

export type AppManifestArgs = {
  temp?: InputMaybe<Scalars['Boolean']>;
};

export enum AppNotificationOperation {
  Account = 'ACCOUNT',
  Acecoins = 'ACECOINS',
  Bookings = 'BOOKINGS',
  CombinedServices = 'COMBINED_SERVICES',
  GameCredit = 'GAME_CREDIT',
  Inbox = 'INBOX',
  LessonVouchers = 'LESSON_VOUCHERS',
  Notification = 'NOTIFICATION',
  Orders = 'ORDERS',
  PractiseCredit = 'PRACTISE_CREDIT',
  Subscriptions = 'SUBSCRIPTIONS'
}

export type AppTelemetry = {
  __typename?: 'AppTelemetry';
  androidVersion?: Maybe<Scalars['String']>;
  iosVersion?: Maybe<Scalars['String']>;
  promptMessage?: Maybe<Scalars['String']>;
  promptUser?: Maybe<Scalars['Boolean']>;
};

export type AppTelemetryInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceManufacturer?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceProductName?: InputMaybe<Scalars['String']>;
  devicePushToken?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  pushNotificationAppEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum ArchivedBy {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export enum AuditLogOutcome {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export type AuthenticatedAdmin = {
  __typename?: 'AuthenticatedAdmin';
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl: Scalars['String'];
  ud?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: Scalars['String'];
  yourIp: Scalars['String'];
};

export type AuthenticatedMember = {
  __typename?: 'AuthenticatedMember';
  id: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type BasicClubhouseDetails = {
  __typename?: 'BasicClubhouseDetails';
  clubhouseCode: Scalars['String'];
  name: Scalars['String'];
};

export type BaySimulator = {
  __typename?: 'BaySimulator';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export enum BookingType {
  Game = 'GAME',
  LessonField = 'LESSON_FIELD',
  LessonIndoor = 'LESSON_INDOOR',
  LessonOutdoor = 'LESSON_OUTDOOR',
  Practise = 'PRACTISE'
}

export type CancellationConditions = {
  __typename?: 'CancellationConditions';
  GAME: Scalars['Int'];
  LESSON_FIELD: Scalars['Int'];
  LESSON_INDOOR: Scalars['Int'];
  LESSON_OUTDOOR: Scalars['Int'];
  PRACTISE: Scalars['Int'];
};

export type CancellationEmailPenaltyLineItem = {
  __typename?: 'CancellationEmailPenaltyLineItem';
  amount: Scalars['String'];
  package?: Maybe<CancellationEmailPenaltyLineItemPackage>;
  type: Scalars['String'];
};

export type CancellationEmailPenaltyLineItemPackage = {
  __typename?: 'CancellationEmailPenaltyLineItemPackage';
  name: Scalars['String'];
  no: Scalars['String'];
};

export enum CancelledBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type ClientStatus = {
  __typename?: 'ClientStatus';
  clients: Scalars['JSON'];
  shopGuid: Scalars['String'];
};

export type ClubhouseOrganization = {
  __typename?: 'ClubhouseOrganization';
  businessName: Scalars['String'];
  id: Scalars['String'];
};

export type ClubhouseOverride = {
  __typename?: 'ClubhouseOverride';
  closureMessage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type Coach = SystemUser & {
  __typename?: 'Coach';
  baseCountryCode?: Maybe<CountryCode>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: AdminOrganization;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type CoachAccountSettings = {
  __typename?: 'CoachAccountSettings';
  baseCountryCode: CountryCode;
  baseGmtOffset: Scalars['Int'];
  myClubhouses?: Maybe<Array<Maybe<CoachClubhouse>>>;
  slug: Scalars['String'];
};

export type CoachAvailabilityCalendarItems = {
  __typename?: 'CoachAvailabilityCalendarItems';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
  hasIndoorBooking?: Maybe<Scalars['Boolean']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  isBlocked?: Maybe<Scalars['Boolean']>;
  isIndoorBookingFull?: Maybe<Scalars['Boolean']>;
};

export type CoachAvailabilityCalendarItemsArgs = {
  currentDate: Scalars['String'];
};

export enum CoachAvailabilityCalendarItemsMode {
  Indoor = 'INDOOR',
  Outdoor = 'OUTDOOR'
}

export type CoachAvailabilityDayItem = {
  __typename?: 'CoachAvailabilityDayItem';
  bi0900?: Maybe<Scalars['String']>;
  bi1000?: Maybe<Scalars['String']>;
  bi1100?: Maybe<Scalars['String']>;
  bi1200?: Maybe<Scalars['String']>;
  bi1300?: Maybe<Scalars['String']>;
  bi1400?: Maybe<Scalars['String']>;
  bi1500?: Maybe<Scalars['String']>;
  bi1600?: Maybe<Scalars['String']>;
  bi1700?: Maybe<Scalars['String']>;
  bi1800?: Maybe<Scalars['String']>;
  bi1900?: Maybe<Scalars['String']>;
  bi2000?: Maybe<Scalars['String']>;
  biOutdoor?: Maybe<Scalars['String']>;
  bs0900?: Maybe<Scalars['String']>;
  bs1000?: Maybe<Scalars['String']>;
  bs1100?: Maybe<Scalars['String']>;
  bs1200?: Maybe<Scalars['String']>;
  bs1300?: Maybe<Scalars['String']>;
  bs1400?: Maybe<Scalars['String']>;
  bs1500?: Maybe<Scalars['String']>;
  bs1600?: Maybe<Scalars['String']>;
  bs1700?: Maybe<Scalars['String']>;
  bs1800?: Maybe<Scalars['String']>;
  bs1900?: Maybe<Scalars['String']>;
  bs2000?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  hasOutdoorBooking?: Maybe<Scalars['Boolean']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
};

export type CoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplate = {
  __typename?: 'CoachAvailabilityDayItemTemplate';
  id: Scalars['String'];
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateArgs = {
  id: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateCreate = {
  __typename?: 'CoachAvailabilityDayItemTemplateCreate';
  id: Scalars['String'];
  status: SystemOperationStatus;
};

export type CoachAvailabilityDayItemTemplateCreateInput = {
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateDeleteInput = {
  id: Scalars['String'];
};

export type CoachAvailabilityDayItemTemplateUpdateInput = {
  id: Scalars['String'];
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CoachAvailabilityDayUpsertInput = {
  coachId?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
};

export type CoachBooking = {
  __typename?: 'CoachBooking';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  cancelledByAdminName?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dateMonthStr?: Maybe<Scalars['String']>;
  dayOfWeekStr?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  durationStr?: Maybe<Scalars['String']>;
  endTime: Scalars['DateTime'];
  endTimeStr?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  startTimeStr?: Maybe<Scalars['String']>;
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
  yearStr?: Maybe<Scalars['String']>;
};

export type CoachBookingArgs = {
  bookingId: Scalars['String'];
};

export type CoachBookingBasic = {
  __typename?: 'CoachBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  member: AdminBookingBasicMember;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
};

export type CoachBookingEdge = {
  __typename?: 'CoachBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachBookingBasic>;
};

export type CoachBookingResponse = {
  __typename?: 'CoachBookingResponse';
  edges?: Maybe<Array<Maybe<CoachBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CoachBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
};

export type CoachClubhouse = {
  __typename?: 'CoachClubhouse';
  clubhouseCode: Scalars['String'];
  displayName: Scalars['String'];
  tagBgColorCode: Scalars['String'];
  tagText: Scalars['String'];
  tagTextColorCode: Scalars['String'];
};

export type CoachExperience = {
  __typename?: 'CoachExperience';
  details?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
};

export enum CoachLevel {
  Pro = 'PRO',
  SemiPro = 'SEMI_PRO'
}

export enum CoachSlotStatus {
  Blocked = 'BLOCKED',
  BookedLessonIndoor = 'BOOKED_LESSON_INDOOR',
  BookedLessonIndoorForced = 'BOOKED_LESSON_INDOOR_FORCED',
  BookedLessonOutdoor = 'BOOKED_LESSON_OUTDOOR',
  BookedLessonOutdoorForced = 'BOOKED_LESSON_OUTDOOR_FORCED'
}

export enum CompDailySimulatorUseType {
  Na = 'NA',
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED'
}

export enum CountryCode {
  Sg = 'SG',
  Vi = 'VI',
  Vn = 'VN'
}

export type CourseMapCoordinate = {
  __typename?: 'CourseMapCoordinate';
  downX?: Maybe<Scalars['Float']>;
  downY?: Maybe<Scalars['Float']>;
  holeNumber?: Maybe<Scalars['Int']>;
  rightX?: Maybe<Scalars['Float']>;
  rightY?: Maybe<Scalars['Float']>;
  worldLeftTopX?: Maybe<Scalars['Float']>;
  worldLeftTopY?: Maybe<Scalars['Float']>;
  worldSizeX?: Maybe<Scalars['Float']>;
  worldSizeY?: Maybe<Scalars['Float']>;
};

export type CreateMemberInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry: Scalars['String'];
  addressPostalCode: Scalars['String'];
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay: Scalars['String'];
  birthdayMonth: Scalars['String'];
  birthdayYear: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  nationality?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
};

export enum CreatedBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  amount: Scalars['Float'];
  authorizedAdjuster?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSpent?: Maybe<Scalars['Boolean']>;
  type?: Maybe<AceCoinTransactionType>;
};

export enum DbServiceEnvType {
  Dev = 'DEV',
  Na = 'NA',
  Prod = 'PROD',
  Test = 'TEST'
}

export type DevEMenuImportOrdersInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type DevEMenuMatchOrders = {
  __typename?: 'DevEMenuMatchOrders';
  numberOfOrdersMatched?: Maybe<Scalars['Int']>;
};

export type DevEMenuMatchOrdersInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevEMenuUpsertCreditTransactionsInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevKGolfCreateAccounts = {
  __typename?: 'DevKGolfCreateAccounts';
  noOfKGolfAccountCreated: Scalars['Int'];
};

export type DevKGolfMemberJoin = {
  __typename?: 'DevKGolfMemberJoin';
  kGolfAccountCreationError: Scalars['Boolean'];
  kGolfPassword: Scalars['String'];
  kGolfUserId: Scalars['String'];
  nickname: Scalars['String'];
};

export type DevManagementSystemAdminNotificationSendInput = {
  devId: Scalars['String'];
  message: Scalars['String'];
  title: Scalars['String'];
};

export type DevManagementSystemAdminViewportReloadRequestInput = {
  userId: Scalars['String'];
};

export type DevManagementSystemServerEnvironments = {
  __typename?: 'DevManagementSystemServerEnvironments';
  environments: Scalars['JSON'];
};

export type DevManagementSystemServerStatus = {
  __typename?: 'DevManagementSystemServerStatus';
  dbService?: Maybe<DevManagementSystemServerStatusDbService>;
};

export type DevManagementSystemServerStatusDbService = {
  __typename?: 'DevManagementSystemServerStatusDbService';
  envType?: Maybe<DbServiceEnvType>;
  url?: Maybe<Scalars['String']>;
};

export type DevManagementSystemUserTelemetry = {
  __typename?: 'DevManagementSystemUserTelemetry';
  eventId: Scalars['String'];
  pageName: Scalars['String'];
  resourceId?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  resourceType?: Maybe<UserTelemetryResourceType>;
  ts: Scalars['String'];
  userId: Scalars['String'];
  userName: Scalars['String'];
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type DevNotificationAppSendInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevUtilityEnvs = {
  __typename?: 'DevUtilityEnvs';
  kGolfEnv: Scalars['JSON'];
};

export enum DeviceType {
  Mobile = 'MOBILE',
  Pc = 'PC',
  Tablet = 'TABLET'
}

export enum Direction {
  Asc = 'asc',
  Desc = 'desc'
}

export enum DurationType {
  Hour = 'HOUR',
  Min = 'MIN'
}

export type EndCoordinates = {
  __typename?: 'EndCoordinates';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type Facility = {
  __typename?: 'Facility';
  clientGuid?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientOrder?: Maybe<Scalars['Int']>;
  facilityCode?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  id?: Maybe<Scalars['String']>;
};

export type FacilityAvailability = {
  __typename?: 'FacilityAvailability';
  clubhouseCode: Scalars['String'];
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export type FacilityAvailabilityCalendarItems = {
  __typename?: 'FacilityAvailabilityCalendarItems';
  date: Scalars['String'];
  isBlocked?: Maybe<Scalars['Boolean']>;
};

export type FacilityBasic = {
  __typename?: 'FacilityBasic';
  facilityCode: Scalars['String'];
  facilityName: Scalars['String'];
  facilityType: FacilityType;
};

export enum FacilitySlotStatus {
  BookedGame = 'BOOKED_GAME',
  BookedLesson = 'BOOKED_LESSON',
  BookedPractise = 'BOOKED_PRACTISE'
}

export enum FacilityType {
  OpenBay = 'OPEN_BAY',
  PrivateRoom = 'PRIVATE_ROOM',
  PuttingGreen = 'PUTTING_GREEN',
  Studio = 'STUDIO'
}

export enum FacilityUsageDuration {
  Hour_1 = 'HOUR_1',
  Hour_2 = 'HOUR_2',
  Hour_3 = 'HOUR_3',
  Hour_4 = 'HOUR_4',
  Hour_5 = 'HOUR_5',
  HourHalf = 'HOUR_HALF'
}

export type File = {
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
};

export type FileUploadCredentials = {
  __typename?: 'FileUploadCredentials';
  fields: Scalars['JSONObject'];
  signedUrl: Scalars['String'];
};

export type FileUploadObject = {
  __typename?: 'FileUploadObject';
  assetUrl: Scalars['String'];
  clientImageFieldName: Scalars['String'];
  fields: Scalars['JSONObject'];
  index: Scalars['Int'];
  signedUrl: Scalars['String'];
};

export type FormHelperBooking = {
  __typename?: 'FormHelperBooking';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperBookingArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type FormHelperNewAdmin = {
  __typename?: 'FormHelperNewAdmin';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperNewAdminArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewBlackOut = {
  __typename?: 'FormHelperNewBlackOut';
  clubhouseCode?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  facilities: Array<Maybe<FacilityBasic>>;
  isCreateAllowed: Scalars['Boolean'];
};

export type FormHelperNewBlackOutArgs = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewCoach = {
  __typename?: 'FormHelperNewCoach';
  countries: Array<Maybe<Scalars['String']>>;
};

export type FormHelperNewCoachArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembership = {
  __typename?: 'FormHelperNewMembership';
  membershipTypes: Array<Maybe<FormHelperNewMembershipMembershipType>>;
};

export type FormHelperNewMembershipArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembershipMembershipType = {
  __typename?: 'FormHelperNewMembershipMembershipType';
  baseCountryCode: CountryCode;
  hasReservedIds?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  internalName: Scalars['String'];
  isCorporate: Scalars['Boolean'];
  price: Scalars['Int'];
  supplementaryTypePrice: Scalars['Int'];
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  versionSlug: Scalars['String'];
};

export type GameBookingConditions = {
  __typename?: 'GameBookingConditions';
  maxDays: Scalars['Int'];
  maxPaxBay: Scalars['Int'];
  maxPaxRoom: Scalars['Int'];
  maxPaxStudio: Scalars['Int'];
  timeLimitMinsPerPax9Hole: Scalars['Int'];
  timeLimitMinsPerPax18Hole: Scalars['Int'];
};

export enum GameCourseType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export type GameRound = {
  __typename?: 'GameRound';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<GameRoundScoreCard>>;
};

export type GameRoundCourseInfo = {
  __typename?: 'GameRoundCourseInfo';
  courseInTotalPar: Scalars['Int'];
  courseOutTotalPar: Scalars['Int'];
  coursePar: Array<Scalars['Int']>;
  courseTotalPar: Scalars['Int'];
  intro: Scalars['String'];
  logo: Scalars['String'];
  newPerioHiddenHole: Scalars['String'];
};

export type GameRoundGameInfo = {
  __typename?: 'GameRoundGameInfo';
  clientGuid: Scalars['String'];
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  concede: Scalars['Int'];
  courseInfo: GameRoundCourseInfo;
  courseName: Scalars['String'];
  distanceUnit: Scalars['String'];
  gameEndTime: Scalars['Int'];
  gameHoleType: Scalars['String'];
  gameRoundId: Scalars['Int'];
  gameStartTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  greenLocation: Scalars['String'];
  greenSpeed: Scalars['String'];
  holeCupLocation: Scalars['String'];
  isBestVideo: Scalars['Boolean'];
  isCaddyVoice: Scalars['Boolean'];
  isUseObHazardTee: Scalars['Boolean'];
  mulliganCount: Scalars['Int'];
  playHoleCount: Scalars['Int'];
  puttingLine: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
  tournamentIdx: Scalars['Int'];
  useSwingPlate: Scalars['String'];
  windSpeed: Scalars['String'];
};

export type GameRoundHoleInfo = {
  __typename?: 'GameRoundHoleInfo';
  holeNumber: Scalars['Int'];
  holeOutType: Scalars['Int'];
  isBestVideo: Scalars['Boolean'];
  isConcede: Scalars['Boolean'];
  isLongest: Scalars['Boolean'];
  isMulligan: Scalars['Boolean'];
  isNearpin: Scalars['Boolean'];
  score: Scalars['Int'];
};

export type GameRoundPlayerInfo = {
  __typename?: 'GameRoundPlayerInfo';
  completeHoleCount: Scalars['Int'];
  difficulty: Scalars['Int'];
  handicap: Scalars['Int'];
  holeInfo: Array<GameRoundHoleInfo>;
  inTotalScore: Scalars['Int'];
  nickname: Scalars['String'];
  outTotalScore: Scalars['Int'];
  playerType: Scalars['Int'];
  rank: Scalars['Int'];
  startHole: Scalars['Int'];
  team: Scalars['Int'];
  totalScore: Scalars['String'];
  userGuid: Scalars['String'];
};

export type GameRoundScoreCard = {
  __typename?: 'GameRoundScoreCard';
  gameInfo: GameRoundGameInfo;
  playerInfo: Array<Maybe<GameRoundPlayerInfo>>;
};

export enum GameType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Undisclosed = 'UNDISCLOSED'
}

export enum Handed {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type HitPayPaymentRequest = {
  __typename?: 'HitPayPaymentRequest';
  checkoutUrl?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
};

export enum IndoorLessonType {
  Field = 'FIELD',
  Normal = 'NORMAL',
  Putting = 'PUTTING'
}

export enum IndoorLocation {
  BaySimulator = 'BAY_SIMULATOR',
  PrivateRoom = 'PRIVATE_ROOM',
  PuttingGreen = 'PUTTING_GREEN'
}

export type KGolfLoginData = {
  __typename?: 'KGolfLoginData';
  access_token?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type KGolfMemberGet = {
  __typename?: 'KGolfMemberGet';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type KGolfMemberJoin = {
  __typename?: 'KGolfMemberJoin';
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfUserId?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type KGolfMemberLogin = {
  __typename?: 'KGolfMemberLogin';
  accessToken?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  ewxpiresIn?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfShopLogin = {
  __typename?: 'KGolfShopLogin';
  accessToken?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
  managerId?: Maybe<Scalars['String']>;
  managerIdx?: Maybe<Scalars['Int']>;
  managerName?: Maybe<Scalars['String']>;
  managerType?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfUpdateMemberInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: InputMaybe<Scalars['Boolean']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  mobilePhoneCountry?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export enum LessonVoucherTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Purchase = 'PURCHASE',
  Redemption = 'REDEMPTION',
  Transfer = 'TRANSFER'
}

export type LineItem = {
  __typename?: 'LineItem';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  eMenuId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  qty: Scalars['Float'];
  salesPrice: Scalars['Float'];
  transactionId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type LineItemInput = {
  __typename?: 'LineItemInput';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  salesPrice: Scalars['Float'];
  vendor?: Maybe<Scalars['String']>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  city?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type ManagementSystem = {
  __typename?: 'ManagementSystem';
  eventId: Scalars['String'];
  operation?: Maybe<ManagementSystemPublishOperation>;
  payload?: Maybe<Scalars['JSON']>;
  ref?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export type ManagementSystemArgs = {
  userId: Scalars['String'];
};

export enum ManagementSystemPublishOperation {
  AdminBookingCreate = 'ADMIN_BOOKING_CREATE',
  AdminBookingUpdate = 'ADMIN_BOOKING_UPDATE',
  AdminMembershipServiceCreate = 'ADMIN_MEMBERSHIP_SERVICE_CREATE',
  AdminMemberCreate = 'ADMIN_MEMBER_CREATE',
  AdminMemberCreditUpdate = 'ADMIN_MEMBER_CREDIT_UPDATE',
  AdminMemberProfileUpdate = 'ADMIN_MEMBER_PROFILE_UPDATE',
  AdminOrganizationUpdate = 'ADMIN_ORGANIZATION_UPDATE',
  CoachAvailabilityDayUpsert = 'COACH_AVAILABILITY_DAY_UPSERT',
  DevAdminNotification = 'DEV_ADMIN_NOTIFICATION',
  DevAdminTelemetryRequest = 'DEV_ADMIN_TELEMETRY_REQUEST',
  DevAdminViewportReloadRequest = 'DEV_ADMIN_VIEWPORT_RELOAD_REQUEST',
  LegacyApiBooingCreate = 'LEGACY_API_BOOING_CREATE',
  MemberBookingCreate = 'MEMBER_BOOKING_CREATE',
  MemberKioskLogin = 'MEMBER_KIOSK_LOGIN',
  PublicApiQuery = 'PUBLIC_API_QUERY',
  Webhook = 'WEBHOOK'
}

export type MemberAccount = {
  __typename?: 'MemberAccount';
  aceCoin: MemberAccountAceCoin;
  benefits: MemberAccountBenefits;
  defaultBaseCountryCode: CountryCode;
  defaultGmtOffset: Scalars['Int'];
  profile: MemberAccountProfile;
  simulator: MemberAccountSimulator;
};

export type MemberAccountAceCoin = {
  __typename?: 'MemberAccountAceCoin';
  balance: Scalars['Float'];
  currentSpent: Scalars['Float'];
};

export type MemberAccountArchiveInput = {
  reason: Scalars['String'];
};

export type MemberAccountBenefits = {
  __typename?: 'MemberAccountBenefits';
  gameCredit: Scalars['Int'];
  lessonVoucherField: Scalars['Int'];
  lessonVoucherIndoor: Scalars['Int'];
  practiseCredit: Scalars['Int'];
  sidasInsoles: Scalars['Int'];
  simulatorHasPrivilege?: Maybe<Scalars['Boolean']>;
  simulatorHasPrivilegeHrs?: Maybe<Scalars['Int']>;
  simulatorUsageConditionMonFri?: Maybe<Scalars['String']>;
  simulatorUsageConditionMonSun?: Maybe<Scalars['String']>;
  simulatorUsageConditionSatSun?: Maybe<Scalars['String']>;
  simulatorUsageDateStr?: Maybe<Scalars['String']>;
  simulatorUsageTimeStr?: Maybe<Scalars['String']>;
};

export type MemberAccountNotificationUpdateInput = {
  isDismissed?: InputMaybe<Scalars['Boolean']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  notificationId: Scalars['String'];
};

export type MemberAccountProfile = {
  __typename?: 'MemberAccountProfile';
  creditToNextLevel: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  memberId: Scalars['String'];
  membershipDisplayName: Scalars['String'];
  mobileNumber: Scalars['String'];
  nextLevelDisplayName: Scalars['String'];
  startDate: Scalars['DateTime'];
  subscription: MemberAccountProfileSubscription;
};

export type MemberAccountProfileSubscription = {
  __typename?: 'MemberAccountProfileSubscription';
  daysLeft: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: SubscriptionStatus;
};

export type MemberAccountServiceTransactionEdge = {
  __typename?: 'MemberAccountServiceTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ServiceTransactionBasic>;
};

export type MemberAccountServiceTransactionResponse = {
  __typename?: 'MemberAccountServiceTransactionResponse';
  edges?: Maybe<Array<Maybe<MemberAccountServiceTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberAccountServiceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberAccountSimulator = {
  __typename?: 'MemberAccountSimulator';
  nickname: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['String'];
};

export type MemberAddFriendInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  loginId: Scalars['String'];
};

export type MemberAddPushTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  pushToken: Scalars['String'];
};

export type MemberApp = {
  __typename?: 'MemberApp';
  eventId?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  operation?: Maybe<MemberAppPublishOperation>;
};

export type MemberAppArgs = {
  memberUuid: Scalars['String'];
};

export enum MemberAppPublishOperation {
  UpdatedAccount = 'UPDATED_ACCOUNT'
}

export type MemberAuditDataInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
};

export enum MemberAuditLogEventName {
  BookingCancel = 'BOOKING_CANCEL',
  BookingCreate = 'BOOKING_CREATE',
  KioskLogin = 'KIOSK_LOGIN',
  Login = 'LOGIN'
}

export type MemberAuditLogSaveDataInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<MemberAuditLogEventName>;
  ipAddress?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
  typeRefId?: InputMaybe<Scalars['String']>;
};

export type MemberAuthResponse = {
  __typename?: 'MemberAuthResponse';
  accessToken: Scalars['String'];
  authenticatedMember: AuthenticatedMember;
  refreshToken: Scalars['String'];
};

export type MemberBooking = {
  __typename?: 'MemberBooking';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  coach?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  description: Scalars['String'];
  durationStr: Scalars['String'];
  endTime: Scalars['DateTime'];
  facilityTypeStr?: Maybe<Scalars['String']>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameTypeStr?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  noOfPlayersStr?: Maybe<Scalars['String']>;
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  textCancellationBody: Scalars['String'];
  textCancellationBodyLocal: Scalars['String'];
  textCancellationHeader: Scalars['String'];
  textCancellationHeaderLocal: Scalars['String'];
  type: BookingType;
  typeStr: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingArgs = {
  bookingId: Scalars['String'];
};

export type MemberBookingBasic = {
  __typename?: 'MemberBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue: Scalars['String'];
};

export type MemberBookingCancelInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  bookingId: Scalars['String'];
};

export type MemberBookingCheckout = {
  __typename?: 'MemberBookingCheckout';
  amountInAceCoins: Scalars['String'];
  amountInCredit: Scalars['String'];
  amountInLocalCurrency?: Maybe<Scalars['String']>;
  balanceBefore: Scalars['String'];
  description: Scalars['String'];
  rateInAceCoins: Scalars['String'];
  rateInLocalCurrency?: Maybe<Scalars['String']>;
  textCancellationBody: Scalars['String'];
  textCancellationBodyLocal: Scalars['String'];
  textCancellationHeader: Scalars['String'];
  textCancellationHeaderLocal: Scalars['String'];
  textConfirm: Scalars['String'];
  textConfirmLocal: Scalars['String'];
  textDoubleBookingBody: Scalars['String'];
  textDoubleBookingBodyLocal: Scalars['String'];
  textDoubleBookingHeader: Scalars['String'];
  textDoubleBookingHeaderLocal: Scalars['String'];
  textRights: Scalars['String'];
  textRightsLocal: Scalars['String'];
};

export type MemberBookingClubhouse = {
  __typename?: 'MemberBookingClubhouse';
  clubhouseCode: Scalars['String'];
  displayName: Scalars['String'];
  hasFacilityBay: Scalars['Boolean'];
  hasFacilityPutting: Scalars['Boolean'];
  hasFacilityRoom: Scalars['Boolean'];
  hasFacilityStudio: Scalars['Boolean'];
  tagBgColorCode: Scalars['String'];
  tagText: Scalars['String'];
  tagTextColorCode: Scalars['String'];
};

export type MemberBookingCoach = {
  __typename?: 'MemberBookingCoach';
  coachId?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type MemberBookingCoachAvailabilityCalendarItems = {
  __typename?: 'MemberBookingCoachAvailabilityCalendarItems';
  calendarItems: Array<Maybe<MemberCoachAvailabilityCalendarItems>>;
};

export type MemberBookingCoachAvailabilityCalendarItemsArgs = {
  coachId: Scalars['String'];
  currentDate: Scalars['String'];
  mode: CoachAvailabilityCalendarItemsMode;
};

export type MemberBookingCoachAvailabilityDayItem = {
  __typename?: 'MemberBookingCoachAvailabilityDayItem';
  clubhouseBgCode: Scalars['String'];
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  date: Scalars['String'];
  dateLong: Scalars['String'];
  time: Scalars['String'];
  timeNum: Scalars['Int'];
  timeStr: Scalars['String'];
  timeStrSpan1hr: Scalars['String'];
  timeStrSpan2hr: Scalars['String'];
  timeStrSpanPutting: Scalars['String'];
};

export type MemberBookingCoachAvailabilityDayItemArgs = {
  dateId: Scalars['String'];
};

export type MemberBookingCoachAvailabilitySlotItem = {
  __typename?: 'MemberBookingCoachAvailabilitySlotItem';
  normalHr1Available: Scalars['Boolean'];
  normalHr2Available: Scalars['Boolean'];
  puttingHr1Available: Scalars['Boolean'];
};

export type MemberBookingCoachAvailabilitySlotItemArgs = {
  clubhouseCode: Scalars['String'];
  dateId: Scalars['String'];
  time: Scalars['String'];
};

export type MemberBookingEdge = {
  __typename?: 'MemberBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberBookingBasic>;
};

export type MemberBookingFacilityAvailabilityCalendarItems = {
  __typename?: 'MemberBookingFacilityAvailabilityCalendarItems';
  calendarItems: Array<Maybe<FacilityAvailabilityCalendarItems>>;
};

export type MemberBookingFacilityAvailabilityCalendarItemsArgs = {
  clubhouseCode: Scalars['String'];
  currentDate: Scalars['String'];
};

export type MemberBookingFacilityAvailabilityDayItem = {
  __typename?: 'MemberBookingFacilityAvailabilityDayItem';
  ampm: Scalars['String'];
  date: Scalars['String'];
  time: Scalars['String'];
  timeNum: Scalars['Int'];
  timeStr: Scalars['String'];
  timeStrSpan: Scalars['String'];
};

export type MemberBookingFacilityAvailabilityDayItemArgs = {
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType?: InputMaybe<GameType>;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingGameCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingGameCreate = {
  __typename?: 'MemberBookingGameCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingGameCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  gameType: GameType;
  noOfPlayers: Scalars['Int'];
  time: Scalars['String'];
};

export type MemberBookingHelper = {
  __typename?: 'MemberBookingHelper';
  clubhouses: Array<Maybe<MemberBookingClubhouse>>;
  gameBookingConditions: GameBookingConditions;
  practiseBookingConditions: PractiseBookingConditions;
};

export type MemberBookingLessonIndoorCheckoutArgs = {
  coachId: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
};

export type MemberBookingLessonIndoorCreate = {
  __typename?: 'MemberBookingLessonIndoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingLessonIndoorCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  isLessonExtended: Scalars['Boolean'];
  lessonType: IndoorLessonType;
  time: Scalars['String'];
};

export type MemberBookingLessonOutdoorCheckoutArgs = {
  coachId: Scalars['String'];
};

export type MemberBookingLessonOutdoorCreate = {
  __typename?: 'MemberBookingLessonOutdoorCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingLessonOutdoorCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  coachSlug: Scalars['String'];
  date: Scalars['String'];
  details: Scalars['String'];
  venue: Scalars['String'];
};

export type MemberBookingPractiseCheckoutArgs = {
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  noOfPlayers: Scalars['Int'];
};

export type MemberBookingPractiseCreate = {
  __typename?: 'MemberBookingPractiseCreate';
  bookingId: Scalars['String'];
  status: SystemOperationStatus;
};

export type MemberBookingPractiseCreateInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clubhouseCode: Scalars['String'];
  date: Scalars['String'];
  duration: FacilityUsageDuration;
  facilityType: FacilityType;
  noOfPlayers: Scalars['Int'];
  time: Scalars['String'];
};

export type MemberBookingResponse = {
  __typename?: 'MemberBookingResponse';
  edges?: Maybe<Array<Maybe<MemberBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
};

export type MemberCoachAvailabilityCalendarItems = {
  __typename?: 'MemberCoachAvailabilityCalendarItems';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
};

export type MemberCreditTransactionEdge = {
  __typename?: 'MemberCreditTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CreditTransaction>;
};

export type MemberCreditTransactionResponse = {
  __typename?: 'MemberCreditTransactionResponse';
  edges?: Maybe<Array<Maybe<MemberCreditTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberDeleteRefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type MemberFindMember = {
  __typename?: 'MemberFindMember';
  memberFound: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
};

export type MemberFindMemberInput = {
  targetMemberCardId: Scalars['String'];
};

export type MemberForgotPassword = {
  __typename?: 'MemberForgotPassword';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type MemberForgotPasswordInput = {
  email: Scalars['String'];
};

export type MemberForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type MemberFriend = {
  __typename?: 'MemberFriend';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type MemberGameQrCodeLoginInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  clientToken?: InputMaybe<Scalars['String']>;
};

export type MemberGameRound = {
  __typename?: 'MemberGameRound';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<MemberGameRoundScoreCard>>;
};

export type MemberGameRoundCourseInfo = {
  __typename?: 'MemberGameRoundCourseInfo';
  courseInTotalPar: Scalars['Int'];
  courseMapCoordinates: Array<Maybe<CourseMapCoordinate>>;
  courseOutTotalPar: Scalars['Int'];
  coursePar: Array<Scalars['Int']>;
  courseTotalPar: Scalars['Int'];
  intro: Scalars['String'];
  logo: Scalars['String'];
  newPerioHiddenHole: Scalars['String'];
};

export type MemberGameRoundGameInfo = {
  __typename?: 'MemberGameRoundGameInfo';
  clientGuid: Scalars['String'];
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  concede: Scalars['Int'];
  courseId?: Maybe<Scalars['String']>;
  courseInfo: MemberGameRoundCourseInfo;
  courseName: Scalars['String'];
  distanceUnit: Scalars['String'];
  gameEndTime: Scalars['Int'];
  gameHoleType: Scalars['String'];
  gameRoundId: Scalars['Int'];
  gameStartTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  greenLocation: Scalars['String'];
  greenSpeed: Scalars['String'];
  holeCupLocation: Scalars['String'];
  isBestVideo: Scalars['Boolean'];
  isCaddyVoice: Scalars['Boolean'];
  isUseObHazardTee: Scalars['Boolean'];
  mulliganCount: Scalars['Int'];
  playHoleCount: Scalars['Int'];
  puttingLine: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
  tournamentIdx: Scalars['Int'];
  useSwingPlate: Scalars['String'];
  windSpeed: Scalars['String'];
};

export type MemberGameRoundPlayerInfo = {
  __typename?: 'MemberGameRoundPlayerInfo';
  completeHoleCount: Scalars['Int'];
  difficulty: Scalars['Int'];
  handicap: Scalars['Int'];
  holes: Array<Maybe<MemberGameRoundPlayerInfoHole>>;
  inTotalScore: Scalars['Int'];
  nickname: Scalars['String'];
  outTotalScore: Scalars['Int'];
  playerType: Scalars['Int'];
  rank: Scalars['Int'];
  startHole: Scalars['Int'];
  team: Scalars['Int'];
  totalScore: Scalars['String'];
  userGuid: Scalars['String'];
};

export type MemberGameRoundPlayerInfoHole = {
  __typename?: 'MemberGameRoundPlayerInfoHole';
  holeNumber: Scalars['Int'];
  holeOutType: Scalars['Int'];
  isBestVideo: Scalars['Boolean'];
  isConcede: Scalars['Boolean'];
  isLongest: Scalars['Boolean'];
  isMulligan: Scalars['Boolean'];
  isNearpin: Scalars['Boolean'];
  score: Scalars['Int'];
  shotCoordinates: Array<Maybe<ShotCoordinate>>;
};

export type MemberGameRoundScoreCard = {
  __typename?: 'MemberGameRoundScoreCard';
  gameRoundInfo: MemberGameRoundGameInfo;
  players: Array<Maybe<MemberGameRoundPlayerInfo>>;
};

export type MemberJwtAccessToken = {
  __typename?: 'MemberJwtAccessToken';
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type MemberJwtRefreshToken = {
  __typename?: 'MemberJwtRefreshToken';
  family?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<MemberJwtRefreshTokenMode>;
  username?: Maybe<Scalars['String']>;
};

export enum MemberJwtRefreshTokenMode {
  Lt = 'LT',
  St = 'ST'
}

export type MemberLoginInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  email: Scalars['String'];
  mode: MemberRefreshTokenMode;
  password: Scalars['String'];
};

export type MemberLogoutInput = {
  refreshToken: Scalars['String'];
};

export type MemberMember = {
  __typename?: 'MemberMember';
  memberName: Scalars['String'];
};

export type MemberMemberArgs = {
  tergetMemberIndividualId?: InputMaybe<Scalars['String']>;
};

export type MemberNotification = {
  __typename?: 'MemberNotification';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRead?: Maybe<Scalars['Boolean']>;
  isReadDate?: Maybe<Scalars['DateTime']>;
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MemberNotificationArgs = {
  notificationId: Scalars['String'];
};

export type MemberNotificationBasic = {
  __typename?: 'MemberNotificationBasic';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminId?: Maybe<Scalars['String']>;
  createdByAdminName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isRead?: Maybe<Scalars['Boolean']>;
  isReadDate?: Maybe<Scalars['DateTime']>;
  message: Scalars['String'];
  mode?: Maybe<NotificationMode>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MemberNotificationDeleteInput = {
  notificationId: Scalars['String'];
};

export type MemberNotificationEdge = {
  __typename?: 'MemberNotificationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberNotificationBasic>;
};

export type MemberNotificationResponse = {
  __typename?: 'MemberNotificationResponse';
  edges?: Maybe<Array<Maybe<MemberNotificationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberOrderArgs = {
  orderNo: Scalars['String'];
};

export type MemberOrderEdge = {
  __typename?: 'MemberOrderEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OrderBasic>;
};

export type MemberOrderResponse = {
  __typename?: 'MemberOrderResponse';
  edges?: Maybe<Array<Maybe<MemberOrderEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type MemberOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type MemberRefreshAccessTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  mode: MemberRefreshTokenMode;
  refreshToken: Scalars['String'];
};

export enum MemberRefreshTokenMode {
  AppWithoutBiometrics = 'APP_WITHOUT_BIOMETRICS',
  AppWithBiometrics = 'APP_WITH_BIOMETRICS',
  Web = 'WEB'
}

export type MemberRemoveFriendInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  friendUuid: Scalars['String'];
};

export type MemberRemovePushTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  pushToken: Scalars['String'];
};

export type MemberScoreCard = {
  __typename?: 'MemberScoreCard';
  completeHoleCount?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['Int']>;
  gameRoundId?: Maybe<Scalars['Int']>;
  gameType?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  isTournament?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  practiceType?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  shopName?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Int']>;
};

export type MemberScoreCardArgs = {
  roundIdx: Scalars['Int'];
};

export type MemberScoreCards = {
  __typename?: 'MemberScoreCards';
  cdn: Scalars['String'];
  list: Array<Maybe<MemberScoreCard>>;
  totalCount: Scalars['Int'];
};

export type MemberScoreCardsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type MemberSimulatorPrivilege = {
  __typename?: 'MemberSimulatorPrivilege';
  hasPrivilege: Scalars['Boolean'];
  lastSimulatorUsageDate?: Maybe<Scalars['DateTime']>;
};

export enum MemberStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export type MemberSubscriptionEdge = {
  __typename?: 'MemberSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MembershipSubscription>;
};

export type MemberSubscriptionResponse = {
  __typename?: 'MemberSubscriptionResponse';
  balance?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  daysLeft?: Maybe<Scalars['Int']>;
  edges?: Maybe<Array<Maybe<MemberSubscriptionEdge>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  membershipUuid?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<PageInfo>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SubscriptionStatus>;
};

export type MemberSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type MemberTopUpCreditInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  creditAmount: Scalars['Float'];
};

export type MemberTransferCreditInput = {
  creditAmount: Scalars['Float'];
  targetMemberCardId: Scalars['String'];
};

export type MemberUpdateEmailInput = {
  email: Scalars['String'];
};

export type MemberUpdateGenderInput = {
  gender: Gender;
};

export type MemberUpdateHandedInput = {
  handed: Handed;
};

export type MemberUpdateMobileNumberInput = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type MemberUpdateNicknameInput = {
  nickname: Scalars['String'];
};

export type MemberUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export enum MembershipStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type MembershipTypeBasic = {
  __typename?: 'MembershipTypeBasic';
  baseCountryCode?: Maybe<CountryCode>;
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  tagBgColorCode?: Maybe<Scalars['String']>;
  tagText?: Maybe<Scalars['String']>;
  tagTextColorCode?: Maybe<Scalars['String']>;
};

export enum MembershipTypeTier {
  Lifestyle = 'LIFESTYLE',
  Premium = 'PREMIUM',
  Vip = 'VIP'
}

export type Mutation = {
  __typename?: 'Mutation';
  adminActivateMembership: AdminActivateMembership;
  adminAdminUpdatePassword: SystemOperationStatus;
  adminBookingBlackoutClubhouseUpdate: AdminBookingBlackoutClubhouse;
  adminBookingBlackoutCoachUpdate: AdminBookingBlackoutCoach;
  adminBookingBlackoutCreate: AdminBookingBlackoutCreate;
  adminBookingBlackoutDelete: SystemOperationStatus;
  adminBookingCancel: SystemOperationStatus;
  adminBookingGameCreate: AdminBookingGameCreate;
  adminBookingLessonIndoorCreate: AdminBookingLessonIndoorCreate;
  adminBookingLessonOutdoorCreate: AdminBookingLessonOutdoorCreate;
  adminBookingPractiseCreate: AdminBookingPractiseCreate;
  adminBookingSendCancellationNotification: SystemOperationStatus;
  adminClientLoginGuest: SystemOperationStatus;
  adminClientSetup: SystemOperationStatus;
  adminCreateAdmin: NewAdmin;
  adminCreateMembership: AdminNewMembership;
  adminDeleteAdmin: SystemOperationStatus;
  adminDeleteCoach: SystemOperationStatus;
  adminDeleteMembership: SystemOperationStatus;
  adminExtendClientTime: SystemOperationStatus;
  adminForgotPassword: AdminForgotPasswordResponse;
  adminForgotPasswordSubmit: SystemOperationStatus;
  adminLockClient: SystemOperationStatus;
  adminLogin: AdminAuthResponse;
  adminLogout: SystemOperationStatus;
  adminManagementSystemUserTelemetry: SystemOperationStatus;
  adminMemberCreateKGolfAccount: SystemOperationStatus;
  adminMemberCreditUpdate: SystemOperationStatus;
  adminMemberProfileUpdate: AdminMemberProfileUpdate;
  adminMemberReassignMembershipId: SystemOperationStatus;
  adminMemberResendOnboardingEmail: SystemOperationStatus;
  adminMemberSendResetPasswordEmail: SystemOperationStatus;
  adminMemberServiceUpdate: SystemOperationStatus;
  adminMemberTierUpdate: AdminMemberProfileUpdate;
  adminMemberUpdatePassword: SystemOperationStatus;
  adminMembershipSubscriptionPause: SystemOperationStatus;
  adminMembershipSubscriptionPayOutstanding: SystemOperationStatus;
  adminMembershipSubscriptionStart: SystemOperationStatus;
  adminNotificationCreate: SystemOperationStatus;
  adminNotificationDelete: SystemOperationStatus;
  adminNotificationMemberDelete: SystemOperationStatus;
  adminPaySubscriptions: SystemOperationStatus;
  adminProductPackageAdd: SystemOperationStatus;
  adminProductPackageManage: SystemOperationStatus;
  adminRefreshAccessToken: AdminAuthResponse;
  adminReportOrderRecordStatusUpdate: AdminReportOrderRecordStatusUpdate;
  adminReportUpdateOrderConnection: SystemOperationStatus;
  adminResendOnboardingEmail: SystemOperationStatus;
  adminShopGetNotification: AdminShopNotification;
  adminShopSendNotification: SystemOperationStatus;
  adminShopTokens: ShopsTokens;
  adminTerminateMembership: SystemOperationStatus;
  adminUnlockClient: SystemOperationStatus;
  adminUpdateAdmin: UpdatedAdmin;
  adminUpdateClientContentLimit: SystemOperationStatus;
  adminUpdateCoach: UpdatedCoach;
  adminUpdateCoachBookable: AdminUpdateCoachBookable;
  adminUpdateFacility: SystemOperationStatus;
  adminUpdateMembershipType: AdminMembershipType;
  adminUpdateNickname: SystemOperationStatus;
  adminUpdateOrganization: Organization;
  adminUpdatePricing: Pricing;
  adminUpdateReservedId: AdminUpdateReservedId;
  adminUpdateShopDetails: AdminShopDetails;
  adminUpdateShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminUpdateShopOptionsRealTime: AdminShopOptionsRealTime;
  adminUpdateShopOptionsRound: AdminShopOptionsRound;
  adminUpdateSidasInsoles: SystemOperationStatus;
  adminUpdateSubscription: SystemOperationStatus;
  appTelemetry: AppTelemetry;
  coachAvailabilityDayItemTemplateCreate: CoachAvailabilityDayItemTemplateCreate;
  coachAvailabilityDayItemTemplateDelete: SystemOperationStatus;
  coachAvailabilityDayItemTemplateUpdate: CoachAvailabilityDayItemTemplate;
  coachAvailabilityDayUpsert?: Maybe<CoachAvailabilityDayItem>;
  devEMenuImportOrders: SystemOperationStatus;
  devEMenuMatchOrders: DevEMenuMatchOrders;
  devEMenuUpsertCreditTransactions: SystemOperationStatus;
  devGraphqlUtilityMutation1: SystemOperationStatus;
  devGraphqlUtilityMutation2: SystemOperationStatus;
  devGraphqlUtilityMutation3: SystemOperationStatus;
  devGraphqlUtilityMutation4: SystemOperationStatus;
  devKGolfCreateAccounts: DevKGolfCreateAccounts;
  devKGolfMemberJoin: DevKGolfMemberJoin;
  devKGolfMemberLogin: KGolfMemberLogin;
  devKGolfShopLogin: KGolfShopLogin;
  devManagementSystemAdminNotificationSend: SystemOperationStatus;
  devManagementSystemAdminTelemetryRequest: SystemOperationStatus;
  devManagementSystemAdminViewportReloadRequest: SystemOperationStatus;
  devManagementSystemServerStatus: DevManagementSystemServerStatus;
  devNotificationAppSend: SystemOperationStatus;
  memberAccountArchive: SystemOperationStatus;
  memberAccountNotificationUpdate: SystemOperationStatus;
  memberAddFriend: SystemOperationStatus;
  memberAddPushToken: SystemOperationStatus;
  memberBookingCancel: SystemOperationStatus;
  memberBookingGameCreate: MemberBookingGameCreate;
  memberBookingLessonIndoorCreate: MemberBookingLessonIndoorCreate;
  memberBookingLessonOutdoorCreate: MemberBookingLessonOutdoorCreate;
  memberBookingPractiseCreate: MemberBookingPractiseCreate;
  memberDeleteRefreshToken: SystemOperationStatus;
  memberFindMember: MemberFindMember;
  memberForgotPassword: MemberForgotPassword;
  memberForgotPasswordSubmit: SystemOperationStatus;
  memberGameQRCodeLogin: SystemOperationStatus;
  memberLogin: MemberAuthResponse;
  memberLogout: SystemOperationStatus;
  memberNotificationDelete: SystemOperationStatus;
  memberRefreshAccessToken: MemberAuthResponse;
  memberRemoveFriend: SystemOperationStatus;
  memberRemovePushToken: SystemOperationStatus;
  memberTopUpCredit: HitPayPaymentRequest;
  memberTransferCredit: SystemOperationStatus;
  memberUpdateEmail: SystemOperationStatus;
  memberUpdateGender: SystemOperationStatus;
  memberUpdateHanded: SystemOperationStatus;
  memberUpdateMobileNumber: SystemOperationStatus;
  memberUpdateNickname: SystemOperationStatus;
  memberUpdatePassword: SystemOperationStatus;
  publicContactForm: SystemOperationStatus;
  publicNewsletter: SystemOperationStatus;
  selfUpdate: SelfUpdated;
  selfUpdatePassword: SystemOperationStatus;
};


export type MutationAdminActivateMembershipArgs = {
  input?: InputMaybe<AdminActivateMembershipInput>;
};


export type MutationAdminAdminUpdatePasswordArgs = {
  input: AdminAdminUpdatePasswordInput;
};


export type MutationAdminBookingBlackoutClubhouseUpdateArgs = {
  input: AdminBookingBlackoutClubhouseUpdateInput;
};


export type MutationAdminBookingBlackoutCoachUpdateArgs = {
  input: AdminBookingBlackoutCoachUpdateInput;
};


export type MutationAdminBookingBlackoutCreateArgs = {
  input: AdminBookingBlackoutCreateInput;
};


export type MutationAdminBookingBlackoutDeleteArgs = {
  input: AdminBookingBlackoutDeleteInput;
};


export type MutationAdminBookingCancelArgs = {
  input: AdminBookingCancelInput;
};


export type MutationAdminBookingGameCreateArgs = {
  input: AdminBookingGameCreateInput;
};


export type MutationAdminBookingLessonIndoorCreateArgs = {
  input: AdminBookingLessonIndoorCreateInput;
};


export type MutationAdminBookingLessonOutdoorCreateArgs = {
  input: AdminBookingLessonOutdoorCreateInput;
};


export type MutationAdminBookingPractiseCreateArgs = {
  input: AdminBookingPractiseCreateInput;
};


export type MutationAdminBookingSendCancellationNotificationArgs = {
  input: AdminBookingSendCancellationNotificationInput;
};


export type MutationAdminClientLoginGuestArgs = {
  input: AdminClientLoginGuestInput;
};


export type MutationAdminClientSetupArgs = {
  input: AdminClientSetupInput;
};


export type MutationAdminCreateAdminArgs = {
  input: AdminCreateAdminInput;
};


export type MutationAdminCreateMembershipArgs = {
  input: AdminCreateMembershipInput;
};


export type MutationAdminDeleteAdminArgs = {
  input?: InputMaybe<AdminDeleteAdminInput>;
};


export type MutationAdminDeleteCoachArgs = {
  input?: InputMaybe<AdminDeleteCoachInput>;
};


export type MutationAdminDeleteMembershipArgs = {
  input: AdminDeleteMembershipInput;
};


export type MutationAdminExtendClientTimeArgs = {
  input: AdminExtendClientTimeInput;
};


export type MutationAdminForgotPasswordArgs = {
  input: AdminForgotPasswordInput;
};


export type MutationAdminForgotPasswordSubmitArgs = {
  input: AdminForgotPasswordSubmitInput;
};


export type MutationAdminLockClientArgs = {
  input: AdminLockClientInput;
};


export type MutationAdminLoginArgs = {
  input: AdminLoginInput;
};


export type MutationAdminManagementSystemUserTelemetryArgs = {
  input: AdminManagementSystemUserTelemetryInput;
};


export type MutationAdminMemberCreateKGolfAccountArgs = {
  input: AdminMemberCreateKGolfAccountInput;
};


export type MutationAdminMemberCreditUpdateArgs = {
  input?: InputMaybe<AdminMemberCreditUpdateInput>;
};


export type MutationAdminMemberProfileUpdateArgs = {
  input: AdminMemberProfileUpdateInput;
};


export type MutationAdminMemberReassignMembershipIdArgs = {
  input: AdminMemberReassignMembershipIdInput;
};


export type MutationAdminMemberResendOnboardingEmailArgs = {
  input: AdminMemberResendOnboardingEmailInput;
};


export type MutationAdminMemberSendResetPasswordEmailArgs = {
  input: AdminMemberSendResetPasswordEmailInput;
};


export type MutationAdminMemberServiceUpdateArgs = {
  input: AdminMemberServiceUpdateInput;
};


export type MutationAdminMemberTierUpdateArgs = {
  input: AdminMemberTierUpdateInput;
};


export type MutationAdminMemberUpdatePasswordArgs = {
  input: AdminMemberUpdatePasswordInput;
};


export type MutationAdminMembershipSubscriptionPauseArgs = {
  input: AdminMembershipSubscriptionPauseInput;
};


export type MutationAdminMembershipSubscriptionPayOutstandingArgs = {
  input: AdminMembershipSubscriptionPayOutstandingInput;
};


export type MutationAdminMembershipSubscriptionStartArgs = {
  input: AdminMembershipSubscriptionStartInput;
};


export type MutationAdminNotificationCreateArgs = {
  input: AdminNotificationCreateInput;
};


export type MutationAdminNotificationDeleteArgs = {
  input: AdminNotificationDeleteInput;
};


export type MutationAdminNotificationMemberDeleteArgs = {
  input: AdminNotificationMemberDeleteInput;
};


export type MutationAdminPaySubscriptionsArgs = {
  input: AdminPaySubscriptionsInput;
};


export type MutationAdminProductPackageAddArgs = {
  input: AdminProductPackageAddInput;
};


export type MutationAdminProductPackageManageArgs = {
  input: AdminProductPackageManageInput;
};


export type MutationAdminReportOrderRecordStatusUpdateArgs = {
  input: AdminReportOrderRecordStatusUpdateInput;
};


export type MutationAdminReportUpdateOrderConnectionArgs = {
  input: AdminReportUpdateOrderConnectionInput;
};


export type MutationAdminResendOnboardingEmailArgs = {
  input: AdminResendOnboardingEmailInput;
};


export type MutationAdminShopGetNotificationArgs = {
  input: AdminShopGetNotificationInput;
};


export type MutationAdminShopSendNotificationArgs = {
  input: AdminShopSendNotificationInput;
};


export type MutationAdminShopTokensArgs = {
  input?: InputMaybe<AdminShopTokensInput>;
};


export type MutationAdminTerminateMembershipArgs = {
  input: AdminTerminateMembershipInput;
};


export type MutationAdminUnlockClientArgs = {
  input: AdminUnlockClientInput;
};


export type MutationAdminUpdateAdminArgs = {
  args: AdminUpdateAdminArgs;
  input: AdminUpdateAdminInput;
};


export type MutationAdminUpdateClientContentLimitArgs = {
  input: AdminUpdateClientContentLimitInput;
};


export type MutationAdminUpdateCoachArgs = {
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachInput;
};


export type MutationAdminUpdateCoachBookableArgs = {
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachBookableInput;
};


export type MutationAdminUpdateFacilityArgs = {
  input: AdminUpdateFacilityInput;
};


export type MutationAdminUpdateMembershipTypeArgs = {
  input: AdminUpdateMembershipTypeInput;
};


export type MutationAdminUpdateNicknameArgs = {
  input: AdminUpdateNicknameInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};


export type MutationAdminUpdatePricingArgs = {
  input: AdminUpdatePricingInput;
};


export type MutationAdminUpdateReservedIdArgs = {
  input?: InputMaybe<AdminUpdateReservedIdInput>;
};


export type MutationAdminUpdateShopDetailsArgs = {
  input: AdminUpdateShopDetailsInput;
};


export type MutationAdminUpdateShopOptionsDrivingRangeArgs = {
  input: AdminUpdateShopOptionsDrivingRangeInput;
};


export type MutationAdminUpdateShopOptionsRealTimeArgs = {
  input: AdminUpdateShopOptionsRealTimeInput;
};


export type MutationAdminUpdateShopOptionsRoundArgs = {
  input: AdminUpdateShopOptionsRoundInput;
};


export type MutationAdminUpdateSidasInsolesArgs = {
  input: AdminUpdateSidasInsolesInput;
};


export type MutationAdminUpdateSubscriptionArgs = {
  input: AdmnUpdateSubscriptionInput;
};


export type MutationAppTelemetryArgs = {
  input: AppTelemetryInput;
};


export type MutationCoachAvailabilityDayItemTemplateCreateArgs = {
  input: CoachAvailabilityDayItemTemplateCreateInput;
};


export type MutationCoachAvailabilityDayItemTemplateDeleteArgs = {
  input: CoachAvailabilityDayItemTemplateDeleteInput;
};


export type MutationCoachAvailabilityDayItemTemplateUpdateArgs = {
  input: CoachAvailabilityDayItemTemplateUpdateInput;
};


export type MutationCoachAvailabilityDayUpsertArgs = {
  input: CoachAvailabilityDayUpsertInput;
};


export type MutationDevEMenuImportOrdersArgs = {
  input: DevEMenuImportOrdersInput;
};


export type MutationDevEMenuMatchOrdersArgs = {
  input: DevEMenuMatchOrdersInput;
};


export type MutationDevEMenuUpsertCreditTransactionsArgs = {
  input?: InputMaybe<DevEMenuUpsertCreditTransactionsInput>;
};


export type MutationDevManagementSystemAdminNotificationSendArgs = {
  input: DevManagementSystemAdminNotificationSendInput;
};


export type MutationDevManagementSystemAdminViewportReloadRequestArgs = {
  input: DevManagementSystemAdminViewportReloadRequestInput;
};


export type MutationDevNotificationAppSendArgs = {
  input: DevNotificationAppSendInput;
};


export type MutationMemberAccountArchiveArgs = {
  input: MemberAccountArchiveInput;
};


export type MutationMemberAccountNotificationUpdateArgs = {
  input: MemberAccountNotificationUpdateInput;
};


export type MutationMemberAddFriendArgs = {
  input: MemberAddFriendInput;
};


export type MutationMemberAddPushTokenArgs = {
  input: MemberAddPushTokenInput;
};


export type MutationMemberBookingCancelArgs = {
  input: MemberBookingCancelInput;
};


export type MutationMemberBookingGameCreateArgs = {
  input: MemberBookingGameCreateInput;
};


export type MutationMemberBookingLessonIndoorCreateArgs = {
  input: MemberBookingLessonIndoorCreateInput;
};


export type MutationMemberBookingLessonOutdoorCreateArgs = {
  input: MemberBookingLessonOutdoorCreateInput;
};


export type MutationMemberBookingPractiseCreateArgs = {
  input: MemberBookingPractiseCreateInput;
};


export type MutationMemberDeleteRefreshTokenArgs = {
  input: MemberDeleteRefreshTokenInput;
};


export type MutationMemberFindMemberArgs = {
  input?: InputMaybe<MemberFindMemberInput>;
};


export type MutationMemberForgotPasswordArgs = {
  input: MemberForgotPasswordInput;
};


export type MutationMemberForgotPasswordSubmitArgs = {
  input: MemberForgotPasswordSubmitInput;
};


export type MutationMemberGameQrCodeLoginArgs = {
  input: MemberGameQrCodeLoginInput;
};


export type MutationMemberLoginArgs = {
  input: MemberLoginInput;
};


export type MutationMemberLogoutArgs = {
  input: MemberLogoutInput;
};


export type MutationMemberNotificationDeleteArgs = {
  input: MemberNotificationDeleteInput;
};


export type MutationMemberRefreshAccessTokenArgs = {
  input: MemberRefreshAccessTokenInput;
};


export type MutationMemberRemoveFriendArgs = {
  input: MemberRemoveFriendInput;
};


export type MutationMemberRemovePushTokenArgs = {
  input: MemberRemovePushTokenInput;
};


export type MutationMemberTopUpCreditArgs = {
  input: MemberTopUpCreditInput;
};


export type MutationMemberTransferCreditArgs = {
  input: MemberTransferCreditInput;
};


export type MutationMemberUpdateEmailArgs = {
  input: MemberUpdateEmailInput;
};


export type MutationMemberUpdateGenderArgs = {
  input: MemberUpdateGenderInput;
};


export type MutationMemberUpdateHandedArgs = {
  input: MemberUpdateHandedInput;
};


export type MutationMemberUpdateMobileNumberArgs = {
  input: MemberUpdateMobileNumberInput;
};


export type MutationMemberUpdateNicknameArgs = {
  input: MemberUpdateNicknameInput;
};


export type MutationMemberUpdatePasswordArgs = {
  input: MemberUpdatePasswordInput;
};


export type MutationPublicContactFormArgs = {
  input: PublicContactFormInput;
};


export type MutationPublicNewsletterArgs = {
  input: PublicNewsletterInput;
};


export type MutationSelfUpdateArgs = {
  input: SelfUpdateInput;
};


export type MutationSelfUpdatePasswordArgs = {
  input: SelfUpdatePasswordInput;
};

export type NewAdmin = {
  __typename?: 'NewAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type NewCoach = {
  __typename?: 'NewCoach';
  coach: Coach;
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
};

export type NonPuttingFacilityDayItem = {
  __typename?: 'NonPuttingFacilityDayItem';
  na0900?: Maybe<Scalars['Boolean']>;
  na1000?: Maybe<Scalars['Boolean']>;
  na1100?: Maybe<Scalars['Boolean']>;
  na1200?: Maybe<Scalars['Boolean']>;
  na1300?: Maybe<Scalars['Boolean']>;
  na1400?: Maybe<Scalars['Boolean']>;
  na1500?: Maybe<Scalars['Boolean']>;
  na1600?: Maybe<Scalars['Boolean']>;
  na1700?: Maybe<Scalars['Boolean']>;
  na1800?: Maybe<Scalars['Boolean']>;
  na1900?: Maybe<Scalars['Boolean']>;
  na2000?: Maybe<Scalars['Boolean']>;
};

export enum NotificationMode {
  Broadcast = 'BROADCAST',
  Single = 'SINGLE'
}

export enum OperationActorType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type Order = {
  __typename?: 'Order';
  additionalDiscount?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  discountPercent?: Maybe<Scalars['Float']>;
  eMenuCustomerName?: Maybe<Scalars['String']>;
  eMenuMemberCardNo?: Maybe<Scalars['String']>;
  gst?: Maybe<Scalars['Float']>;
  isEMenuOrder?: Maybe<Scalars['Boolean']>;
  lineItems: Array<Maybe<LineItem>>;
  memberDiscount?: Maybe<Scalars['Float']>;
  memberId?: Maybe<Scalars['String']>;
  memberIndividualId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  nonMemberCustomer?: Maybe<Scalars['Boolean']>;
  orderNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: Scalars['String'];
  serviceCharge?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  venue?: Maybe<Scalars['String']>;
};

export type OrderBasic = {
  __typename?: 'OrderBasic';
  date: Scalars['DateTime'];
  eMenuCustomerName?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  nonMemberCustomer: Scalars['Boolean'];
  orderNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: Scalars['String'];
  status: PaymentStatus;
  subTotal: Scalars['Float'];
  total: Scalars['Float'];
  venue?: Maybe<Scalars['String']>;
};

export type OrderBy = {
  direction?: InputMaybe<Direction>;
  field?: InputMaybe<Scalars['String']>;
};

export enum OrderMetadaProvider {
  Emenu = 'EMENU'
}

export type OrderMetadata = {
  __typename?: 'OrderMetadata';
  eMenuCustomerName?: Maybe<Scalars['String']>;
  eMenuMemberCardNo?: Maybe<Scalars['String']>;
  provider?: Maybe<OrderMetadaProvider>;
};

export enum OrderRecordUpdateStatus {
  Archived = 'ARCHIVED',
  Resynced = 'RESYNCED'
}

export type Organization = {
  __typename?: 'Organization';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  clubhouses?: Maybe<Array<Maybe<AdminClubhouse>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationNumber?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Admin>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export enum PaymentCode {
  CreditTopUp = 'CREDIT_TOP_UP',
  SignUp = 'SIGN_UP'
}

export enum PaymentCurrency {
  Sgd = 'SGD',
  Usd = 'USD',
  Vnd = 'VND'
}

export enum PaymentMethod {
  Acecoins = 'ACECOINS',
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Emenu = 'EMENU',
  Hitpay = 'HITPAY',
  Nets = 'NETS',
  Nil = 'NIL',
  Paynow = 'PAYNOW',
  Paypal = 'PAYPAL',
  Voucher = 'VOUCHER'
}

export enum PaymentMode {
  BankTransfer = 'BANK_TRANSFER',
  Emenu = 'EMENU',
  Hitpay = 'HITPAY',
  Nil = 'NIL'
}

export enum PaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PractiseBookingConditions = {
  __typename?: 'PractiseBookingConditions';
  maxDays: Scalars['Int'];
  maxHrsBay: Scalars['Int'];
  maxHrsRoom: Scalars['Int'];
  maxMinsPutting: Scalars['Int'];
  maxPaxBay: Scalars['Int'];
  maxPaxPutting: Scalars['Int'];
  maxPaxRoom: Scalars['Int'];
};

export type Pricing = {
  __typename?: 'Pricing';
  sgBayHourlyRate?: Maybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgBayMaxHours?: Maybe<Scalars['Int']>;
  sgBayMaxPlayers?: Maybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  sgHole9MaxHours?: Maybe<Scalars['Int']>;
  sgHole9MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgHole18MaxHours?: Maybe<Scalars['Int']>;
  sgHole18MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgLessonField?: Maybe<Scalars['Int']>;
  sgLessonFieldVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoor?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoorVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
  viBayHourlyRate?: Maybe<Scalars['Int']>;
  viBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  viBayMaxHours?: Maybe<Scalars['Int']>;
  viBayMaxPlayers?: Maybe<Scalars['Int']>;
  viBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  viBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  viHole9MaxHours?: Maybe<Scalars['Int']>;
  viHole9MaxPlayers?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viHole18MaxHours?: Maybe<Scalars['Int']>;
  viHole18MaxPlayers?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viLessonField?: Maybe<Scalars['Int']>;
  viLessonFieldVIP?: Maybe<Scalars['Int']>;
  viLessonIndoor?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  viLessonIndoorVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
};

export type PrivateRoom = {
  __typename?: 'PrivateRoom';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PublicClubhouseArgs = {
  countryCode: CountryCode;
};

export type PublicCoach = {
  __typename?: 'PublicCoach';
  baseCountryCode?: Maybe<CountryCode>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLessonField?: Maybe<Scalars['Int']>;
  coachLessonFieldVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoor?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoorVIP?: Maybe<Scalars['Int']>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PublicContactFormInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PublicMembership = {
  __typename?: 'PublicMembership';
  exampleField?: Maybe<Scalars['Int']>;
};

export type PublicNewsletterInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export enum PublishMode {
  Broadcast = 'BROADCAST',
  Single = 'SINGLE'
}

export type PuttingFacilityDayItem = {
  __typename?: 'PuttingFacilityDayItem';
  na0900?: Maybe<Scalars['Boolean']>;
  na0930?: Maybe<Scalars['Boolean']>;
  na1000?: Maybe<Scalars['Boolean']>;
  na1030?: Maybe<Scalars['Boolean']>;
  na1100?: Maybe<Scalars['Boolean']>;
  na1130?: Maybe<Scalars['Boolean']>;
  na1200?: Maybe<Scalars['Boolean']>;
  na1230?: Maybe<Scalars['Boolean']>;
  na1300?: Maybe<Scalars['Boolean']>;
  na1330?: Maybe<Scalars['Boolean']>;
  na1400?: Maybe<Scalars['Boolean']>;
  na1430?: Maybe<Scalars['Boolean']>;
  na1500?: Maybe<Scalars['Boolean']>;
  na1530?: Maybe<Scalars['Boolean']>;
  na1600?: Maybe<Scalars['Boolean']>;
  na1630?: Maybe<Scalars['Boolean']>;
  na1700?: Maybe<Scalars['Boolean']>;
  na1730?: Maybe<Scalars['Boolean']>;
  na1800?: Maybe<Scalars['Boolean']>;
  na1830?: Maybe<Scalars['Boolean']>;
  na1900?: Maybe<Scalars['Boolean']>;
  na1930?: Maybe<Scalars['Boolean']>;
  na2000?: Maybe<Scalars['Boolean']>;
  na2030?: Maybe<Scalars['Boolean']>;
};

export type PuttingGreen = {
  __typename?: 'PuttingGreen';
  blockedFromBooking: Scalars['Boolean'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  admin?: Maybe<Admin>;
  adminBooking?: Maybe<AdminBooking>;
  adminBookingAvailability: Scalars['String'];
  adminBookingBlackoutClubhouse: AdminBookingBlackoutClubhouse;
  adminBookingBlackoutCoach: AdminBookingBlackoutCoach;
  adminBookingBlackouts: Array<Maybe<AdminBookingBlackoutBasic>>;
  adminBookingCoachAvailabilityCalendarItems?: Maybe<AdminBookingCoachAvailabilityCalendarItems>;
  adminBookingCoachAvailabilityDayItem?: Maybe<AdminBookingCoachAvailabilityDayItem>;
  adminBookingCoachAvailabilitySlotItem?: Maybe<AdminBookingCoachAvailabilitySlotItem>;
  adminBookingCoaches: Array<Maybe<AdminBookingCoach>>;
  adminBookingCombinedCoachAvailabilityDayItem?: Maybe<AdminBookingCombinedCoachAvailabilityDayItem>;
  adminBookingFacilityAvailabilityCalendarItems?: Maybe<AdminBookingFacilityAvailabilityCalendarItems>;
  adminBookingFacilityAvailabilityDayItem?: Maybe<AdminBookingFacilityAvailabilityDayItem>;
  adminBookingFacilityAvailabilitySlotItem?: Maybe<AdminBookingFacilityAvailabilitySlotItem>;
  adminBookingGameCheckout: AdminBookingCheckout;
  adminBookingLessonIndoorCheckout: AdminBookingCheckout;
  adminBookingLessonOutdoorCheckout: AdminBookingCheckout;
  adminBookingPractiseCheckout: AdminBookingCheckout;
  adminBookingSettings: AdminBookingSettings;
  adminBookings: AdminBookingResponse;
  adminClientStatus: ClientStatus;
  adminClubhouse: AdminClubhouse;
  adminClubhouseFacilities: Array<Facility>;
  adminClubhouseFacilityAvailability: AdminClubhouseFacilityAvailability;
  adminClubhouses: AdminClubhouseResponse;
  adminCoach: AdminCoach;
  adminCoachAvailabilityCalendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  adminCoachCombinedAvailability: Array<Maybe<AdminCoachCombinedAvailability>>;
  adminCoaches: AdminCoachResponse;
  adminCreditTransactions: AdminCreditTransactionResponse;
  adminGameHistory: AdminGameHistory;
  adminKGolfMember: AdminKGolfMember;
  adminManagementSystemProps: AdminManagementSystemProps;
  adminMember: AdminMember;
  adminMemberNotifications: AdminMemberNotificationResponse;
  adminMemberServiceTransactions: AdminMemberServiceTransactionResponse;
  adminMemberSubscriptions: AdminMemberSubscriptionResponse;
  adminMembers: AdminMemberResponse;
  adminMembershipServices?: Maybe<AdminMembershipServices>;
  adminMembershipSubscriptions: AdminMembershipSubscriptionResponse;
  adminMembershipType: AdminMembershipType;
  adminMembershipTypes: AdminMembershipTypes;
  adminNotification: AdminNotification;
  adminNotifications: AdminNotificationResponse;
  adminProductPackageExtensions: AdminProductPackageExtensions;
  adminProducts: AdminProductResponse;
  adminReportAcTransactions: AdminReportAcTransactionResponse;
  adminReportCreditTransactions: AdminReportCreditTransactionResponse;
  adminReportHitPayCharges: AdminReportHitPayChargeResponse;
  adminReportMemberStats: AdminReportMemberStatResponse;
  adminReportOrder: Order;
  adminReportOrders: AdminReportOrderResponse;
  adminReportSubscriptions: AdminReportSubscriptionResponse;
  adminReservedIds?: Maybe<AdminReservedIds>;
  adminScoreCard?: Maybe<Scalars['JSON']>;
  adminShopDetails?: Maybe<AdminShopDetails>;
  adminShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminShopOptionsRealTime: AdminShopOptionsRealTime;
  adminShopOptionsRound: AdminShopOptionsRound;
  adminSimulatorUsage?: Maybe<Scalars['JSON']>;
  adminStaffs: AdminStaffResponse;
  admins: AdminResponse;
  appDineMenu?: Maybe<AppDineMenu>;
  appMainSlider?: Maybe<AppMainSlider>;
  appManifest: AppManifest;
  coachAccountSettings: CoachAccountSettings;
  coachAvailabilityCalendarItems: Array<Maybe<CoachAvailabilityCalendarItems>>;
  coachAvailabilityDayItem?: Maybe<CoachAvailabilityDayItem>;
  coachAvailabilityDayItemTemplate: CoachAvailabilityDayItemTemplate;
  coachAvailabilityDayItemTemplates: Array<Maybe<CoachAvailabilityDayItemTemplate>>;
  coachBooking?: Maybe<CoachBooking>;
  coachBookings: CoachBookingResponse;
  devGraphqlUtilityQuery1: Scalars['JSON'];
  devGraphqlUtilityQuery2: Scalars['JSON'];
  devGraphqlUtilityQuery3: Scalars['JSON'];
  devGraphqlUtilityQuery4: Scalars['JSON'];
  devKGolfMemberGet: KGolfMemberGet;
  devManagementSystemServerEnvironments: DevManagementSystemServerEnvironments;
  formHelperBooking?: Maybe<FormHelperBooking>;
  formHelperNewAdmin?: Maybe<FormHelperNewAdmin>;
  formHelperNewBlackOut?: Maybe<FormHelperNewBlackOut>;
  formHelperNewCoach?: Maybe<FormHelperNewCoach>;
  formHelperNewMembership?: Maybe<FormHelperNewMembership>;
  memberAccount: MemberAccount;
  memberAccountServiceTransactions: MemberAccountServiceTransactionResponse;
  memberBooking: MemberBooking;
  memberBookingCoachAvailabilityCalendarItems?: Maybe<MemberBookingCoachAvailabilityCalendarItems>;
  memberBookingCoachAvailabilityDayItem: Array<Maybe<MemberBookingCoachAvailabilityDayItem>>;
  memberBookingCoachAvailabilitySlotItem: MemberBookingCoachAvailabilitySlotItem;
  memberBookingCoaches: Array<Maybe<MemberBookingCoach>>;
  memberBookingFacilityAvailabilityCalendarItems?: Maybe<MemberBookingFacilityAvailabilityCalendarItems>;
  memberBookingFacilityAvailabilityDayItem: Array<Maybe<MemberBookingFacilityAvailabilityDayItem>>;
  memberBookingGameCheckout: MemberBookingCheckout;
  memberBookingHelper: MemberBookingHelper;
  memberBookingLessonIndoorCheckout: MemberBookingCheckout;
  memberBookingLessonOutdoorCheckout: MemberBookingCheckout;
  memberBookingPractiseCheckout: MemberBookingCheckout;
  memberBookings: MemberBookingResponse;
  memberCreditTransactions: MemberCreditTransactionResponse;
  memberFriends: Array<Maybe<MemberFriend>>;
  memberMember: MemberMember;
  memberNotification: MemberNotification;
  memberNotifications: MemberNotificationResponse;
  memberOrder: Order;
  memberOrders: MemberOrderResponse;
  memberScoreCard: Scalars['JSON'];
  memberScoreCards: Scalars['JSON'];
  memberSimulatorPrivilege: MemberSimulatorPrivilege;
  memberSubscriptions: MemberSubscriptionResponse;
  organization?: Maybe<Organization>;
  pricing?: Maybe<Pricing>;
  publicClubhouse?: Maybe<Scalars['JSON']>;
  publicCoaches?: Maybe<Array<Maybe<PublicCoach>>>;
  publicMembership: Array<Maybe<PublicMembership>>;
  publicUtilityIpAddress: Scalars['String'];
  self?: Maybe<Self>;
};


export type QueryAdminArgs = {
  args: AdminArgs;
};


export type QueryAdminBookingArgs = {
  args: AdminBookingArgs;
};


export type QueryAdminBookingAvailabilityArgs = {
  args: AdminBookingAvailabilityArgs;
};


export type QueryAdminBookingBlackoutClubhouseArgs = {
  args: AdminBookingBlackoutClubhouseArgs;
};


export type QueryAdminBookingBlackoutCoachArgs = {
  args: AdminBookingBlackoutCoachArgs;
};


export type QueryAdminBookingBlackoutsArgs = {
  args: AdminBookingBlackoutsArgs;
};


export type QueryAdminBookingCoachAvailabilityCalendarItemsArgs = {
  args: AdminBookingCoachAvailabilityCalendarItemsArgs;
};


export type QueryAdminBookingCoachAvailabilityDayItemArgs = {
  args: AdminBookingCoachAvailabilityDayItemArgs;
};


export type QueryAdminBookingCoachAvailabilitySlotItemArgs = {
  args: AdminBookingCoachAvailabilitySlotItemArgs;
};


export type QueryAdminBookingCombinedCoachAvailabilityDayItemArgs = {
  args: AdminBookingCombinedCoachAvailabilityDayItemArgs;
};


export type QueryAdminBookingFacilityAvailabilityCalendarItemsArgs = {
  args: AdminBookingFacilityAvailabilityCalendarItemsArgs;
};


export type QueryAdminBookingFacilityAvailabilityDayItemArgs = {
  args: AdminBookingFacilityAvailabilityDayItemArgs;
};


export type QueryAdminBookingFacilityAvailabilitySlotItemArgs = {
  args: AdminBookingFacilityAvailabilitySlotItemArgs;
};


export type QueryAdminBookingGameCheckoutArgs = {
  args: AdminBookingGameCheckoutArgs;
};


export type QueryAdminBookingLessonIndoorCheckoutArgs = {
  args: AdminBookingLessonIndoorCheckoutArgs;
};


export type QueryAdminBookingLessonOutdoorCheckoutArgs = {
  args: AdminBookingLessonOutdoorCheckoutArgs;
};


export type QueryAdminBookingPractiseCheckoutArgs = {
  args: AdminBookingPractiseCheckoutArgs;
};


export type QueryAdminBookingSettingsArgs = {
  args: AdminBookingSettingsArgs;
};


export type QueryAdminBookingsArgs = {
  args: AdminBookingsArgs;
};


export type QueryAdminClientStatusArgs = {
  args: AdminClientStatusArgs;
};


export type QueryAdminClubhouseArgs = {
  args: AdminClubhouseArgs;
};


export type QueryAdminClubhouseFacilitiesArgs = {
  args: AdminClubhouseFacilitiesArgs;
};


export type QueryAdminClubhouseFacilityAvailabilityArgs = {
  args: AdminClubhouseFacilityAvailabilityArgs;
};


export type QueryAdminClubhousesArgs = {
  args: AdminClubhousesArgs;
};


export type QueryAdminCoachArgs = {
  args: AdminCoachArgs;
};


export type QueryAdminCoachAvailabilityCalendarItemsArgs = {
  args?: InputMaybe<AdminCoachAvailabilityCalendarItemsArgs>;
};


export type QueryAdminCoachCombinedAvailabilityArgs = {
  args: AdminCoachCombinedAvailabilityArgs;
};


export type QueryAdminCoachesArgs = {
  args?: InputMaybe<AdminCoachesArgs>;
};


export type QueryAdminCreditTransactionsArgs = {
  args: AdminCreditTransactionsArgs;
};


export type QueryAdminGameHistoryArgs = {
  args: AdminGameHistoryArgs;
};


export type QueryAdminKGolfMemberArgs = {
  args?: InputMaybe<AdminKGolfMemberArgs>;
};


export type QueryAdminMemberArgs = {
  args: AdminMemberArgs;
};


export type QueryAdminMemberNotificationsArgs = {
  args: AdminMemberNotificationsArgs;
};


export type QueryAdminMemberServiceTransactionsArgs = {
  args: AdminMemberServiceTransactionsArgs;
};


export type QueryAdminMemberSubscriptionsArgs = {
  args: AdminMemberSubscriptionsArgs;
};


export type QueryAdminMembersArgs = {
  args: AdminMembersArgs;
};


export type QueryAdminMembershipServicesArgs = {
  args: AdminMembershipServicesArgs;
};


export type QueryAdminMembershipSubscriptionsArgs = {
  args: AdminMembershipSubscriptionsArgs;
};


export type QueryAdminMembershipTypeArgs = {
  args: AdminMembershipTypeArgs;
};


export type QueryAdminMembershipTypesArgs = {
  args: AdminMembershipTypesArgs;
};


export type QueryAdminNotificationArgs = {
  args: AdminNotificationArgs;
};


export type QueryAdminNotificationsArgs = {
  args: AdminNotificationsArgs;
};


export type QueryAdminProductPackageExtensionsArgs = {
  args: AdminProductPackageExtensionsArgs;
};


export type QueryAdminProductsArgs = {
  args: AdminProductsArgs;
};


export type QueryAdminReportAcTransactionsArgs = {
  args: AdminReportAcTransactionsArgs;
};


export type QueryAdminReportCreditTransactionsArgs = {
  args: AdminReportCreditTransactionsArgs;
};


export type QueryAdminReportHitPayChargesArgs = {
  args: AdminReportHitPayChargesArgs;
};


export type QueryAdminReportMemberStatsArgs = {
  args: AdminReportMemberStatsArgs;
};


export type QueryAdminReportOrderArgs = {
  args: AdminReportOrderArgs;
};


export type QueryAdminReportOrdersArgs = {
  args: AdminReportOrdersArgs;
};


export type QueryAdminReportSubscriptionsArgs = {
  args: AdminReportSubscriptionsArgs;
};


export type QueryAdminReservedIdsArgs = {
  args?: InputMaybe<AdminReservedIdsArgs>;
};


export type QueryAdminScoreCardArgs = {
  args: AdminScoreCardArgs;
};


export type QueryAdminShopDetailsArgs = {
  args: AdminShopDetailsArg;
};


export type QueryAdminShopOptionsDrivingRangeArgs = {
  args: AdminShopOptionsDrivingRangeArgs;
};


export type QueryAdminShopOptionsRealTimeArgs = {
  args: AdminShopOptionsRealTimeArgs;
};


export type QueryAdminShopOptionsRoundArgs = {
  args: AdminShopOptionsRoundArgs;
};


export type QueryAdminSimulatorUsageArgs = {
  args: AdminSimulatorUsageArgs;
};


export type QueryAdminStaffsArgs = {
  args?: InputMaybe<AdminStaffsArgs>;
};


export type QueryAdminsArgs = {
  args: AdminsArgs;
};


export type QueryAppDineMenuArgs = {
  args?: InputMaybe<AppDineMenuArgs>;
};


export type QueryAppMainSliderArgs = {
  args?: InputMaybe<AppMainSliderArgs>;
};


export type QueryAppManifestArgs = {
  args: AppManifestArgs;
};


export type QueryCoachAvailabilityCalendarItemsArgs = {
  args?: InputMaybe<CoachAvailabilityCalendarItemsArgs>;
};


export type QueryCoachAvailabilityDayItemArgs = {
  args: CoachAvailabilityDayItemArgs;
};


export type QueryCoachAvailabilityDayItemTemplateArgs = {
  args: CoachAvailabilityDayItemTemplateArgs;
};


export type QueryCoachBookingArgs = {
  args: CoachBookingArgs;
};


export type QueryCoachBookingsArgs = {
  args: CoachBookingsArgs;
};


export type QueryFormHelperBookingArgs = {
  args: FormHelperBookingArgs;
};


export type QueryFormHelperNewAdminArgs = {
  args: FormHelperNewAdminArgs;
};


export type QueryFormHelperNewBlackOutArgs = {
  args?: InputMaybe<FormHelperNewBlackOutArgs>;
};


export type QueryFormHelperNewCoachArgs = {
  args: FormHelperNewCoachArgs;
};


export type QueryFormHelperNewMembershipArgs = {
  args: FormHelperNewMembershipArgs;
};


export type QueryMemberAccountServiceTransactionsArgs = {
  args: MemberAccountServiceTransactionsArgs;
};


export type QueryMemberBookingArgs = {
  args: MemberBookingArgs;
};


export type QueryMemberBookingCoachAvailabilityCalendarItemsArgs = {
  args: MemberBookingCoachAvailabilityCalendarItemsArgs;
};


export type QueryMemberBookingCoachAvailabilityDayItemArgs = {
  args: MemberBookingCoachAvailabilityDayItemArgs;
};


export type QueryMemberBookingCoachAvailabilitySlotItemArgs = {
  args: MemberBookingCoachAvailabilitySlotItemArgs;
};


export type QueryMemberBookingFacilityAvailabilityCalendarItemsArgs = {
  args: MemberBookingFacilityAvailabilityCalendarItemsArgs;
};


export type QueryMemberBookingFacilityAvailabilityDayItemArgs = {
  args: MemberBookingFacilityAvailabilityDayItemArgs;
};


export type QueryMemberBookingGameCheckoutArgs = {
  args: MemberBookingGameCheckoutArgs;
};


export type QueryMemberBookingLessonIndoorCheckoutArgs = {
  args: MemberBookingLessonIndoorCheckoutArgs;
};


export type QueryMemberBookingLessonOutdoorCheckoutArgs = {
  args: MemberBookingLessonOutdoorCheckoutArgs;
};


export type QueryMemberBookingPractiseCheckoutArgs = {
  args: MemberBookingPractiseCheckoutArgs;
};


export type QueryMemberBookingsArgs = {
  args: MemberBookingsArgs;
};


export type QueryMemberCreditTransactionsArgs = {
  args: MemberCreditTransactionsArgs;
};


export type QueryMemberMemberArgs = {
  args: MemberMemberArgs;
};


export type QueryMemberNotificationArgs = {
  args: MemberNotificationArgs;
};


export type QueryMemberNotificationsArgs = {
  args: MemberNotificationsArgs;
};


export type QueryMemberOrderArgs = {
  args: MemberOrderArgs;
};


export type QueryMemberOrdersArgs = {
  args: MemberOrdersArgs;
};


export type QueryMemberScoreCardArgs = {
  args: MemberScoreCardArgs;
};


export type QueryMemberScoreCardsArgs = {
  args: MemberScoreCardsArgs;
};


export type QueryMemberSubscriptionsArgs = {
  args: MemberSubscriptionsArgs;
};


export type QueryPublicClubhouseArgs = {
  args: PublicClubhouseArgs;
};

export enum Relationship {
  Child = 'CHILD',
  Spouse = 'SPOUSE'
}

export enum ReservedIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export enum ReservedMembershipIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export type ScoreCard = {
  __typename?: 'ScoreCard';
  clientName: Scalars['String'];
  courseIntroImage: Scalars['String'];
  courseLogoImage: Scalars['String'];
  courseName: Scalars['String'];
  endTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  roundIdx: Scalars['Int'];
  shopName: Scalars['String'];
  startTime: Scalars['Int'];
  strokeTotalScore: Scalars['Int'];
};

export type Self = {
  __typename?: 'Self';
  baseCountryCode?: Maybe<CountryCode>;
  baseGmtOffset?: Maybe<Scalars['Int']>;
  clubhouses?: Maybe<Array<Maybe<SelfClubhouse>>>;
  countries?: Maybe<Array<Maybe<SelfCountry>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type SelfClubhouse = {
  __typename?: 'SelfClubhouse';
  clubhouseCode: Scalars['String'];
  name: Scalars['String'];
};

export type SelfCountry = {
  __typename?: 'SelfCountry';
  countryCode: CountryCode;
  name: Scalars['String'];
};

export type SelfUpdateInput = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
};

export type SelfUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SelfUpdated = {
  __typename?: 'SelfUpdated';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  self: Self;
};

export enum SentBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  System = 'SYSTEM'
}

export type ServiceTransactionBasic = {
  __typename?: 'ServiceTransactionBasic';
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  id: Scalars['String'];
  serviceType: Scalars['String'];
  transactionType: Scalars['String'];
  venue?: Maybe<Scalars['String']>;
};

export enum ServiceTransactionDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export enum ServiceTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Purchase = 'PURCHASE',
  Redemption = 'REDEMPTION',
  Transfer = 'TRANSFER'
}

export enum ServiceType {
  Game = 'GAME',
  LessonField = 'LESSON_FIELD',
  LessonIndoor = 'LESSON_INDOOR',
  Practise = 'PRACTISE'
}

export type ShopTokens = {
  __typename?: 'ShopTokens';
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  kgat: Scalars['String'];
  kgrt: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
};

export type ShopsTokens = {
  __typename?: 'ShopsTokens';
  expires: Scalars['String'];
  shops?: Maybe<Scalars['JSON']>;
  ud?: Maybe<Scalars['DateTime']>;
};

export type ShotCoordinate = {
  __typename?: 'ShotCoordinate';
  endCoordinates?: Maybe<EndCoordinates>;
  gameRoundShotId?: Maybe<Scalars['Int']>;
  shotNumber?: Maybe<Scalars['Int']>;
  startCoordinates?: Maybe<StartCoordinates>;
};

export type SlotItem = {
  __typename?: 'SlotItem';
  bays: Array<Maybe<FacilityAvailability>>;
  puttings: Array<Maybe<FacilityAvailability>>;
  rooms: Array<Maybe<FacilityAvailability>>;
  studios: Array<Maybe<FacilityAvailability>>;
};

export type StartCoordinates = {
  __typename?: 'StartCoordinates';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export enum StringBoolean {
  False = 'FALSE',
  True = 'TRUE'
}

export type Subscription = {
  __typename?: 'Subscription';
  devManagementSystemUserTelemetry?: Maybe<DevManagementSystemUserTelemetry>;
  managementSystem?: Maybe<ManagementSystem>;
  memberApp?: Maybe<MemberApp>;
};


export type SubscriptionManagementSystemArgs = {
  args: ManagementSystemArgs;
};


export type SubscriptionMemberAppArgs = {
  args: MemberAppArgs;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Na = 'NA',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

export enum SystemAuditLogEventName {
  AdminLogin = 'ADMIN_LOGIN',
  BlackoutCreate = 'BLACKOUT_CREATE',
  CronJob = 'CRON_JOB'
}

export enum SystemOperationStatus {
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  AdminNotFound = 'ADMIN_NOT_FOUND',
  BadRequestException = 'BAD_REQUEST_EXCEPTION',
  BookingNotAllowed = 'BOOKING_NOT_ALLOWED',
  BookingOverlapped = 'BOOKING_OVERLAPPED',
  CannotFindSelf = 'CANNOT_FIND_SELF',
  Fail = 'FAIL',
  IncorrectExistingPassword = 'INCORRECT_EXISTING_PASSWORD',
  InsufficientCredit = 'INSUFFICIENT_CREDIT',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MemberNotFoundPasswordReset = 'MEMBER_NOT_FOUND_PASSWORD_RESET',
  NoRefreshToken = 'NO_REFRESH_TOKEN',
  PasswordMismatch = 'PASSWORD_MISMATCH',
  ResourceNotAvailable = 'RESOURCE_NOT_AVAILABLE',
  Success = 'SUCCESS',
  SuccessPasswordUpdate = 'SUCCESS_PASSWORD_UPDATE',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  UnableToUpdate = 'UNABLE_TO_UPDATE',
  Unauthorized = 'UNAUTHORIZED',
  UniqueConstraintEmail = 'UNIQUE_CONSTRAINT_EMAIL',
  UniqueConstraintViolation = 'UNIQUE_CONSTRAINT_VIOLATION',
  VerificationCodeMismatch = 'VERIFICATION_CODE_MISMATCH',
  VersionMismatch = 'VERSION_MISMATCH'
}

export type SystemUser = {
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type UpdatedAdmin = {
  __typename?: 'UpdatedAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type UpdatedCoach = {
  __typename?: 'UpdatedCoach';
  coach: AdminCoach;
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
};

export enum UserTelemetryResourceType {
  Booking = 'BOOKING',
  Clubhouse = 'CLUBHOUSE',
  Coach = 'COACH',
  Member = 'MEMBER',
  MyAccount = 'MY_ACCOUNT',
  NotificationMessage = 'NOTIFICATION_MESSAGE',
  Order = 'ORDER',
  OrderAtn = 'ORDER_ATN',
  Organization = 'ORGANIZATION',
  Settings = 'SETTINGS',
  Staff = 'STAFF',
  SystemUser = 'SYSTEM_USER'
}

export enum UserType {
  ClubhouseStaff = 'CLUBHOUSE_STAFF',
  Developer = 'DEVELOPER',
  ExternalCoach = 'EXTERNAL_COACH',
  MasterCoach = 'MASTER_COACH',
  MasterOwner = 'MASTER_OWNER',
  MasterUser = 'MASTER_USER',
  Owner = 'OWNER',
  User = 'USER'
}

export type AdminAdminUpdatePasswordMutationVariables = Exact<{
  input: AdminAdminUpdatePasswordInput;
}>;


export type AdminAdminUpdatePasswordMutation = { __typename?: 'Mutation', adminAdminUpdatePassword: SystemOperationStatus };

export type AdminCreateAdminMutationVariables = Exact<{
  input: AdminCreateAdminInput;
}>;


export type AdminCreateAdminMutation = { __typename?: 'Mutation', adminCreateAdmin: { __typename?: 'NewAdmin', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, user: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string } } };

export type AdminDeleteAdminMutationVariables = Exact<{
  input?: InputMaybe<AdminDeleteAdminInput>;
}>;


export type AdminDeleteAdminMutation = { __typename?: 'Mutation', adminDeleteAdmin: SystemOperationStatus };

export type AdminUpdateAdminMutationVariables = Exact<{
  args: AdminUpdateAdminArgs;
  input: AdminUpdateAdminInput;
}>;


export type AdminUpdateAdminMutation = { __typename?: 'Mutation', adminUpdateAdmin: { __typename?: 'UpdatedAdmin', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, user: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, baseCountryCode?: CountryCode | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins?: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } } };

export type AdminResendOnboardingEmailMutationVariables = Exact<{
  input: AdminResendOnboardingEmailInput;
}>;


export type AdminResendOnboardingEmailMutation = { __typename?: 'Mutation', adminResendOnboardingEmail: SystemOperationStatus };

export type FormHelperNewAdminQueryVariables = Exact<{
  args: FormHelperNewAdminArgs;
}>;


export type FormHelperNewAdminQuery = { __typename?: 'Query', formHelperNewAdmin?: { __typename?: 'FormHelperNewAdmin', clubhouses: Array<{ __typename?: 'AdminClubhouseBasic', clubhouseCode: string, clubhouseId: string, name: string } | null> } | null };

export type AdminsQueryVariables = Exact<{
  args: AdminsArgs;
}>;


export type AdminsQuery = { __typename?: 'Query', admins: { __typename?: 'AdminResponse', edges?: Array<{ __typename?: 'AdminEdge', cursor?: string | null, node?: { __typename?: 'AdminBasic', baseCountryCode?: CountryCode | null, createdAt?: any | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, userType?: UserType | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminQueryVariables = Exact<{
  args: AdminArgs;
}>;


export type AdminQuery = { __typename?: 'Query', admin?: { __typename?: 'Admin', authorizedClubhouses?: Array<string | null> | null, baseCountryCode?: CountryCode | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, permissions: Array<string | null>, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins?: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> | null, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null };

export type AdminBookingCancelMutationVariables = Exact<{
  input: AdminBookingCancelInput;
}>;


export type AdminBookingCancelMutation = { __typename?: 'Mutation', adminBookingCancel: SystemOperationStatus };

export type AdminBookingSendCancellationNotificationMutationVariables = Exact<{
  input: AdminBookingSendCancellationNotificationInput;
}>;


export type AdminBookingSendCancellationNotificationMutation = { __typename?: 'Mutation', adminBookingSendCancellationNotification: SystemOperationStatus };

export type AdminBookingGameCreateMutationVariables = Exact<{
  input: AdminBookingGameCreateInput;
}>;


export type AdminBookingGameCreateMutation = { __typename?: 'Mutation', adminBookingGameCreate: { __typename?: 'AdminBookingGameCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingLessonIndoorCreateMutationVariables = Exact<{
  input: AdminBookingLessonIndoorCreateInput;
}>;


export type AdminBookingLessonIndoorCreateMutation = { __typename?: 'Mutation', adminBookingLessonIndoorCreate: { __typename?: 'AdminBookingLessonIndoorCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingLessonOutdoorCreateMutationVariables = Exact<{
  input: AdminBookingLessonOutdoorCreateInput;
}>;


export type AdminBookingLessonOutdoorCreateMutation = { __typename?: 'Mutation', adminBookingLessonOutdoorCreate: { __typename?: 'AdminBookingLessonOutdoorCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingPractiseCreateMutationVariables = Exact<{
  input: AdminBookingPractiseCreateInput;
}>;


export type AdminBookingPractiseCreateMutation = { __typename?: 'Mutation', adminBookingPractiseCreate: { __typename?: 'AdminBookingPractiseCreate', bookingId: string, status: SystemOperationStatus } };

export type AdminBookingBlackoutCreateMutationVariables = Exact<{
  input: AdminBookingBlackoutCreateInput;
}>;


export type AdminBookingBlackoutCreateMutation = { __typename?: 'Mutation', adminBookingBlackoutCreate: { __typename?: 'AdminBookingBlackoutCreate', errorMessage: string, isCreateAllowed: boolean } };

export type AdminBookingBlackoutClubhouseUpdateMutationVariables = Exact<{
  input: AdminBookingBlackoutClubhouseUpdateInput;
}>;


export type AdminBookingBlackoutClubhouseUpdateMutation = { __typename?: 'Mutation', adminBookingBlackoutClubhouseUpdate: { __typename?: 'AdminBookingBlackoutClubhouse', block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, clubhouseCode?: string | null, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null } } | null> } };

export type AdminBookingBlackoutCoachUpdateMutationVariables = Exact<{
  input: AdminBookingBlackoutCoachUpdateInput;
}>;


export type AdminBookingBlackoutCoachUpdateMutation = { __typename?: 'Mutation', adminBookingBlackoutCoachUpdate: { __typename?: 'AdminBookingBlackoutCoach', block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, coachDisplayName: string, coachSlug: string, date: string, isDayBlocked: boolean } };

export type AdminBookingBlackoutDeleteMutationVariables = Exact<{
  input: AdminBookingBlackoutDeleteInput;
}>;


export type AdminBookingBlackoutDeleteMutation = { __typename?: 'Mutation', adminBookingBlackoutDelete: SystemOperationStatus };

export type AdminBookingCoachesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminBookingCoachesQuery = { __typename?: 'Query', adminBookingCoaches: Array<{ __typename?: 'AdminBookingCoach', baseCountryCode?: CountryCode | null, coachPublished?: boolean | null, displayName?: string | null, profileImageUrl?: string | null, slug?: string | null, userId?: string | null } | null> };

export type AdminBookingCoachAvailabilityCalendarItemsQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilityCalendarItemsArgs;
}>;


export type AdminBookingCoachAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminBookingCoachAvailabilityCalendarItems?: { __typename?: 'AdminBookingCoachAvailabilityCalendarItems', calendarItems: Array<{ __typename?: 'CoachAvailabilityCalendarItems', clubhouses: Array<string | null>, date: string, hasIndoorBooking?: boolean | null, hasOutdoorBooking?: boolean | null, isBlocked?: boolean | null, isIndoorBookingFull?: boolean | null } | null>, clubhouses: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> } | null };

export type AdminBookingCoachAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilityDayItemArgs;
}>;


export type AdminBookingCoachAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingCoachAvailabilityDayItem?: { __typename?: 'AdminBookingCoachAvailabilityDayItem', bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, blockedClubhousesDay: Array<string | null>, blockedClubhousesHours: Array<string | null>, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, date?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null } | null };

export type AdminBookingCoachAvailabilitySlotItemQueryVariables = Exact<{
  args: AdminBookingCoachAvailabilitySlotItemArgs;
}>;


export type AdminBookingCoachAvailabilitySlotItemQuery = { __typename?: 'Query', adminBookingCoachAvailabilitySlotItem?: { __typename?: 'AdminBookingCoachAvailabilitySlotItem', hr1?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr2?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null } | null };

export type AdminBookingFacilityAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilityDayItemArgs;
}>;


export type AdminBookingFacilityAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingFacilityAvailabilityDayItem?: { __typename?: 'AdminBookingFacilityAvailabilityDayItem', nonPutting?: { __typename?: 'NonPuttingFacilityDayItem', na0900?: boolean | null, na1000?: boolean | null, na1100?: boolean | null, na1200?: boolean | null, na1300?: boolean | null, na1400?: boolean | null, na1500?: boolean | null, na1600?: boolean | null, na1700?: boolean | null, na1800?: boolean | null, na1900?: boolean | null, na2000?: boolean | null } | null, putting?: { __typename?: 'PuttingFacilityDayItem', na0900?: boolean | null, na0930?: boolean | null, na1000?: boolean | null, na1030?: boolean | null, na1100?: boolean | null, na1130?: boolean | null, na1200?: boolean | null, na1230?: boolean | null, na1300?: boolean | null, na1330?: boolean | null, na1400?: boolean | null, na1430?: boolean | null, na1500?: boolean | null, na1530?: boolean | null, na1600?: boolean | null, na1630?: boolean | null, na1700?: boolean | null, na1730?: boolean | null, na1800?: boolean | null, na1830?: boolean | null, na1900?: boolean | null, na1930?: boolean | null, na2000?: boolean | null, na2030?: boolean | null } | null } | null };

export type AdminBookingFacilityAvailabilitySlotItemQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilitySlotItemArgs;
}>;


export type AdminBookingFacilityAvailabilitySlotItemQuery = { __typename?: 'Query', adminBookingFacilityAvailabilitySlotItem?: { __typename?: 'AdminBookingFacilityAvailabilitySlotItem', hr1?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr2?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr3?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr4?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, hr5?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, putting30?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null, putting60?: { __typename?: 'SlotItem', bays: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, puttings: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, rooms: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null>, studios: Array<{ __typename?: 'FacilityAvailability', clubhouseCode: string, facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null } | null };

export type AdminBookingFacilityAvailabilityCalendarItemsQueryVariables = Exact<{
  args: AdminBookingFacilityAvailabilityCalendarItemsArgs;
}>;


export type AdminBookingFacilityAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminBookingFacilityAvailabilityCalendarItems?: { __typename?: 'AdminBookingFacilityAvailabilityCalendarItems', calendarItems: Array<{ __typename?: 'FacilityAvailabilityCalendarItems', date: string, isBlocked?: boolean | null } | null> } | null };

export type AdminCoachCombinedAvailabilityQueryVariables = Exact<{
  args: AdminCoachCombinedAvailabilityArgs;
}>;


export type AdminCoachCombinedAvailabilityQuery = { __typename?: 'Query', adminCoachCombinedAvailability: Array<{ __typename?: 'AdminCoachCombinedAvailability', coachId: string, coachSlug: string, name: string, dateObjs: Array<{ __typename?: 'AdminCoachCombinedAvailabilityDateObj', clubhouses: Array<string | null>, date: string, hasIndoorBooking: boolean, hasOutdoorBooking: boolean, isDayBlocked: boolean } | null> } | null> };

export type AdminClubhouseFacilityAvailabilityQueryVariables = Exact<{
  args: AdminClubhouseFacilityAvailabilityArgs;
}>;


export type AdminClubhouseFacilityAvailabilityQuery = { __typename?: 'Query', adminClubhouseFacilityAvailability: { __typename?: 'AdminClubhouseFacilityAvailability', clubhouseCode: string, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null } } | null> } };

export type AdminBookingBlackoutClubhouseQueryVariables = Exact<{
  args: AdminBookingBlackoutClubhouseArgs;
}>;


export type AdminBookingBlackoutClubhouseQuery = { __typename?: 'Query', adminBookingBlackoutClubhouse: { __typename?: 'AdminBookingBlackoutClubhouse', block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, clubhouseCode?: string | null, date: string, isDayBlocked: boolean, name: string, facilityObjs: Array<{ __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObj', facilityCode: string, facilityName: string, facilityType: FacilityType, availability: { __typename?: 'AdminClubhouseFacilityAvailabilityFacilityObjAvailability', bi0900?: string | null, bi0930?: string | null, bi1000?: string | null, bi1030?: string | null, bi1100?: string | null, bi1130?: string | null, bi1200?: string | null, bi1230?: string | null, bi1300?: string | null, bi1330?: string | null, bi1400?: string | null, bi1430?: string | null, bi1500?: string | null, bi1530?: string | null, bi1600?: string | null, bi1630?: string | null, bi1700?: string | null, bi1730?: string | null, bi1800?: string | null, bi1830?: string | null, bi1900?: string | null, bi1930?: string | null, bi2000?: string | null, bi2030?: string | null } } | null> } };

export type AdminBookingBlackoutCoachQueryVariables = Exact<{
  args: AdminBookingBlackoutCoachArgs;
}>;


export type AdminBookingBlackoutCoachQuery = { __typename?: 'Query', adminBookingBlackoutCoach: { __typename?: 'AdminBookingBlackoutCoach', block09: boolean, block10: boolean, block11: boolean, block12: boolean, block13: boolean, block14: boolean, block15: boolean, block16: boolean, block17: boolean, block18: boolean, block19: boolean, block20: boolean, coachDisplayName: string, coachSlug: string, date: string, isDayBlocked: boolean } };

export type AdminBookingBlackoutsQueryVariables = Exact<{
  args: AdminBookingBlackoutsArgs;
}>;


export type AdminBookingBlackoutsQuery = { __typename?: 'Query', adminBookingBlackouts: Array<{ __typename?: 'AdminBookingBlackoutBasic', clubhouseCode?: string | null, clubhouseName?: string | null, coachDisplayName?: string | null, coachSlug?: string | null, countryCode?: CountryCode | null, date: string, type: string } | null> };

export type AdminBookingCombinedCoachAvailabilityDayItemQueryVariables = Exact<{
  args: AdminBookingCombinedCoachAvailabilityDayItemArgs;
}>;


export type AdminBookingCombinedCoachAvailabilityDayItemQuery = { __typename?: 'Query', adminBookingCombinedCoachAvailabilityDayItem?: { __typename?: 'AdminBookingCombinedCoachAvailabilityDayItem', bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, biOutdoor?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, date?: string | null, displayName?: string | null, hasOutdoorBooking?: boolean | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, clubhouses: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> } | null };

export type FormHelperBookingQueryVariables = Exact<{
  args: FormHelperBookingArgs;
}>;


export type FormHelperBookingQuery = { __typename?: 'Query', formHelperBooking?: { __typename?: 'FormHelperBooking', clubhouses: Array<{ __typename?: 'AdminClubhouseBasic', clubhouseCode: string, clubhouseId: string, name: string } | null> } | null };

export type FormHelperNewBlackOutQueryVariables = Exact<{
  args?: InputMaybe<FormHelperNewBlackOutArgs>;
}>;


export type FormHelperNewBlackOutQuery = { __typename?: 'Query', formHelperNewBlackOut?: { __typename?: 'FormHelperNewBlackOut', clubhouseCode?: string | null, date: string, errorMessage?: string | null, isCreateAllowed: boolean, facilities: Array<{ __typename?: 'FacilityBasic', facilityCode: string, facilityName: string, facilityType: FacilityType } | null> } | null };

export type AdminBookingAvailabilityQueryVariables = Exact<{
  args: AdminBookingAvailabilityArgs;
}>;


export type AdminBookingAvailabilityQuery = { __typename?: 'Query', adminBookingAvailability: string };

export type AdminBookingQueryVariables = Exact<{
  args: AdminBookingArgs;
}>;


export type AdminBookingQuery = { __typename?: 'Query', adminBooking?: { __typename?: 'AdminBooking', cancellationDateTime?: any | null, cancellationNotificationByAppSent?: boolean | null, cancellationNotificationByEmailSent?: boolean | null, cancellationNotificationBySmsSent?: boolean | null, cancellationNotificationMessage?: string | null, cancellationNotificationSentByAdminName?: string | null, cancellationNotificationSentDateTime?: any | null, cancellationReason?: string | null, cancelledBy?: CancelledBy | null, cancelledByAdminName?: string | null, coachId?: string | null, coachName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminName?: string | null, date: any, dateMonthStr?: string | null, dayOfWeekStr?: string | null, duration?: number | null, durationStr?: string | null, endTime: any, endTimeStr?: string | null, fieldLessonDetails?: string | null, gameCourseType?: GameCourseType | null, id: string, lateCancellationDetails?: any | null, member: string, memberIndividualId: string, memberUuid: string, noOfPlayers: number, resourceName?: string | null, startTime: any, startTimeStr?: string | null, status: BookingStatus, type: BookingType, venue?: string | null, yearStr?: string | null } | null };

export type AdminBookingBasicQueryVariables = Exact<{
  args: AdminBookingArgs;
}>;


export type AdminBookingBasicQuery = { __typename?: 'Query', adminBooking?: { __typename?: 'AdminBooking', dateMonthStr?: string | null, dayOfWeekStr?: string | null, durationStr?: string | null, endTimeStr?: string | null, facilityType?: FacilityType | null, id: string, member: string, memberIndividualId: string, resourceName?: string | null, startTimeStr?: string | null, venue?: string | null, yearStr?: string | null } | null };

export type AdminBookingsQueryVariables = Exact<{
  args: AdminBookingsArgs;
}>;


export type AdminBookingsQuery = { __typename?: 'Query', adminBookings: { __typename?: 'AdminBookingResponse', edges?: Array<{ __typename?: 'AdminBookingEdge', cursor?: string | null, node?: { __typename?: 'AdminBookingBasic', cancellationDateTime?: any | null, coachDisplayName?: string | null, date: any, dateMonthStr?: string | null, dayOfWeekStr?: string | null, durationStr?: string | null, endTime: any, endTimeStr?: string | null, gameCourseType?: GameCourseType | null, id: string, resourceName?: string | null, startTime: any, startTimeStr?: string | null, status: BookingStatus, type: BookingType, venue?: string | null, yearStr?: string | null, member: { __typename?: 'AdminBookingBasicMember', firstName?: string | null, lastName?: string | null } } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminBookingGameCheckoutQueryVariables = Exact<{
  args: AdminBookingGameCheckoutArgs;
}>;


export type AdminBookingGameCheckoutQuery = { __typename?: 'Query', adminBookingGameCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingLessonIndoorCheckoutQueryVariables = Exact<{
  args: AdminBookingLessonIndoorCheckoutArgs;
}>;


export type AdminBookingLessonIndoorCheckoutQuery = { __typename?: 'Query', adminBookingLessonIndoorCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingLessonOutdoorCheckoutQueryVariables = Exact<{
  args: AdminBookingLessonOutdoorCheckoutArgs;
}>;


export type AdminBookingLessonOutdoorCheckoutQuery = { __typename?: 'Query', adminBookingLessonOutdoorCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingPractiseCheckoutQueryVariables = Exact<{
  args: AdminBookingPractiseCheckoutArgs;
}>;


export type AdminBookingPractiseCheckoutQuery = { __typename?: 'Query', adminBookingPractiseCheckout: { __typename?: 'AdminBookingCheckout', amountInAceCoins: string, amountInCredit: string, amountInLocalCurrency?: string | null, balanceBefore: string, description: string, rateInAceCoins: string, rateInLocalCurrency?: string | null } };

export type AdminBookingSettingsQueryVariables = Exact<{
  args: AdminBookingSettingsArgs;
}>;


export type AdminBookingSettingsQuery = { __typename?: 'Query', adminBookingSettings: { __typename?: 'AdminBookingSettings', cancellationConditions: { __typename?: 'CancellationConditions', GAME: number, LESSON_FIELD: number, LESSON_INDOOR: number, LESSON_OUTDOOR: number, PRACTISE: number } } };

export type AdminStaffsQueryVariables = Exact<{
  args?: InputMaybe<AdminStaffsArgs>;
}>;


export type AdminStaffsQuery = { __typename?: 'Query', adminStaffs: { __typename?: 'AdminStaffResponse', edges?: Array<{ __typename?: 'AdminStaffEdge', cursor?: string | null, node?: { __typename?: 'AdminStaffBasic', baseCountryCode?: CountryCode | null, createdAt?: any | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminClientSetupMutationVariables = Exact<{
  input: AdminClientSetupInput;
}>;


export type AdminClientSetupMutation = { __typename?: 'Mutation', adminClientSetup: SystemOperationStatus };

export type AdminUpdateFacilityMutationVariables = Exact<{
  input: AdminUpdateFacilityInput;
}>;


export type AdminUpdateFacilityMutation = { __typename?: 'Mutation', adminUpdateFacility: SystemOperationStatus };

export type AdminClubhousesQueryVariables = Exact<{
  args: AdminClubhousesArgs;
}>;


export type AdminClubhousesQuery = { __typename?: 'Query', adminClubhouses: { __typename?: 'AdminClubhouseResponse', edges?: Array<{ __typename?: 'AdminClubhouseEdge', cursor?: string | null, node?: { __typename?: 'AdminClubhouseBasic', addressCountry?: string | null, clubhouseCode: string, clubhouseId: string, name: string } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminClubhouseQueryVariables = Exact<{
  args: AdminClubhouseArgs;
}>;


export type AdminClubhouseQuery = { __typename?: 'Query', adminClubhouse: { __typename?: 'AdminClubhouse', addressCity?: string | null, addressCountry?: string | null, addressCountryIso?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, clubhouseCode?: string | null, clubhouseId: string, colorCode?: string | null, createdAt?: any | null, email?: string | null, kGolfClientId?: string | null, kGolfClientSecret?: string | null, kGolfPassword?: string | null, kGolfShopGuid?: string | null, kGolfUsername?: string | null, name: string, noOfPrivateRooms?: number | null, noOfPuttingGreen?: number | null, noOfSimulators?: number | null, organizationId: string, phoneNumber?: string | null, updatedAt?: any | null, organization: { __typename?: 'ClubhouseOrganization', businessName: string, id: string } } };

export type AdminClubhouseFacilitiesQueryVariables = Exact<{
  args: AdminClubhouseFacilitiesArgs;
}>;


export type AdminClubhouseFacilitiesQuery = { __typename?: 'Query', adminClubhouseFacilities: Array<{ __typename?: 'Facility', clientGuid?: string | null, clientName?: string | null, clientOrder?: number | null, facilityCode?: string | null, facilityName?: string | null, facilityType?: FacilityType | null, id?: string | null }> };

export type AdminDeleteCoachMutationVariables = Exact<{
  input?: InputMaybe<AdminDeleteCoachInput>;
}>;


export type AdminDeleteCoachMutation = { __typename?: 'Mutation', adminDeleteCoach: SystemOperationStatus };

export type AdminUpdateCoachBookableMutationVariables = Exact<{
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachBookableInput;
}>;


export type AdminUpdateCoachBookableMutation = { __typename?: 'Mutation', adminUpdateCoachBookable: { __typename?: 'AdminUpdateCoachBookable', isBookable: boolean } };

export type AdminUpdateCoachMutationVariables = Exact<{
  args: AdminUpdateCoachArgs;
  input: AdminUpdateCoachInput;
}>;


export type AdminUpdateCoachMutation = { __typename?: 'Mutation', adminUpdateCoach: { __typename?: 'UpdatedCoach', coach: { __typename?: 'AdminCoach', baseCountryCode?: CountryCode | null, coachBirthdate?: string | null, coachBirthPlace?: string | null, coachExperiences?: any | null, coachExpertise?: Array<string | null> | null, coachLanguages?: Array<string | null> | null, coachLevel?: CoachLevel | null, coachListOrder?: number | null, coachPGANo?: string | null, coachPGAType?: string | null, coachPGAYear?: string | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, profileImageUrl?: string | null, slug?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType: UserType, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null>, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null }, fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null } };

export type CoachAvailabilityDayUpsertMutationVariables = Exact<{
  input: CoachAvailabilityDayUpsertInput;
}>;


export type CoachAvailabilityDayUpsertMutation = { __typename?: 'Mutation', coachAvailabilityDayUpsert?: { __typename?: 'CoachAvailabilityDayItem', bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, date?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null } | null };

export type FormHelperNewCoachQueryVariables = Exact<{
  args: FormHelperNewCoachArgs;
}>;


export type FormHelperNewCoachQuery = { __typename?: 'Query', formHelperNewCoach?: { __typename?: 'FormHelperNewCoach', countries: Array<string | null> } | null };

export type AdminCoachQueryVariables = Exact<{
  args: AdminCoachArgs;
}>;


export type AdminCoachQuery = { __typename?: 'Query', adminCoach: { __typename?: 'AdminCoach', baseCountryCode?: CountryCode | null, coachBirthdate?: string | null, coachBirthPlace?: string | null, coachExperiences?: any | null, coachExpertise?: Array<string | null> | null, coachLanguages?: Array<string | null> | null, coachLevel?: CoachLevel | null, coachListOrder?: number | null, coachPGANo?: string | null, coachPGAType?: string | null, coachPGAYear?: string | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: Gender | null, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, mobileNumber?: string | null, profileImageUrl?: string | null, slug?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType: UserType, clubhouses?: Array<{ __typename?: 'CoachClubhouse', clubhouseCode: string, displayName: string, tagBgColorCode: string, tagText: string, tagTextColorCode: string } | null> | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null>, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } };

export type AdminCoachesQueryVariables = Exact<{
  args?: InputMaybe<AdminCoachesArgs>;
}>;


export type AdminCoachesQuery = { __typename?: 'Query', adminCoaches: { __typename?: 'AdminCoachResponse', edges?: Array<{ __typename?: 'AdminCoachEdge', cursor?: string | null, node?: { __typename?: 'AdminCoachBasic', baseCountryCode?: CountryCode | null, coachPublished?: boolean | null, createdAt?: any | null, displayName?: string | null, firstName: string, lastAccessTokenDate?: any | null, lastLoginDate?: any | null, lastName: string, profileImageUrl?: string | null, status?: AdminStatus | null, userId: string, organization?: { __typename?: 'AdminOrganization', businessName: string, id: string, clubhouses?: Array<{ __typename?: 'BasicClubhouseDetails', clubhouseCode: string, name: string } | null> | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminCoachAvailabilityCalendarItemsQueryVariables = Exact<{
  args?: InputMaybe<AdminCoachAvailabilityCalendarItemsArgs>;
}>;


export type AdminCoachAvailabilityCalendarItemsQuery = { __typename?: 'Query', adminCoachAvailabilityCalendarItems: Array<{ __typename?: 'CoachAvailabilityCalendarItems', clubhouses: Array<string | null>, date: string, hasIndoorBooking?: boolean | null, hasOutdoorBooking?: boolean | null, isBlocked?: boolean | null, isIndoorBookingFull?: boolean | null } | null> };

export type CoachAvailabilityDayItemQueryVariables = Exact<{
  args: CoachAvailabilityDayItemArgs;
}>;


export type CoachAvailabilityDayItemQuery = { __typename?: 'Query', coachAvailabilityDayItem?: { __typename?: 'CoachAvailabilityDayItem', bi0900?: string | null, bi1000?: string | null, bi1100?: string | null, bi1200?: string | null, bi1300?: string | null, bi1400?: string | null, bi1500?: string | null, bi1600?: string | null, bi1700?: string | null, bi1800?: string | null, bi1900?: string | null, bi2000?: string | null, biOutdoor?: string | null, bs0900?: string | null, bs1000?: string | null, bs1100?: string | null, bs1200?: string | null, bs1300?: string | null, bs1400?: string | null, bs1500?: string | null, bs1600?: string | null, bs1700?: string | null, bs1800?: string | null, bs1900?: string | null, bs2000?: string | null, date?: string | null, hasOutdoorBooking?: boolean | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null } | null };

export type DevGraphqlUtilityMutation1MutationVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityMutation1Mutation = { __typename?: 'Mutation', devGraphqlUtilityMutation1: SystemOperationStatus };

export type DevGraphqlUtilityMutation2MutationVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityMutation2Mutation = { __typename?: 'Mutation', devGraphqlUtilityMutation2: SystemOperationStatus };

export type DevGraphqlUtilityMutation3MutationVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityMutation3Mutation = { __typename?: 'Mutation', devGraphqlUtilityMutation3: SystemOperationStatus };

export type DevGraphqlUtilityMutation4MutationVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityMutation4Mutation = { __typename?: 'Mutation', devGraphqlUtilityMutation4: SystemOperationStatus };

export type DevGraphqlUtilityQuery1QueryVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityQuery1Query = { __typename?: 'Query', devGraphqlUtilityQuery1: any };

export type DevGraphqlUtilityQuery2QueryVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityQuery2Query = { __typename?: 'Query', devGraphqlUtilityQuery2: any };

export type DevGraphqlUtilityQuery3QueryVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityQuery3Query = { __typename?: 'Query', devGraphqlUtilityQuery3: any };

export type DevGraphqlUtilityQuery4QueryVariables = Exact<{ [key: string]: never; }>;


export type DevGraphqlUtilityQuery4Query = { __typename?: 'Query', devGraphqlUtilityQuery4: any };

export type DevEMenuImportOrdersMutationVariables = Exact<{
  input: DevEMenuImportOrdersInput;
}>;


export type DevEMenuImportOrdersMutation = { __typename?: 'Mutation', devEMenuImportOrders: SystemOperationStatus };

export type DevEMenuMatchOrdersMutationVariables = Exact<{
  input: DevEMenuMatchOrdersInput;
}>;


export type DevEMenuMatchOrdersMutation = { __typename?: 'Mutation', devEMenuMatchOrders: { __typename?: 'DevEMenuMatchOrders', numberOfOrdersMatched?: number | null } };

export type DevEMenuUpsertCreditTransactionsMutationVariables = Exact<{
  input?: InputMaybe<DevEMenuUpsertCreditTransactionsInput>;
}>;


export type DevEMenuUpsertCreditTransactionsMutation = { __typename?: 'Mutation', devEMenuUpsertCreditTransactions: SystemOperationStatus };

export type DevKGolfMemberJoinMutationVariables = Exact<{ [key: string]: never; }>;


export type DevKGolfMemberJoinMutation = { __typename?: 'Mutation', devKGolfMemberJoin: { __typename?: 'DevKGolfMemberJoin', kGolfAccountCreationError: boolean, kGolfPassword: string, kGolfUserId: string, nickname: string } };

export type DevKGolfMemberLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type DevKGolfMemberLoginMutation = { __typename?: 'Mutation', devKGolfMemberLogin: { __typename?: 'KGolfMemberLogin', accessToken?: string | null, cdn?: string | null, ewxpiresIn?: number | null, gender?: number | null, guid?: string | null, nickname?: string | null, profilePath?: string | null, refreshToken?: string | null, scope?: string | null, tokenType?: string | null } };

export type DevKGolfMemberGetQueryVariables = Exact<{ [key: string]: never; }>;


export type DevKGolfMemberGetQuery = { __typename?: 'Query', devKGolfMemberGet: { __typename?: 'KGolfMemberGet', address1?: string | null, address2?: string | null, birthday?: string | null, cdn?: string | null, city?: string | null, country?: string | null, email?: string | null, gender?: number | null, isTermsAgreeNotificationSMS?: boolean | null, mobilePhone?: string | null, mobilePhoneCountry?: string | null, nickname?: string | null, profilePath?: string | null, province?: string | null, zipcode?: string | null } };

export type DevKGolfCreateAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type DevKGolfCreateAccountsMutation = { __typename?: 'Mutation', devKGolfCreateAccounts: { __typename?: 'DevKGolfCreateAccounts', noOfKGolfAccountCreated: number } };

export type DevKGolfShopLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type DevKGolfShopLoginMutation = { __typename?: 'Mutation', devKGolfShopLogin: { __typename?: 'KGolfShopLogin', accessToken?: string | null, country?: string | null, expiresIn?: number | null, managerId?: string | null, managerIdx?: number | null, managerName?: string | null, managerType?: string | null, refreshToken?: string | null, scope?: string | null, shopGuid?: string | null, shopName?: string | null, tokenType?: string | null } };

export type DevNotificationAppSendMutationVariables = Exact<{
  input: DevNotificationAppSendInput;
}>;


export type DevNotificationAppSendMutation = { __typename?: 'Mutation', devNotificationAppSend: SystemOperationStatus };

export type AdminLoginMutationVariables = Exact<{
  input: AdminLoginInput;
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminLogoutMutation = { __typename?: 'Mutation', adminLogout: SystemOperationStatus };

export type AdminRefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminRefreshAccessTokenMutation = { __typename?: 'Mutation', adminRefreshAccessToken: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminForgotPasswordMutationVariables = Exact<{
  input: AdminForgotPasswordInput;
}>;


export type AdminForgotPasswordMutation = { __typename?: 'Mutation', adminForgotPassword: { __typename?: 'AdminForgotPasswordResponse', email: string, resetToken: string } };

export type AdminForgotPasswordSubmitMutationVariables = Exact<{
  input: AdminForgotPasswordSubmitInput;
}>;


export type AdminForgotPasswordSubmitMutation = { __typename?: 'Mutation', adminForgotPasswordSubmit: SystemOperationStatus };

export type AdminShopTokensMutationVariables = Exact<{
  input?: InputMaybe<AdminShopTokensInput>;
}>;


export type AdminShopTokensMutation = { __typename?: 'Mutation', adminShopTokens: { __typename?: 'ShopsTokens', expires: string, shops?: any | null, ud?: any | null } };

export type AdminDeleteMembershipMutationVariables = Exact<{
  input: AdminDeleteMembershipInput;
}>;


export type AdminDeleteMembershipMutation = { __typename?: 'Mutation', adminDeleteMembership: SystemOperationStatus };

export type AdminMemberCreditUpdateMutationVariables = Exact<{
  input?: InputMaybe<AdminMemberCreditUpdateInput>;
}>;


export type AdminMemberCreditUpdateMutation = { __typename?: 'Mutation', adminMemberCreditUpdate: SystemOperationStatus };

export type AdminMemberSendResetPasswordEmailMutationVariables = Exact<{
  input: AdminMemberSendResetPasswordEmailInput;
}>;


export type AdminMemberSendResetPasswordEmailMutation = { __typename?: 'Mutation', adminMemberSendResetPasswordEmail: SystemOperationStatus };

export type AdminMemberProfileUpdateMutationVariables = Exact<{
  input: AdminMemberProfileUpdateInput;
}>;


export type AdminMemberProfileUpdateMutation = { __typename?: 'Mutation', adminMemberProfileUpdate: { __typename?: 'AdminMemberProfileUpdate', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, member: { __typename?: 'AdminMember', accountType?: AccountType | null, activationOrderNo: string, activationPrice: number, addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, birthday?: string | null, companyContactPersonEmail?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, credit: number, creditSpent: number, email: string, firstName: string, gameCredit: number, gender?: Gender | null, handed: Handed, hasSubscriptions: boolean, individualId: string, kGolfAccountCreationError?: boolean | null, lastName: string, locker: boolean, membershipStatus: MembershipStatus, membershipUuid: string, memberStatus: MemberStatus, memberUuid: string, mobileNumber?: string | null, nationality?: string | null, nickname?: string | null, partialNricOrFin?: string | null, practiseCredit: number, profileImageUrl?: string | null, pushTokens: Array<string | null>, relationshipToMainMember?: Relationship | null, serviceNote?: string | null, signUpSidasInsoles: number, startDate?: any | null, voucherField: number, voucherIndoor: number, activationLineItems: Array<{ __typename?: 'AdminMemberActivationLineItem', itemName: string, salesPrice: number } | null>, members: Array<{ __typename?: 'AdminMemberMember', accountType?: AccountType | null, firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null } | null>, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } } };

export type AdminMemberTierUpdateMutationVariables = Exact<{
  input: AdminMemberTierUpdateInput;
}>;


export type AdminMemberTierUpdateMutation = { __typename?: 'Mutation', adminMemberTierUpdate: { __typename?: 'AdminMemberProfileUpdate', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, member: { __typename?: 'AdminMember', accountType?: AccountType | null, activationOrderNo: string, activationPrice: number, addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, birthday?: string | null, companyContactPersonEmail?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, credit: number, creditSpent: number, email: string, firstName: string, gameCredit: number, gender?: Gender | null, handed: Handed, hasSubscriptions: boolean, individualId: string, kGolfAccountCreationError?: boolean | null, lastName: string, locker: boolean, membershipStatus: MembershipStatus, membershipUuid: string, memberStatus: MemberStatus, memberUuid: string, mobileNumber?: string | null, nationality?: string | null, nickname?: string | null, partialNricOrFin?: string | null, practiseCredit: number, profileImageUrl?: string | null, pushTokens: Array<string | null>, relationshipToMainMember?: Relationship | null, serviceNote?: string | null, signUpSidasInsoles: number, startDate?: any | null, voucherField: number, voucherIndoor: number, activationLineItems: Array<{ __typename?: 'AdminMemberActivationLineItem', itemName: string, salesPrice: number } | null>, members: Array<{ __typename?: 'AdminMemberMember', accountType?: AccountType | null, firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null } | null>, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } } };

export type AdminUpdateSidasInsolesMutationVariables = Exact<{
  input: AdminUpdateSidasInsolesInput;
}>;


export type AdminUpdateSidasInsolesMutation = { __typename?: 'Mutation', adminUpdateSidasInsoles: SystemOperationStatus };

export type AdminUpdateNicknameMutationVariables = Exact<{
  input: AdminUpdateNicknameInput;
}>;


export type AdminUpdateNicknameMutation = { __typename?: 'Mutation', adminUpdateNickname: SystemOperationStatus };

export type AdminPaySubscriptionsMutationVariables = Exact<{
  input: AdminPaySubscriptionsInput;
}>;


export type AdminPaySubscriptionsMutation = { __typename?: 'Mutation', adminPaySubscriptions: SystemOperationStatus };

export type AdminUpdateSubscriptionMutationVariables = Exact<{
  input: AdmnUpdateSubscriptionInput;
}>;


export type AdminUpdateSubscriptionMutation = { __typename?: 'Mutation', adminUpdateSubscription: SystemOperationStatus };

export type AdminMemberResendOnboardingEmailMutationVariables = Exact<{
  input: AdminMemberResendOnboardingEmailInput;
}>;


export type AdminMemberResendOnboardingEmailMutation = { __typename?: 'Mutation', adminMemberResendOnboardingEmail: SystemOperationStatus };

export type AdminMemberUpdatePasswordMutationVariables = Exact<{
  input: AdminMemberUpdatePasswordInput;
}>;


export type AdminMemberUpdatePasswordMutation = { __typename?: 'Mutation', adminMemberUpdatePassword: SystemOperationStatus };

export type AdminMemberReassignMembershipIdMutationVariables = Exact<{
  input: AdminMemberReassignMembershipIdInput;
}>;


export type AdminMemberReassignMembershipIdMutation = { __typename?: 'Mutation', adminMemberReassignMembershipId: SystemOperationStatus };

export type AdminMemberServiceUpdateMutationVariables = Exact<{
  input: AdminMemberServiceUpdateInput;
}>;


export type AdminMemberServiceUpdateMutation = { __typename?: 'Mutation', adminMemberServiceUpdate: SystemOperationStatus };

export type AdminMembersQueryVariables = Exact<{
  args: AdminMembersArgs;
}>;


export type AdminMembersQuery = { __typename?: 'Query', adminMembers: { __typename?: 'AdminMemberResponse', edges?: Array<{ __typename?: 'AdminMemberEdge', cursor?: string | null, node?: { __typename?: 'AdminMemberBasic', accountType?: AccountType | null, appVersion?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, firstName: string, id: string, individualId: string, kGolfAccountCreationError?: boolean | null, lastName: string, membershipId: string, memberStatus?: MemberStatus | null, startDate?: any | null, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'AdminMemberResponsePageInfo', endCursor?: string | null, failedKGolfAccounts?: number | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberQueryVariables = Exact<{
  args: AdminMemberArgs;
}>;


export type AdminMemberQuery = { __typename?: 'Query', adminMember: { __typename?: 'AdminMember', accountType?: AccountType | null, activationOrderNo: string, activationPrice: number, addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, birthday?: string | null, companyContactPersonEmail?: string | null, companyContactPersonFirstName?: string | null, companyContactPersonLastName?: string | null, companyName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, credit: number, creditSpent: number, email: string, firstName: string, gameCredit: number, gender?: Gender | null, handed: Handed, hasSubscriptions: boolean, individualId: string, kGolfAccountCreationError?: boolean | null, lastName: string, locker: boolean, membershipStatus: MembershipStatus, membershipUuid: string, memberStatus: MemberStatus, memberUuid: string, mobileNumber?: string | null, nationality?: string | null, nickname?: string | null, partialNricOrFin?: string | null, practiseCredit: number, profileImageUrl?: string | null, pushTokens: Array<string | null>, relationshipToMainMember?: Relationship | null, serviceNote?: string | null, signUpSidasInsoles: number, startDate?: any | null, termEndDate?: any | null, voucherField: number, voucherIndoor: number, activationLineItems: Array<{ __typename?: 'AdminMemberActivationLineItem', itemName: string, salesPrice: number } | null>, members: Array<{ __typename?: 'AdminMemberMember', accountType?: AccountType | null, firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null } | null>, membershipType?: { __typename?: 'MembershipTypeBasic', baseCountryCode?: CountryCode | null, internalName?: string | null, isCorporate?: boolean | null, price?: number | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null } | null } };

export type AdminCreditTransactionsQueryVariables = Exact<{
  args: AdminCreditTransactionsArgs;
}>;


export type AdminCreditTransactionsQuery = { __typename?: 'Query', adminCreditTransactions: { __typename?: 'AdminCreditTransactionResponse', edges?: Array<{ __typename?: 'AdminCreditTransactionEdge', cursor?: string | null, node?: { __typename?: 'CreditTransaction', amount: number, authorizedAdjuster?: string | null, createdAt?: any | null, description?: string | null, id?: string | null, isSpent?: boolean | null, type?: AceCoinTransactionType | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminKGolfMemberQueryVariables = Exact<{
  args?: InputMaybe<AdminKGolfMemberArgs>;
}>;


export type AdminKGolfMemberQuery = { __typename?: 'Query', adminKGolfMember: { __typename?: 'AdminKGolfMember', address1?: string | null, address2?: string | null, birthday?: string | null, cdn?: string | null, city?: string | null, connectKakao?: boolean | null, connectWechat?: boolean | null, country?: string | null, email?: string | null, gender?: number | null, handed?: number | null, id?: string | null, isTermsAgreeNotificationEmail?: boolean | null, isTermsAgreeNotificationSMS?: boolean | null, mobilePhone?: string | null, mobilePhoneCountry?: string | null, nickname?: string | null, profilePath?: string | null, province?: string | null, zipcode?: string | null } };

export type AdminMembershipSubscriptionsQueryVariables = Exact<{
  args: AdminMembershipSubscriptionsArgs;
}>;


export type AdminMembershipSubscriptionsQuery = { __typename?: 'Query', adminMembershipSubscriptions: { __typename?: 'AdminMembershipSubscriptionResponse', edges?: Array<{ __typename?: 'AdminMembershipSubscriptionEdge', cursor?: string | null, node?: { __typename?: 'AdminMembershipSubscriptionBasic', credit: number, endDate?: any | null, mainMemberMainId: string, mainMemberName: string, membershipUuid: string, memberUuid: string, status?: SubscriptionStatus | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMemberSubscriptionsQueryVariables = Exact<{
  args: AdminMemberSubscriptionsArgs;
}>;


export type AdminMemberSubscriptionsQuery = { __typename?: 'Query', adminMemberSubscriptions: { __typename?: 'AdminMemberSubscriptionResponse', balance?: number | null, credit?: number | null, daysLeft?: number | null, endDate?: any | null, mainMemberName?: string | null, membershipId?: string | null, membershipUuid?: string | null, startDate?: any | null, status?: SubscriptionStatus | null, subscriptionEndDate?: any | null, edges?: Array<{ __typename?: 'AdminMemberSubscriptionEdge', cursor?: string | null, node?: { __typename?: 'AdminMembershipSubscription', amount?: number | null, creditDeducted?: boolean | null, days?: number | null, description?: string | null, endDate?: any | null, id?: string | null, startDate?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminMembershipServicesQueryVariables = Exact<{
  args: AdminMembershipServicesArgs;
}>;


export type AdminMembershipServicesQuery = { __typename?: 'Query', adminMembershipServices?: { __typename?: 'AdminMembershipServices', services?: Array<{ __typename?: 'AdminMembershipService', amount: number, dateAdded?: any | null, expiryDate?: any | null, hasExtended?: boolean | null, orderNo?: string | null, serviceId: string, serviceName: string, unitType: string } | null> | null } | null };

export type AdminMemberServiceTransactionsQueryVariables = Exact<{
  args: AdminMemberServiceTransactionsArgs;
}>;


export type AdminMemberServiceTransactionsQuery = { __typename?: 'Query', adminMemberServiceTransactions: { __typename?: 'AdminMemberServiceTransactionResponse', edges?: Array<{ __typename?: 'AdminMemberServiceTransactionEdge', cursor?: string | null, node?: { __typename?: 'ServiceTransactionBasic', amount: number, comment?: string | null, date: any, id: string, serviceType: string, transactionType: string, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminUpdateMembershipTypeMutationVariables = Exact<{
  input: AdminUpdateMembershipTypeInput;
}>;


export type AdminUpdateMembershipTypeMutation = { __typename?: 'Mutation', adminUpdateMembershipType: { __typename?: 'AdminMembershipType', baseCountryCode?: CountryCode | null, compDailySimulatorUse?: number | null, compDailySimulatorUseType?: CompDailySimulatorUseType | null, compFieldLessons?: number | null, compIndoorLessons?: number | null, compLocker?: boolean | null, designatedPrivateRoom?: boolean | null, discount?: number | null, id?: string | null, imageUrl?: string | null, initialCredits?: number | null, internalName?: string | null, isCorporate?: boolean | null, isEnabled?: boolean | null, lineItemCode?: string | null, loungeAccess?: boolean | null, mainTypeSlug?: string | null, monthlySub?: number | null, price?: number | null, publicName?: string | null, signupProductSidasInsoles?: boolean | null, subscriptionlineItemCode?: string | null, supplementaryTypeSlug?: string | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } };

export type AdminMembershipTypesQueryVariables = Exact<{
  args: AdminMembershipTypesArgs;
}>;


export type AdminMembershipTypesQuery = { __typename?: 'Query', adminMembershipTypes: { __typename?: 'AdminMembershipTypes', numberOfTypes?: number | null, lifestyle?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null, premium?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null, vip?: Array<{ __typename?: 'AdminMembershipTypeBasic', baseCountryCode?: CountryCode | null, id?: string | null, internalName?: string | null, price?: number | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } | null> | null } };

export type AdminMembershipTypeQueryVariables = Exact<{
  args: AdminMembershipTypeArgs;
}>;


export type AdminMembershipTypeQuery = { __typename?: 'Query', adminMembershipType: { __typename?: 'AdminMembershipType', baseCountryCode?: CountryCode | null, compDailySimulatorUse?: number | null, compDailySimulatorUseType?: CompDailySimulatorUseType | null, compFieldLessons?: number | null, compIndoorLessons?: number | null, compLocker?: boolean | null, designatedPrivateRoom?: boolean | null, discount?: number | null, id?: string | null, imageUrl?: string | null, initialCredits?: number | null, internalName?: string | null, isCorporate?: boolean | null, isEnabled?: boolean | null, lineItemCode?: string | null, loungeAccess?: boolean | null, mainTypeSlug?: string | null, monthlySub?: number | null, price?: number | null, publicName?: string | null, signupProductSidasInsoles?: boolean | null, subscriptionlineItemCode?: string | null, supplementaryTypeSlug?: string | null, tagBgColorCode?: string | null, tagText?: string | null, tagTextColorCode?: string | null, tier?: MembershipTypeTier | null, versionSlug?: string | null } };

export type AdminActivateMembershipMutationVariables = Exact<{
  input?: InputMaybe<AdminActivateMembershipInput>;
}>;


export type AdminActivateMembershipMutation = { __typename?: 'Mutation', adminActivateMembership: { __typename?: 'AdminActivateMembership', payment?: { __typename?: 'HitPayPaymentRequest', checkoutUrl?: string | null, requestId?: string | null } | null } };

export type AdminCreateMembershipMutationVariables = Exact<{
  input: AdminCreateMembershipInput;
}>;


export type AdminCreateMembershipMutation = { __typename?: 'Mutation', adminCreateMembership: { __typename?: 'AdminNewMembership', memberUuid?: string | null, fileUploadCredentials?: { __typename?: 'AdminNewMembershipFileUploadCredentials', mainMembers?: Array<{ __typename?: 'FileUploadObject', assetUrl: string, clientImageFieldName: string, fields: any, index: number, signedUrl: string } | null> | null, subMembers?: Array<{ __typename?: 'FileUploadObject', assetUrl: string, clientImageFieldName: string, fields: any, index: number, signedUrl: string } | null> | null } | null, payment?: { __typename?: 'HitPayPaymentRequest', checkoutUrl?: string | null, requestId?: string | null } | null } };

export type AdminUpdateReservedIdMutationVariables = Exact<{
  input?: InputMaybe<AdminUpdateReservedIdInput>;
}>;


export type AdminUpdateReservedIdMutation = { __typename?: 'Mutation', adminUpdateReservedId: { __typename?: 'AdminUpdateReservedId', onHoldExpiresAt?: any | null } };

export type AdminMembershipSubscriptionPauseMutationVariables = Exact<{
  input: AdminMembershipSubscriptionPauseInput;
}>;


export type AdminMembershipSubscriptionPauseMutation = { __typename?: 'Mutation', adminMembershipSubscriptionPause: SystemOperationStatus };

export type AdminMembershipSubscriptionStartMutationVariables = Exact<{
  input: AdminMembershipSubscriptionStartInput;
}>;


export type AdminMembershipSubscriptionStartMutation = { __typename?: 'Mutation', adminMembershipSubscriptionStart: SystemOperationStatus };

export type AdminMembershipSubscriptionPayOutstandingMutationVariables = Exact<{
  input: AdminMembershipSubscriptionPayOutstandingInput;
}>;


export type AdminMembershipSubscriptionPayOutstandingMutation = { __typename?: 'Mutation', adminMembershipSubscriptionPayOutstanding: SystemOperationStatus };

export type FormHelperNewMembershipQueryVariables = Exact<{
  args: FormHelperNewMembershipArgs;
}>;


export type FormHelperNewMembershipQuery = { __typename?: 'Query', formHelperNewMembership?: { __typename?: 'FormHelperNewMembership', membershipTypes: Array<{ __typename?: 'FormHelperNewMembershipMembershipType', baseCountryCode: CountryCode, hasReservedIds?: boolean | null, id: string, internalName: string, isCorporate: boolean, price: number, supplementaryTypePrice: number, supplementaryTypeSlug?: string | null, versionSlug: string } | null> } | null };

export type AdminReservedIdsQueryVariables = Exact<{
  args?: InputMaybe<AdminReservedIdsArgs>;
}>;


export type AdminReservedIdsQuery = { __typename?: 'Query', adminReservedIds?: { __typename?: 'AdminReservedIds', idOnHold?: string | null, idOnHoldExpiresAt?: any | null, reservedIds?: Array<{ __typename?: 'AdminReservedId', id?: number | null, membershipId?: string | null, onHoldExpiresAt?: any | null, onHoldFor?: string | null, status?: ReservedIdStatus | null, updatedAt?: any | null } | null> | null } | null };

export type SelfUpdateMutationVariables = Exact<{
  input: SelfUpdateInput;
}>;


export type SelfUpdateMutation = { __typename?: 'Mutation', selfUpdate: { __typename?: 'SelfUpdated', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, self: { __typename?: 'Self', createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } } };

export type SelfUpdatePasswordMutationVariables = Exact<{
  input: SelfUpdatePasswordInput;
}>;


export type SelfUpdatePasswordMutation = { __typename?: 'Mutation', selfUpdatePassword: SystemOperationStatus };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self?: { __typename?: 'Self', baseCountryCode?: CountryCode | null, createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } | null };

export type SelfBasicQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfBasicQuery = { __typename?: 'Query', self?: { __typename?: 'Self', baseCountryCode?: CountryCode | null, baseGmtOffset?: number | null, clubhouses?: Array<{ __typename?: 'SelfClubhouse', clubhouseCode: string, name: string } | null> | null, countries?: Array<{ __typename?: 'SelfCountry', countryCode: CountryCode, name: string } | null> | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } | null };

export type AdminNotificationCreateMutationVariables = Exact<{
  input: AdminNotificationCreateInput;
}>;


export type AdminNotificationCreateMutation = { __typename?: 'Mutation', adminNotificationCreate: SystemOperationStatus };

export type AdminNotificationDeleteMutationVariables = Exact<{
  input: AdminNotificationDeleteInput;
}>;


export type AdminNotificationDeleteMutation = { __typename?: 'Mutation', adminNotificationDelete: SystemOperationStatus };

export type AdminNotificationMemberDeleteMutationVariables = Exact<{
  input: AdminNotificationMemberDeleteInput;
}>;


export type AdminNotificationMemberDeleteMutation = { __typename?: 'Mutation', adminNotificationMemberDelete: SystemOperationStatus };

export type AdminMemberNotificationsQueryVariables = Exact<{
  args: AdminMemberNotificationsArgs;
}>;


export type AdminMemberNotificationsQuery = { __typename?: 'Query', adminMemberNotifications: { __typename?: 'AdminMemberNotificationResponse', edges?: Array<{ __typename?: 'AdminMemberNotificationEdge', cursor?: string | null, node?: { __typename?: 'AdminNotificationBasic', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, mode?: NotificationMode | null, title?: string | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminNotificationQueryVariables = Exact<{
  args: AdminNotificationArgs;
}>;


export type AdminNotificationQuery = { __typename?: 'Query', adminNotification: { __typename?: 'AdminNotification', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, mode?: NotificationMode | null, title?: string | null, updatedAt?: any | null } };

export type AdminNotificationsQueryVariables = Exact<{
  args: AdminNotificationsArgs;
}>;


export type AdminNotificationsQuery = { __typename?: 'Query', adminNotifications: { __typename?: 'AdminNotificationResponse', edges?: Array<{ __typename?: 'AdminNotificationEdge', cursor?: string | null, node?: { __typename?: 'AdminNotificationBasic', createdAt: any, createdBy?: CreatedBy | null, createdByAdminId?: string | null, createdByAdminName?: string | null, expiry?: boolean | null, expiryDate?: any | null, id: string, message: string, title?: string | null, updatedAt?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  input: AdminUpdateOrganizationInput;
}>;


export type AdminUpdateOrganizationMutation = { __typename?: 'Mutation', adminUpdateOrganization: { __typename?: 'Organization', addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, businessName?: string | null, createdAt?: any | null, email?: string | null, id: string, organizationNumber?: number | null, phoneNumber?: string | null, updatedAt?: any | null } };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', addressCity?: string | null, addressCountry?: string | null, addressPostalCode?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, businessName?: string | null, createdAt?: any | null, email?: string | null, id: string, organizationNumber?: number | null, phoneNumber?: string | null, updatedAt?: any | null } | null };

export type AdminUpdatePricingMutationVariables = Exact<{
  input: AdminUpdatePricingInput;
}>;


export type AdminUpdatePricingMutation = { __typename?: 'Mutation', adminUpdatePricing: { __typename?: 'Pricing', sgBayHourlyRate?: number | null, sgBayHourlyRateVIP?: number | null, sgBayMaxHours?: number | null, sgBayMaxPlayers?: number | null, sgBookingCancellationPenalty?: number | null, sgBookingLapsedPenalty?: number | null, sgHole18MaxHours?: number | null, sgHole18MaxPlayers?: number | null, sgHole18PerPlayerRate?: number | null, sgHole18PerPlayerRateVIP?: number | null, sgHole9MaxHours?: number | null, sgHole9MaxPlayers?: number | null, sgHole9PerPlayerRate?: number | null, sgHole9PerPlayerRateVIP?: number | null, sgLessonField?: number | null, sgLessonFieldVIP?: number | null, sgLessonIndoor?: number | null, sgLessonIndoorPuttingGreen?: number | null, sgLessonIndoorPuttingGreenVIP?: number | null, sgLessonIndoorVIP?: number | null, sgPrivateRoomHourlyRate?: number | null, sgPrivateRoomHourlyRateVIP?: number | null, sgPrivateRoomMaxHours?: number | null, sgPrivateRoomMaxPlayers?: number | null, sgPuttingGreenHourlyRate?: number | null, sgPuttingGreenHourlyRateVIP?: number | null, sgPuttingGreenMaxMins?: number | null, sgPuttingGreenMaxPlayers?: number | null, viBayHourlyRate?: number | null, viBayHourlyRateVIP?: number | null, viBayMaxHours?: number | null, viBayMaxPlayers?: number | null, viBookingCancellationPenalty?: number | null, viBookingLapsedPenalty?: number | null, viHole18MaxHours?: number | null, viHole18MaxPlayers?: number | null, viHole18PerPlayerRate?: number | null, viHole18PerPlayerRateVIP?: number | null, viHole9MaxHours?: number | null, viHole9MaxPlayers?: number | null, viHole9PerPlayerRate?: number | null, viHole9PerPlayerRateVIP?: number | null, viLessonField?: number | null, viLessonFieldVIP?: number | null, viLessonIndoor?: number | null, viLessonIndoorPuttingGreen?: number | null, viLessonIndoorPuttingGreenVIP?: number | null, viLessonIndoorVIP?: number | null, viPrivateRoomHourlyRate?: number | null, viPrivateRoomHourlyRateVIP?: number | null, viPrivateRoomMaxHours?: number | null, viPrivateRoomMaxPlayers?: number | null, viPuttingGreenHourlyRate?: number | null, viPuttingGreenHourlyRateVIP?: number | null, viPuttingGreenMaxMins?: number | null, viPuttingGreenMaxPlayers?: number | null } };

export type PricingQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingQuery = { __typename?: 'Query', pricing?: { __typename?: 'Pricing', sgBayHourlyRate?: number | null, sgBayHourlyRateVIP?: number | null, sgBayMaxHours?: number | null, sgBayMaxPlayers?: number | null, sgBookingCancellationPenalty?: number | null, sgBookingLapsedPenalty?: number | null, sgHole18MaxHours?: number | null, sgHole18MaxPlayers?: number | null, sgHole18PerPlayerRate?: number | null, sgHole18PerPlayerRateVIP?: number | null, sgHole9MaxHours?: number | null, sgHole9MaxPlayers?: number | null, sgHole9PerPlayerRate?: number | null, sgHole9PerPlayerRateVIP?: number | null, sgLessonField?: number | null, sgLessonFieldVIP?: number | null, sgLessonIndoor?: number | null, sgLessonIndoorPuttingGreen?: number | null, sgLessonIndoorPuttingGreenVIP?: number | null, sgLessonIndoorVIP?: number | null, sgPrivateRoomHourlyRate?: number | null, sgPrivateRoomHourlyRateVIP?: number | null, sgPrivateRoomMaxHours?: number | null, sgPrivateRoomMaxPlayers?: number | null, sgPuttingGreenHourlyRate?: number | null, sgPuttingGreenHourlyRateVIP?: number | null, sgPuttingGreenMaxMins?: number | null, sgPuttingGreenMaxPlayers?: number | null, viBayHourlyRate?: number | null, viBayHourlyRateVIP?: number | null, viBayMaxHours?: number | null, viBayMaxPlayers?: number | null, viBookingCancellationPenalty?: number | null, viBookingLapsedPenalty?: number | null, viHole18MaxHours?: number | null, viHole18MaxPlayers?: number | null, viHole18PerPlayerRate?: number | null, viHole18PerPlayerRateVIP?: number | null, viHole9MaxHours?: number | null, viHole9MaxPlayers?: number | null, viHole9PerPlayerRate?: number | null, viHole9PerPlayerRateVIP?: number | null, viLessonField?: number | null, viLessonFieldVIP?: number | null, viLessonIndoor?: number | null, viLessonIndoorPuttingGreen?: number | null, viLessonIndoorPuttingGreenVIP?: number | null, viLessonIndoorVIP?: number | null, viPrivateRoomHourlyRate?: number | null, viPrivateRoomHourlyRateVIP?: number | null, viPrivateRoomMaxHours?: number | null, viPrivateRoomMaxPlayers?: number | null, viPuttingGreenHourlyRate?: number | null, viPuttingGreenHourlyRateVIP?: number | null, viPuttingGreenMaxMins?: number | null, viPuttingGreenMaxPlayers?: number | null } | null };

export type AdminProductPackageAddMutationVariables = Exact<{
  input: AdminProductPackageAddInput;
}>;


export type AdminProductPackageAddMutation = { __typename?: 'Mutation', adminProductPackageAdd: SystemOperationStatus };

export type AdminProductPackageManageMutationVariables = Exact<{
  input: AdminProductPackageManageInput;
}>;


export type AdminProductPackageManageMutation = { __typename?: 'Mutation', adminProductPackageManage: SystemOperationStatus };

export type AdminProductsQueryVariables = Exact<{
  args: AdminProductsArgs;
}>;


export type AdminProductsQuery = { __typename?: 'Query', adminProducts: { __typename?: 'AdminProductResponse', edges?: Array<{ __typename?: 'AdminProductEdge', cursor?: string | null, node?: { __typename?: 'AdminProductBasic', baseCountryCode: CountryCode, itemCode: string, name: string, price?: number | null, validity?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminProductPackageExtensionsQueryVariables = Exact<{
  args: AdminProductPackageExtensionsArgs;
}>;


export type AdminProductPackageExtensionsQuery = { __typename?: 'Query', adminProductPackageExtensions: { __typename?: 'AdminProductPackageExtensions', extensions?: Array<{ __typename?: 'AdminProductPackageExtension', authorizedAdjusterName?: string | null, comment?: string | null, dateExtended?: any | null, daysAdded?: number | null, newExpiryDate?: any | null, prevExpiryDate?: any | null } | null> | null } };

export type AdminReportUpdateOrderConnectionMutationVariables = Exact<{
  input: AdminReportUpdateOrderConnectionInput;
}>;


export type AdminReportUpdateOrderConnectionMutation = { __typename?: 'Mutation', adminReportUpdateOrderConnection: SystemOperationStatus };

export type AdminReportOrderRecordStatusUpdateMutationVariables = Exact<{
  input: AdminReportOrderRecordStatusUpdateInput;
}>;


export type AdminReportOrderRecordStatusUpdateMutation = { __typename?: 'Mutation', adminReportOrderRecordStatusUpdate: { __typename?: 'AdminReportOrderRecordStatusUpdate', status?: OrderRecordUpdateStatus | null } };

export type AdminSimulatorUsageQueryVariables = Exact<{
  args: AdminSimulatorUsageArgs;
}>;


export type AdminSimulatorUsageQuery = { __typename?: 'Query', adminSimulatorUsage?: any | null };

export type AdminReportCreditTransactionsQueryVariables = Exact<{
  args: AdminReportCreditTransactionsArgs;
}>;


export type AdminReportCreditTransactionsQuery = { __typename?: 'Query', adminReportCreditTransactions: { __typename?: 'AdminReportCreditTransactionResponse', edges?: Array<{ __typename?: 'AdminReportCreditTransactionEdge', cursor?: string | null, node?: { __typename?: 'AdminReportCreditTransaction', amount: number, createdAt?: any | null, description?: string | null, id?: string | null, memberId?: string | null, membershipId?: string | null, type?: AceCoinTransactionType | null, member?: { __typename?: 'AdminReportCreditTransactionMember', firstName?: string | null, individualId?: string | null, lastName?: string | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportHitPayChargesQueryVariables = Exact<{
  args: AdminReportHitPayChargesArgs;
}>;


export type AdminReportHitPayChargesQuery = { __typename?: 'Query', adminReportHitPayCharges: { __typename?: 'AdminReportHitPayChargeResponse', edges?: Array<{ __typename?: 'AdminReportHitPayChargeEdge', cursor?: string | null, node?: { __typename?: 'AdminReportHitPayCharge', amount?: string | null, buyer_email?: string | null, buyer_name: string, buyer_phone?: string | null, created_at?: string | null, currency?: string | null, fees?: string | null, id: string, payment_method?: string | null, payment_type?: string | null, quantity: number, refunded_amount?: string | null, status: string, updated_at?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportMemberStatsQueryVariables = Exact<{
  args: AdminReportMemberStatsArgs;
}>;


export type AdminReportMemberStatsQuery = { __typename?: 'Query', adminReportMemberStats: { __typename?: 'AdminReportMemberStatResponse', edges?: Array<{ __typename?: 'AdminReportMemberStatEdge', cursor?: string | null, node?: { __typename?: 'AdminReportMemberStat', firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null, stat?: number | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminReportOrderQueryVariables = Exact<{
  args: AdminReportOrderArgs;
}>;


export type AdminReportOrderQuery = { __typename?: 'Query', adminReportOrder: { __typename?: 'Order', additionalDiscount?: number | null, date: any, discountPercent?: number | null, eMenuCustomerName?: string | null, eMenuMemberCardNo?: string | null, gst?: number | null, isEMenuOrder?: boolean | null, memberDiscount?: number | null, memberId?: string | null, memberIndividualId?: string | null, memberName?: string | null, membershipId?: string | null, metadata?: any | null, nonMemberCustomer?: boolean | null, orderNo: string, paymentCurrency?: PaymentCurrency | null, paymentMethod: string, serviceCharge?: number | null, subTotal?: number | null, total: number, venue?: string | null, lineItems: Array<{ __typename?: 'LineItem', brand?: string | null, category?: string | null, date: any, eMenuId?: number | null, id: string, itemCode?: string | null, itemName: string, mainCategory?: string | null, mCategoryId?: number | null, orderId?: number | null, price: number, qty: number, salesPrice: number, transactionId?: string | null, vendor?: string | null } | null> } };

export type AdminReportOrdersQueryVariables = Exact<{
  args: AdminReportOrdersArgs;
}>;


export type AdminReportOrdersQuery = { __typename?: 'Query', adminReportOrders: { __typename?: 'AdminReportOrderResponse', edges?: Array<{ __typename?: 'AdminReportOrderEdge', cursor?: string | null, node?: { __typename?: 'OrderBasic', date: any, eMenuCustomerName?: string | null, memberName?: string | null, metadata?: any | null, nonMemberCustomer: boolean, orderNo: string, paymentCurrency?: PaymentCurrency | null, paymentMethod: string, status: PaymentStatus, subTotal: number, total: number, venue?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'AdminReportOrderPageInfo', endCursor?: string | null, hasNextPage?: boolean | null, noOfNonConnectedOrders?: number | null, total?: number | null } | null } };

export type AdminReportSubscriptionsQueryVariables = Exact<{
  args: AdminReportSubscriptionsArgs;
}>;


export type AdminReportSubscriptionsQuery = { __typename?: 'Query', adminReportSubscriptions: { __typename?: 'AdminReportSubscriptionResponse', edges?: Array<{ __typename?: 'AdminReportSubscriptionEdge', cursor?: string | null, node?: { __typename?: 'AdminReportSubscription', amount?: number | null, creditDeducted?: boolean | null, description?: string | null, endDate?: any | null, id?: string | null, membershipId?: string | null, startDate?: any | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminClientLoginGuestMutationVariables = Exact<{
  input: AdminClientLoginGuestInput;
}>;


export type AdminClientLoginGuestMutation = { __typename?: 'Mutation', adminClientLoginGuest: SystemOperationStatus };

export type AdminExtendClientTimeMutationVariables = Exact<{
  input: AdminExtendClientTimeInput;
}>;


export type AdminExtendClientTimeMutation = { __typename?: 'Mutation', adminExtendClientTime: SystemOperationStatus };

export type AdminLockClientMutationVariables = Exact<{
  input: AdminLockClientInput;
}>;


export type AdminLockClientMutation = { __typename?: 'Mutation', adminLockClient: SystemOperationStatus };

export type AdminShopSendNotificationMutationVariables = Exact<{
  input: AdminShopSendNotificationInput;
}>;


export type AdminShopSendNotificationMutation = { __typename?: 'Mutation', adminShopSendNotification: SystemOperationStatus };

export type AdminUnlockClientMutationVariables = Exact<{
  input: AdminUnlockClientInput;
}>;


export type AdminUnlockClientMutation = { __typename?: 'Mutation', adminUnlockClient: SystemOperationStatus };

export type AdminUpdateClientContentLimitMutationVariables = Exact<{
  input: AdminUpdateClientContentLimitInput;
}>;


export type AdminUpdateClientContentLimitMutation = { __typename?: 'Mutation', adminUpdateClientContentLimit: SystemOperationStatus };

export type AdminUpdateShopDetailsMutationVariables = Exact<{
  input: AdminUpdateShopDetailsInput;
}>;


export type AdminUpdateShopDetailsMutation = { __typename?: 'Mutation', adminUpdateShopDetails: { __typename?: 'AdminShopDetails', address1?: string | null, address2?: string | null, CDN?: string | null, country?: string | null, currency?: string | null, isEquipmentStorage?: boolean | null, isLeftHanded?: boolean | null, isParking?: boolean | null, isProLesson?: boolean | null, isShopCloseNextDay?: boolean | null, isSwingplate?: boolean | null, ownerEmail?: string | null, ownerMobilePhone?: string | null, ownerMobilePhoneCountry?: string | null, ownerName?: string | null, shopCloseTime?: string | null, shopGuid?: string | null, shopName?: string | null, shopOpenTime?: string | null, shopPhone?: string | null, zipcode?: string | null, clientType?: { __typename?: 'AdminShopDetailsClientType', lesson?: boolean | null, practice?: boolean | null, screen?: boolean | null } | null } };

export type AdminUpdateShopOptionsDrivingRangeMutationVariables = Exact<{
  input: AdminUpdateShopOptionsDrivingRangeInput;
}>;


export type AdminUpdateShopOptionsDrivingRangeMutation = { __typename?: 'Mutation', adminUpdateShopOptionsDrivingRange: { __typename?: 'AdminShopOptionsDrivingRange', courseId?: string | null, difficulty?: number | null, distanceUnit?: number | null, isBallTrajectory?: boolean | null, isFixedCamera?: boolean | null, isSwingVideo?: boolean | null, teeHeight?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminUpdateShopOptionsRealTimeMutationVariables = Exact<{
  input: AdminUpdateShopOptionsRealTimeInput;
}>;


export type AdminUpdateShopOptionsRealTimeMutation = { __typename?: 'Mutation', adminUpdateShopOptionsRealTime: { __typename?: 'AdminShopOptionsRealTime', drivingRangeTimeLimit?: number | null, gameHoleTypeLimit?: number | null, gameTypeLimit?: number | null, isContentLimit?: boolean | null, paymentType?: number | null, playerCountLimit?: number | null, usageTime?: number | null } };

export type AdminUpdateShopOptionsRoundMutationVariables = Exact<{
  input: AdminUpdateShopOptionsRoundInput;
}>;


export type AdminUpdateShopOptionsRoundMutation = { __typename?: 'Mutation', adminUpdateShopOptionsRound: { __typename?: 'AdminShopOptionsRound', concede?: number | null, distanceUnit?: number | null, greenLocation?: number | null, greenSpeed?: number | null, holeCupLocation?: number | null, isBestVideo?: boolean | null, isCaddyVoice?: boolean | null, isUseObHazardTee?: boolean | null, mulliganCount?: number | null, puttingLine?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminShopGetNotificationMutationVariables = Exact<{
  input: AdminShopGetNotificationInput;
}>;


export type AdminShopGetNotificationMutation = { __typename?: 'Mutation', adminShopGetNotification: { __typename?: 'AdminShopNotification', message: string } };

export type AdminGameHistoryQueryVariables = Exact<{
  args: AdminGameHistoryArgs;
}>;


export type AdminGameHistoryQuery = { __typename?: 'Query', adminGameHistory: { __typename?: 'AdminGameHistory', currentPage: number, maxPage: number, totalCount: number, list: Array<{ __typename?: 'AdminGameHistoryListItem', clientName: string, completeHoleCount: number, endTime?: number | null, gameRoundId: number, gameType: string, gameTypeCode: number, playerCount: number, startTime: number } | null> } };

export type AdminClientStatusQueryVariables = Exact<{
  args: AdminClientStatusArgs;
}>;


export type AdminClientStatusQuery = { __typename?: 'Query', adminClientStatus: { __typename?: 'ClientStatus', clients: any, shopGuid: string } };

export type AdminScoreCardQueryVariables = Exact<{
  args: AdminScoreCardArgs;
}>;


export type AdminScoreCardQuery = { __typename?: 'Query', adminScoreCard?: any | null };

export type AdminShopDetailsQueryVariables = Exact<{
  args: AdminShopDetailsArg;
}>;


export type AdminShopDetailsQuery = { __typename?: 'Query', adminShopDetails?: { __typename?: 'AdminShopDetails', address1?: string | null, address2?: string | null, CDN?: string | null, country?: string | null, currency?: string | null, isEquipmentStorage?: boolean | null, isLeftHanded?: boolean | null, isParking?: boolean | null, isProLesson?: boolean | null, isShopCloseNextDay?: boolean | null, isSwingplate?: boolean | null, ownerEmail?: string | null, ownerMobilePhone?: string | null, ownerMobilePhoneCountry?: string | null, ownerName?: string | null, shopCloseTime?: string | null, shopGuid?: string | null, shopName?: string | null, shopOpenTime?: string | null, shopPhone?: string | null, zipcode?: string | null, clientType?: { __typename?: 'AdminShopDetailsClientType', lesson?: boolean | null, practice?: boolean | null, screen?: boolean | null } | null } | null };

export type AdminShopOptionsDrivingRangeQueryVariables = Exact<{
  args: AdminShopOptionsDrivingRangeArgs;
}>;


export type AdminShopOptionsDrivingRangeQuery = { __typename?: 'Query', adminShopOptionsDrivingRange: { __typename?: 'AdminShopOptionsDrivingRange', courseId?: string | null, difficulty?: number | null, distanceUnit?: number | null, isBallTrajectory?: boolean | null, isFixedCamera?: boolean | null, isSwingVideo?: boolean | null, teeHeight?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type AdminShopOptionsRealTimeQueryVariables = Exact<{
  args: AdminShopOptionsRealTimeArgs;
}>;


export type AdminShopOptionsRealTimeQuery = { __typename?: 'Query', adminShopOptionsRealTime: { __typename?: 'AdminShopOptionsRealTime', drivingRangeTimeLimit?: number | null, gameHoleTypeLimit?: number | null, gameTypeLimit?: number | null, isContentLimit?: boolean | null, paymentType?: number | null, playerCountLimit?: number | null, usageTime?: number | null } };

export type AdminShopOptionsRoundQueryVariables = Exact<{
  args: AdminShopOptionsRoundArgs;
}>;


export type AdminShopOptionsRoundQuery = { __typename?: 'Query', adminShopOptionsRound: { __typename?: 'AdminShopOptionsRound', concede?: number | null, distanceUnit?: number | null, greenLocation?: number | null, greenSpeed?: number | null, holeCupLocation?: number | null, isBestVideo?: boolean | null, isCaddyVoice?: boolean | null, isUseObHazardTee?: boolean | null, mulliganCount?: number | null, puttingLine?: number | null, useSwingPlate?: number | null, windSpeed?: number | null } };

export type DevManagementSystemAdminNotificationSendMutationVariables = Exact<{
  input: DevManagementSystemAdminNotificationSendInput;
}>;


export type DevManagementSystemAdminNotificationSendMutation = { __typename?: 'Mutation', devManagementSystemAdminNotificationSend: SystemOperationStatus };

export type DevManagementSystemServerEnvironmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type DevManagementSystemServerEnvironmentsQuery = { __typename?: 'Query', devManagementSystemServerEnvironments: { __typename?: 'DevManagementSystemServerEnvironments', environments: any } };

export type DevManagementSystemServerStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type DevManagementSystemServerStatusMutation = { __typename?: 'Mutation', devManagementSystemServerStatus: { __typename?: 'DevManagementSystemServerStatus', dbService?: { __typename?: 'DevManagementSystemServerStatusDbService', envType?: DbServiceEnvType | null, url?: string | null } | null } };

export type DevManagementSystemAdminTelemetryRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DevManagementSystemAdminTelemetryRequestMutation = { __typename?: 'Mutation', devManagementSystemAdminTelemetryRequest: SystemOperationStatus };

export type DevManagementSystemAdminViewportReloadRequestMutationVariables = Exact<{
  input: DevManagementSystemAdminViewportReloadRequestInput;
}>;


export type DevManagementSystemAdminViewportReloadRequestMutation = { __typename?: 'Mutation', devManagementSystemAdminViewportReloadRequest: SystemOperationStatus };

export type DevManagementSystemUserTelemetrySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DevManagementSystemUserTelemetrySubscription = { __typename?: 'Subscription', devManagementSystemUserTelemetry?: { __typename?: 'DevManagementSystemUserTelemetry', eventId: string, pageName: string, resourceId?: string | null, resourceName?: string | null, resourceType?: UserTelemetryResourceType | null, ts: string, userId: string, userName: string, userProfileImageUrl?: string | null } | null };

export type AdminManagementSystemUserTelemetryMutationVariables = Exact<{
  input: AdminManagementSystemUserTelemetryInput;
}>;


export type AdminManagementSystemUserTelemetryMutation = { __typename?: 'Mutation', adminManagementSystemUserTelemetry: SystemOperationStatus };

export type AdminManagementSystemPropsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminManagementSystemPropsQuery = { __typename?: 'Query', adminManagementSystemProps: { __typename?: 'AdminManagementSystemProps', currentAppVersion: string } };

export type ManagementSystemSubscriptionVariables = Exact<{
  args: ManagementSystemArgs;
}>;


export type ManagementSystemSubscription = { __typename?: 'Subscription', managementSystem?: { __typename?: 'ManagementSystem', eventId: string, operation?: ManagementSystemPublishOperation | null, payload?: any | null, ref?: string | null, userId?: string | null, userName?: string | null, userProfileImageUrl?: string | null } | null };


export const AdminAdminUpdatePasswordDocument = gql`
    mutation AdminAdminUpdatePassword($input: AdminAdminUpdatePasswordInput!) {
  adminAdminUpdatePassword(input: $input)
}
    `;
export type AdminAdminUpdatePasswordMutationFn = Apollo.MutationFunction<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>;

/**
 * __useAdminAdminUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAdminAdminUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAdminUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAdminUpdatePasswordMutation, { data, loading, error }] = useAdminAdminUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAdminUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>(AdminAdminUpdatePasswordDocument, options);
      }
export type AdminAdminUpdatePasswordMutationHookResult = ReturnType<typeof useAdminAdminUpdatePasswordMutation>;
export type AdminAdminUpdatePasswordMutationResult = Apollo.MutationResult<AdminAdminUpdatePasswordMutation>;
export type AdminAdminUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AdminAdminUpdatePasswordMutation, AdminAdminUpdatePasswordMutationVariables>;
export const AdminCreateAdminDocument = gql`
    mutation AdminCreateAdmin($input: AdminCreateAdminInput!) {
  adminCreateAdmin(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    user {
      authorizedClubhouses
      email
      firstName
      lastName
      mobileNumber
      permissions
      profileImageUrl
      status
      userId
    }
  }
}
    `;
export type AdminCreateAdminMutationFn = Apollo.MutationFunction<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>;

/**
 * __useAdminCreateAdminMutation__
 *
 * To run a mutation, you first call `useAdminCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAdminMutation, { data, loading, error }] = useAdminCreateAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>(AdminCreateAdminDocument, options);
      }
export type AdminCreateAdminMutationHookResult = ReturnType<typeof useAdminCreateAdminMutation>;
export type AdminCreateAdminMutationResult = Apollo.MutationResult<AdminCreateAdminMutation>;
export type AdminCreateAdminMutationOptions = Apollo.BaseMutationOptions<AdminCreateAdminMutation, AdminCreateAdminMutationVariables>;
export const AdminDeleteAdminDocument = gql`
    mutation AdminDeleteAdmin($input: AdminDeleteAdminInput) {
  adminDeleteAdmin(input: $input)
}
    `;
export type AdminDeleteAdminMutationFn = Apollo.MutationFunction<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>;

/**
 * __useAdminDeleteAdminMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAdminMutation, { data, loading, error }] = useAdminDeleteAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>(AdminDeleteAdminDocument, options);
      }
export type AdminDeleteAdminMutationHookResult = ReturnType<typeof useAdminDeleteAdminMutation>;
export type AdminDeleteAdminMutationResult = Apollo.MutationResult<AdminDeleteAdminMutation>;
export type AdminDeleteAdminMutationOptions = Apollo.BaseMutationOptions<AdminDeleteAdminMutation, AdminDeleteAdminMutationVariables>;
export const AdminUpdateAdminDocument = gql`
    mutation AdminUpdateAdmin($args: AdminUpdateAdminArgs!, $input: AdminUpdateAdminInput!) {
  adminUpdateAdmin(args: $args, input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    user {
      authorizedClubhouses
      baseCountryCode
      createdAt
      displayName
      email
      firstName
      gender
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organization {
        businessName
        clubhouses {
          clubhouseCode
          name
        }
        id
      }
      permissions
      profileImageUrl
      status
      updatedAt
      userId
      userType
    }
  }
}
    `;
export type AdminUpdateAdminMutationFn = Apollo.MutationFunction<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>;

/**
 * __useAdminUpdateAdminMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAdminMutation, { data, loading, error }] = useAdminUpdateAdminMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateAdminMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>(AdminUpdateAdminDocument, options);
      }
export type AdminUpdateAdminMutationHookResult = ReturnType<typeof useAdminUpdateAdminMutation>;
export type AdminUpdateAdminMutationResult = Apollo.MutationResult<AdminUpdateAdminMutation>;
export type AdminUpdateAdminMutationOptions = Apollo.BaseMutationOptions<AdminUpdateAdminMutation, AdminUpdateAdminMutationVariables>;
export const AdminResendOnboardingEmailDocument = gql`
    mutation AdminResendOnboardingEmail($input: AdminResendOnboardingEmailInput!) {
  adminResendOnboardingEmail(input: $input)
}
    `;
export type AdminResendOnboardingEmailMutationFn = Apollo.MutationFunction<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>;

/**
 * __useAdminResendOnboardingEmailMutation__
 *
 * To run a mutation, you first call `useAdminResendOnboardingEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResendOnboardingEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResendOnboardingEmailMutation, { data, loading, error }] = useAdminResendOnboardingEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminResendOnboardingEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>(AdminResendOnboardingEmailDocument, options);
      }
export type AdminResendOnboardingEmailMutationHookResult = ReturnType<typeof useAdminResendOnboardingEmailMutation>;
export type AdminResendOnboardingEmailMutationResult = Apollo.MutationResult<AdminResendOnboardingEmailMutation>;
export type AdminResendOnboardingEmailMutationOptions = Apollo.BaseMutationOptions<AdminResendOnboardingEmailMutation, AdminResendOnboardingEmailMutationVariables>;
export const FormHelperNewAdminDocument = gql`
    query FormHelperNewAdmin($args: FormHelperNewAdminArgs!) {
  formHelperNewAdmin(args: $args) {
    clubhouses {
      clubhouseCode
      clubhouseId
      name
    }
  }
}
    `;

/**
 * __useFormHelperNewAdminQuery__
 *
 * To run a query within a React component, call `useFormHelperNewAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewAdminQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>(FormHelperNewAdminDocument, options);
      }
export function useFormHelperNewAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>(FormHelperNewAdminDocument, options);
        }
export type FormHelperNewAdminQueryHookResult = ReturnType<typeof useFormHelperNewAdminQuery>;
export type FormHelperNewAdminLazyQueryHookResult = ReturnType<typeof useFormHelperNewAdminLazyQuery>;
export type FormHelperNewAdminQueryResult = Apollo.QueryResult<FormHelperNewAdminQuery, FormHelperNewAdminQueryVariables>;
export const AdminsDocument = gql`
    query Admins($args: AdminsArgs!) {
  admins(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        createdAt
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
        userType
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminsQuery__
 *
 * To run a query within a React component, call `useAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminsQuery(baseOptions: Apollo.QueryHookOptions<AdminsQuery, AdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminsQuery, AdminsQueryVariables>(AdminsDocument, options);
      }
export function useAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminsQuery, AdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminsQuery, AdminsQueryVariables>(AdminsDocument, options);
        }
export type AdminsQueryHookResult = ReturnType<typeof useAdminsQuery>;
export type AdminsLazyQueryHookResult = ReturnType<typeof useAdminsLazyQuery>;
export type AdminsQueryResult = Apollo.QueryResult<AdminsQuery, AdminsQueryVariables>;
export const AdminDocument = gql`
    query Admin($args: AdminArgs!) {
  admin(args: $args) {
    authorizedClubhouses
    baseCountryCode
    createdAt
    displayName
    email
    firstName
    gender
    lastAccessTokenDate
    lastLogin {
      city
      ipAddress
      time
    }
    lastLoginDate
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organization {
      businessName
      clubhouses {
        clubhouseCode
        name
      }
      id
    }
    permissions
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useAdminQuery__
 *
 * To run a query within a React component, call `useAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminQuery(baseOptions: Apollo.QueryHookOptions<AdminQuery, AdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
      }
export function useAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuery, AdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
        }
export type AdminQueryHookResult = ReturnType<typeof useAdminQuery>;
export type AdminLazyQueryHookResult = ReturnType<typeof useAdminLazyQuery>;
export type AdminQueryResult = Apollo.QueryResult<AdminQuery, AdminQueryVariables>;
export const AdminBookingCancelDocument = gql`
    mutation AdminBookingCancel($input: AdminBookingCancelInput!) {
  adminBookingCancel(input: $input)
}
    `;
export type AdminBookingCancelMutationFn = Apollo.MutationFunction<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;

/**
 * __useAdminBookingCancelMutation__
 *
 * To run a mutation, you first call `useAdminBookingCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingCancelMutation, { data, loading, error }] = useAdminBookingCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingCancelMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>(AdminBookingCancelDocument, options);
      }
export type AdminBookingCancelMutationHookResult = ReturnType<typeof useAdminBookingCancelMutation>;
export type AdminBookingCancelMutationResult = Apollo.MutationResult<AdminBookingCancelMutation>;
export type AdminBookingCancelMutationOptions = Apollo.BaseMutationOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;
export const AdminBookingSendCancellationNotificationDocument = gql`
    mutation AdminBookingSendCancellationNotification($input: AdminBookingSendCancellationNotificationInput!) {
  adminBookingSendCancellationNotification(input: $input)
}
    `;
export type AdminBookingSendCancellationNotificationMutationFn = Apollo.MutationFunction<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;

/**
 * __useAdminBookingSendCancellationNotificationMutation__
 *
 * To run a mutation, you first call `useAdminBookingSendCancellationNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingSendCancellationNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingSendCancellationNotificationMutation, { data, loading, error }] = useAdminBookingSendCancellationNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingSendCancellationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>(AdminBookingSendCancellationNotificationDocument, options);
      }
export type AdminBookingSendCancellationNotificationMutationHookResult = ReturnType<typeof useAdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationResult = Apollo.MutationResult<AdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationOptions = Apollo.BaseMutationOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;
export const AdminBookingGameCreateDocument = gql`
    mutation AdminBookingGameCreate($input: AdminBookingGameCreateInput!) {
  adminBookingGameCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingGameCreateMutationFn = Apollo.MutationFunction<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>;

/**
 * __useAdminBookingGameCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingGameCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingGameCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingGameCreateMutation, { data, loading, error }] = useAdminBookingGameCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingGameCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>(AdminBookingGameCreateDocument, options);
      }
export type AdminBookingGameCreateMutationHookResult = ReturnType<typeof useAdminBookingGameCreateMutation>;
export type AdminBookingGameCreateMutationResult = Apollo.MutationResult<AdminBookingGameCreateMutation>;
export type AdminBookingGameCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingGameCreateMutation, AdminBookingGameCreateMutationVariables>;
export const AdminBookingLessonIndoorCreateDocument = gql`
    mutation AdminBookingLessonIndoorCreate($input: AdminBookingLessonIndoorCreateInput!) {
  adminBookingLessonIndoorCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingLessonIndoorCreateMutationFn = Apollo.MutationFunction<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>;

/**
 * __useAdminBookingLessonIndoorCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingLessonIndoorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonIndoorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingLessonIndoorCreateMutation, { data, loading, error }] = useAdminBookingLessonIndoorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingLessonIndoorCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>(AdminBookingLessonIndoorCreateDocument, options);
      }
export type AdminBookingLessonIndoorCreateMutationHookResult = ReturnType<typeof useAdminBookingLessonIndoorCreateMutation>;
export type AdminBookingLessonIndoorCreateMutationResult = Apollo.MutationResult<AdminBookingLessonIndoorCreateMutation>;
export type AdminBookingLessonIndoorCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingLessonIndoorCreateMutation, AdminBookingLessonIndoorCreateMutationVariables>;
export const AdminBookingLessonOutdoorCreateDocument = gql`
    mutation AdminBookingLessonOutdoorCreate($input: AdminBookingLessonOutdoorCreateInput!) {
  adminBookingLessonOutdoorCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingLessonOutdoorCreateMutationFn = Apollo.MutationFunction<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>;

/**
 * __useAdminBookingLessonOutdoorCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingLessonOutdoorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonOutdoorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingLessonOutdoorCreateMutation, { data, loading, error }] = useAdminBookingLessonOutdoorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingLessonOutdoorCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>(AdminBookingLessonOutdoorCreateDocument, options);
      }
export type AdminBookingLessonOutdoorCreateMutationHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCreateMutation>;
export type AdminBookingLessonOutdoorCreateMutationResult = Apollo.MutationResult<AdminBookingLessonOutdoorCreateMutation>;
export type AdminBookingLessonOutdoorCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingLessonOutdoorCreateMutation, AdminBookingLessonOutdoorCreateMutationVariables>;
export const AdminBookingPractiseCreateDocument = gql`
    mutation AdminBookingPractiseCreate($input: AdminBookingPractiseCreateInput!) {
  adminBookingPractiseCreate(input: $input) {
    bookingId
    status
  }
}
    `;
export type AdminBookingPractiseCreateMutationFn = Apollo.MutationFunction<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>;

/**
 * __useAdminBookingPractiseCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingPractiseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingPractiseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingPractiseCreateMutation, { data, loading, error }] = useAdminBookingPractiseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingPractiseCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>(AdminBookingPractiseCreateDocument, options);
      }
export type AdminBookingPractiseCreateMutationHookResult = ReturnType<typeof useAdminBookingPractiseCreateMutation>;
export type AdminBookingPractiseCreateMutationResult = Apollo.MutationResult<AdminBookingPractiseCreateMutation>;
export type AdminBookingPractiseCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingPractiseCreateMutation, AdminBookingPractiseCreateMutationVariables>;
export const AdminBookingBlackoutCreateDocument = gql`
    mutation AdminBookingBlackoutCreate($input: AdminBookingBlackoutCreateInput!) {
  adminBookingBlackoutCreate(input: $input) {
    errorMessage
    isCreateAllowed
  }
}
    `;
export type AdminBookingBlackoutCreateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>;

/**
 * __useAdminBookingBlackoutCreateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutCreateMutation, { data, loading, error }] = useAdminBookingBlackoutCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>(AdminBookingBlackoutCreateDocument, options);
      }
export type AdminBookingBlackoutCreateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutCreateMutation>;
export type AdminBookingBlackoutCreateMutationResult = Apollo.MutationResult<AdminBookingBlackoutCreateMutation>;
export type AdminBookingBlackoutCreateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutCreateMutation, AdminBookingBlackoutCreateMutationVariables>;
export const AdminBookingBlackoutClubhouseUpdateDocument = gql`
    mutation AdminBookingBlackoutClubhouseUpdate($input: AdminBookingBlackoutClubhouseUpdateInput!) {
  adminBookingBlackoutClubhouseUpdate(input: $input) {
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;
export type AdminBookingBlackoutClubhouseUpdateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>;

/**
 * __useAdminBookingBlackoutClubhouseUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutClubhouseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutClubhouseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutClubhouseUpdateMutation, { data, loading, error }] = useAdminBookingBlackoutClubhouseUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutClubhouseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>(AdminBookingBlackoutClubhouseUpdateDocument, options);
      }
export type AdminBookingBlackoutClubhouseUpdateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseUpdateMutation>;
export type AdminBookingBlackoutClubhouseUpdateMutationResult = Apollo.MutationResult<AdminBookingBlackoutClubhouseUpdateMutation>;
export type AdminBookingBlackoutClubhouseUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutClubhouseUpdateMutation, AdminBookingBlackoutClubhouseUpdateMutationVariables>;
export const AdminBookingBlackoutCoachUpdateDocument = gql`
    mutation AdminBookingBlackoutCoachUpdate($input: AdminBookingBlackoutCoachUpdateInput!) {
  adminBookingBlackoutCoachUpdate(input: $input) {
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    coachDisplayName
    coachSlug
    date
    isDayBlocked
  }
}
    `;
export type AdminBookingBlackoutCoachUpdateMutationFn = Apollo.MutationFunction<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>;

/**
 * __useAdminBookingBlackoutCoachUpdateMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutCoachUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCoachUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutCoachUpdateMutation, { data, loading, error }] = useAdminBookingBlackoutCoachUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutCoachUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>(AdminBookingBlackoutCoachUpdateDocument, options);
      }
export type AdminBookingBlackoutCoachUpdateMutationHookResult = ReturnType<typeof useAdminBookingBlackoutCoachUpdateMutation>;
export type AdminBookingBlackoutCoachUpdateMutationResult = Apollo.MutationResult<AdminBookingBlackoutCoachUpdateMutation>;
export type AdminBookingBlackoutCoachUpdateMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutCoachUpdateMutation, AdminBookingBlackoutCoachUpdateMutationVariables>;
export const AdminBookingBlackoutDeleteDocument = gql`
    mutation AdminBookingBlackoutDelete($input: AdminBookingBlackoutDeleteInput!) {
  adminBookingBlackoutDelete(input: $input)
}
    `;
export type AdminBookingBlackoutDeleteMutationFn = Apollo.MutationFunction<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>;

/**
 * __useAdminBookingBlackoutDeleteMutation__
 *
 * To run a mutation, you first call `useAdminBookingBlackoutDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingBlackoutDeleteMutation, { data, loading, error }] = useAdminBookingBlackoutDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingBlackoutDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>(AdminBookingBlackoutDeleteDocument, options);
      }
export type AdminBookingBlackoutDeleteMutationHookResult = ReturnType<typeof useAdminBookingBlackoutDeleteMutation>;
export type AdminBookingBlackoutDeleteMutationResult = Apollo.MutationResult<AdminBookingBlackoutDeleteMutation>;
export type AdminBookingBlackoutDeleteMutationOptions = Apollo.BaseMutationOptions<AdminBookingBlackoutDeleteMutation, AdminBookingBlackoutDeleteMutationVariables>;
export const AdminBookingCoachesDocument = gql`
    query AdminBookingCoaches {
  adminBookingCoaches {
    baseCountryCode
    coachPublished
    displayName
    profileImageUrl
    slug
    userId
  }
}
    `;

/**
 * __useAdminBookingCoachesQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminBookingCoachesQuery(baseOptions?: Apollo.QueryHookOptions<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>(AdminBookingCoachesDocument, options);
      }
export function useAdminBookingCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>(AdminBookingCoachesDocument, options);
        }
export type AdminBookingCoachesQueryHookResult = ReturnType<typeof useAdminBookingCoachesQuery>;
export type AdminBookingCoachesLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachesLazyQuery>;
export type AdminBookingCoachesQueryResult = Apollo.QueryResult<AdminBookingCoachesQuery, AdminBookingCoachesQueryVariables>;
export const AdminBookingCoachAvailabilityCalendarItemsDocument = gql`
    query AdminBookingCoachAvailabilityCalendarItems($args: AdminBookingCoachAvailabilityCalendarItemsArgs!) {
  adminBookingCoachAvailabilityCalendarItems(args: $args) {
    calendarItems {
      clubhouses
      date
      hasIndoorBooking
      hasOutdoorBooking
      isBlocked
      isIndoorBookingFull
    }
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilityCalendarItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>(AdminBookingCoachAvailabilityCalendarItemsDocument, options);
      }
export function useAdminBookingCoachAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>(AdminBookingCoachAvailabilityCalendarItemsDocument, options);
        }
export type AdminBookingCoachAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityCalendarItemsQuery>;
export type AdminBookingCoachAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityCalendarItemsLazyQuery>;
export type AdminBookingCoachAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilityCalendarItemsQuery, AdminBookingCoachAvailabilityCalendarItemsQueryVariables>;
export const AdminBookingCoachAvailabilityDayItemDocument = gql`
    query AdminBookingCoachAvailabilityDayItem($args: AdminBookingCoachAvailabilityDayItemArgs!) {
  adminBookingCoachAvailabilityDayItem(args: $args) {
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    blockedClubhousesDay
    blockedClubhousesHours
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    date
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>(AdminBookingCoachAvailabilityDayItemDocument, options);
      }
export function useAdminBookingCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>(AdminBookingCoachAvailabilityDayItemDocument, options);
        }
export type AdminBookingCoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityDayItemQuery>;
export type AdminBookingCoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilityDayItemLazyQuery>;
export type AdminBookingCoachAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilityDayItemQuery, AdminBookingCoachAvailabilityDayItemQueryVariables>;
export const AdminBookingCoachAvailabilitySlotItemDocument = gql`
    query AdminBookingCoachAvailabilitySlotItem($args: AdminBookingCoachAvailabilitySlotItemArgs!) {
  adminBookingCoachAvailabilitySlotItem(args: $args) {
    hr1 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr2 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
  }
}
    `;

/**
 * __useAdminBookingCoachAvailabilitySlotItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCoachAvailabilitySlotItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCoachAvailabilitySlotItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCoachAvailabilitySlotItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCoachAvailabilitySlotItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>(AdminBookingCoachAvailabilitySlotItemDocument, options);
      }
export function useAdminBookingCoachAvailabilitySlotItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>(AdminBookingCoachAvailabilitySlotItemDocument, options);
        }
export type AdminBookingCoachAvailabilitySlotItemQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilitySlotItemQuery>;
export type AdminBookingCoachAvailabilitySlotItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCoachAvailabilitySlotItemLazyQuery>;
export type AdminBookingCoachAvailabilitySlotItemQueryResult = Apollo.QueryResult<AdminBookingCoachAvailabilitySlotItemQuery, AdminBookingCoachAvailabilitySlotItemQueryVariables>;
export const AdminBookingFacilityAvailabilityDayItemDocument = gql`
    query AdminBookingFacilityAvailabilityDayItem($args: AdminBookingFacilityAvailabilityDayItemArgs!) {
  adminBookingFacilityAvailabilityDayItem(args: $args) {
    nonPutting {
      na0900
      na1000
      na1100
      na1200
      na1300
      na1400
      na1500
      na1600
      na1700
      na1800
      na1900
      na2000
    }
    putting {
      na0900
      na0930
      na1000
      na1030
      na1100
      na1130
      na1200
      na1230
      na1300
      na1330
      na1400
      na1430
      na1500
      na1530
      na1600
      na1630
      na1700
      na1730
      na1800
      na1830
      na1900
      na1930
      na2000
      na2030
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>(AdminBookingFacilityAvailabilityDayItemDocument, options);
      }
export function useAdminBookingFacilityAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>(AdminBookingFacilityAvailabilityDayItemDocument, options);
        }
export type AdminBookingFacilityAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityDayItemQuery>;
export type AdminBookingFacilityAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityDayItemLazyQuery>;
export type AdminBookingFacilityAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilityDayItemQuery, AdminBookingFacilityAvailabilityDayItemQueryVariables>;
export const AdminBookingFacilityAvailabilitySlotItemDocument = gql`
    query AdminBookingFacilityAvailabilitySlotItem($args: AdminBookingFacilityAvailabilitySlotItemArgs!) {
  adminBookingFacilityAvailabilitySlotItem(args: $args) {
    hr1 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr2 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr3 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr4 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    hr5 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    putting30 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
    putting60 {
      bays {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      puttings {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      rooms {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
      studios {
        clubhouseCode
        facilityCode
        facilityName
        facilityType
      }
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilitySlotItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilitySlotItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilitySlotItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilitySlotItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilitySlotItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>(AdminBookingFacilityAvailabilitySlotItemDocument, options);
      }
export function useAdminBookingFacilityAvailabilitySlotItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>(AdminBookingFacilityAvailabilitySlotItemDocument, options);
        }
export type AdminBookingFacilityAvailabilitySlotItemQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilitySlotItemQuery>;
export type AdminBookingFacilityAvailabilitySlotItemLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilitySlotItemLazyQuery>;
export type AdminBookingFacilityAvailabilitySlotItemQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilitySlotItemQuery, AdminBookingFacilityAvailabilitySlotItemQueryVariables>;
export const AdminBookingFacilityAvailabilityCalendarItemsDocument = gql`
    query AdminBookingFacilityAvailabilityCalendarItems($args: AdminBookingFacilityAvailabilityCalendarItemsArgs!) {
  adminBookingFacilityAvailabilityCalendarItems(args: $args) {
    calendarItems {
      date
      isBlocked
    }
  }
}
    `;

/**
 * __useAdminBookingFacilityAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminBookingFacilityAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingFacilityAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingFacilityAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingFacilityAvailabilityCalendarItemsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>(AdminBookingFacilityAvailabilityCalendarItemsDocument, options);
      }
export function useAdminBookingFacilityAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>(AdminBookingFacilityAvailabilityCalendarItemsDocument, options);
        }
export type AdminBookingFacilityAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityCalendarItemsQuery>;
export type AdminBookingFacilityAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminBookingFacilityAvailabilityCalendarItemsLazyQuery>;
export type AdminBookingFacilityAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminBookingFacilityAvailabilityCalendarItemsQuery, AdminBookingFacilityAvailabilityCalendarItemsQueryVariables>;
export const AdminCoachCombinedAvailabilityDocument = gql`
    query AdminCoachCombinedAvailability($args: AdminCoachCombinedAvailabilityArgs!) {
  adminCoachCombinedAvailability(args: $args) {
    coachId
    coachSlug
    dateObjs {
      clubhouses
      date
      hasIndoorBooking
      hasOutdoorBooking
      isDayBlocked
    }
    name
  }
}
    `;

/**
 * __useAdminCoachCombinedAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminCoachCombinedAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachCombinedAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachCombinedAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachCombinedAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>(AdminCoachCombinedAvailabilityDocument, options);
      }
export function useAdminCoachCombinedAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>(AdminCoachCombinedAvailabilityDocument, options);
        }
export type AdminCoachCombinedAvailabilityQueryHookResult = ReturnType<typeof useAdminCoachCombinedAvailabilityQuery>;
export type AdminCoachCombinedAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminCoachCombinedAvailabilityLazyQuery>;
export type AdminCoachCombinedAvailabilityQueryResult = Apollo.QueryResult<AdminCoachCombinedAvailabilityQuery, AdminCoachCombinedAvailabilityQueryVariables>;
export const AdminClubhouseFacilityAvailabilityDocument = gql`
    query AdminClubhouseFacilityAvailability($args: AdminClubhouseFacilityAvailabilityArgs!) {
  adminClubhouseFacilityAvailability(args: $args) {
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;

/**
 * __useAdminClubhouseFacilityAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseFacilityAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseFacilityAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseFacilityAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseFacilityAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>(AdminClubhouseFacilityAvailabilityDocument, options);
      }
export function useAdminClubhouseFacilityAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>(AdminClubhouseFacilityAvailabilityDocument, options);
        }
export type AdminClubhouseFacilityAvailabilityQueryHookResult = ReturnType<typeof useAdminClubhouseFacilityAvailabilityQuery>;
export type AdminClubhouseFacilityAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminClubhouseFacilityAvailabilityLazyQuery>;
export type AdminClubhouseFacilityAvailabilityQueryResult = Apollo.QueryResult<AdminClubhouseFacilityAvailabilityQuery, AdminClubhouseFacilityAvailabilityQueryVariables>;
export const AdminBookingBlackoutClubhouseDocument = gql`
    query AdminBookingBlackoutClubhouse($args: AdminBookingBlackoutClubhouseArgs!) {
  adminBookingBlackoutClubhouse(args: $args) {
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    clubhouseCode
    date
    facilityObjs {
      availability {
        bi0900
        bi0930
        bi1000
        bi1030
        bi1100
        bi1130
        bi1200
        bi1230
        bi1300
        bi1330
        bi1400
        bi1430
        bi1500
        bi1530
        bi1600
        bi1630
        bi1700
        bi1730
        bi1800
        bi1830
        bi1900
        bi1930
        bi2000
        bi2030
      }
      facilityCode
      facilityName
      facilityType
    }
    isDayBlocked
    name
  }
}
    `;

/**
 * __useAdminBookingBlackoutClubhouseQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutClubhouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutClubhouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutClubhouseQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutClubhouseQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>(AdminBookingBlackoutClubhouseDocument, options);
      }
export function useAdminBookingBlackoutClubhouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>(AdminBookingBlackoutClubhouseDocument, options);
        }
export type AdminBookingBlackoutClubhouseQueryHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseQuery>;
export type AdminBookingBlackoutClubhouseLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutClubhouseLazyQuery>;
export type AdminBookingBlackoutClubhouseQueryResult = Apollo.QueryResult<AdminBookingBlackoutClubhouseQuery, AdminBookingBlackoutClubhouseQueryVariables>;
export const AdminBookingBlackoutCoachDocument = gql`
    query AdminBookingBlackoutCoach($args: AdminBookingBlackoutCoachArgs!) {
  adminBookingBlackoutCoach(args: $args) {
    block09
    block10
    block11
    block12
    block13
    block14
    block15
    block16
    block17
    block18
    block19
    block20
    coachDisplayName
    coachSlug
    date
    isDayBlocked
  }
}
    `;

/**
 * __useAdminBookingBlackoutCoachQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutCoachQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>(AdminBookingBlackoutCoachDocument, options);
      }
export function useAdminBookingBlackoutCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>(AdminBookingBlackoutCoachDocument, options);
        }
export type AdminBookingBlackoutCoachQueryHookResult = ReturnType<typeof useAdminBookingBlackoutCoachQuery>;
export type AdminBookingBlackoutCoachLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutCoachLazyQuery>;
export type AdminBookingBlackoutCoachQueryResult = Apollo.QueryResult<AdminBookingBlackoutCoachQuery, AdminBookingBlackoutCoachQueryVariables>;
export const AdminBookingBlackoutsDocument = gql`
    query AdminBookingBlackouts($args: AdminBookingBlackoutsArgs!) {
  adminBookingBlackouts(args: $args) {
    clubhouseCode
    clubhouseName
    coachDisplayName
    coachSlug
    countryCode
    date
    type
  }
}
    `;

/**
 * __useAdminBookingBlackoutsQuery__
 *
 * To run a query within a React component, call `useAdminBookingBlackoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBlackoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBlackoutsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBlackoutsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>(AdminBookingBlackoutsDocument, options);
      }
export function useAdminBookingBlackoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>(AdminBookingBlackoutsDocument, options);
        }
export type AdminBookingBlackoutsQueryHookResult = ReturnType<typeof useAdminBookingBlackoutsQuery>;
export type AdminBookingBlackoutsLazyQueryHookResult = ReturnType<typeof useAdminBookingBlackoutsLazyQuery>;
export type AdminBookingBlackoutsQueryResult = Apollo.QueryResult<AdminBookingBlackoutsQuery, AdminBookingBlackoutsQueryVariables>;
export const AdminBookingCombinedCoachAvailabilityDayItemDocument = gql`
    query AdminBookingCombinedCoachAvailabilityDayItem($args: AdminBookingCombinedCoachAvailabilityDayItemArgs!) {
  adminBookingCombinedCoachAvailabilityDayItem(args: $args) {
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    biOutdoor
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    date
    displayName
    hasOutdoorBooking
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
  }
}
    `;

/**
 * __useAdminBookingCombinedCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useAdminBookingCombinedCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCombinedCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingCombinedCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingCombinedCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>(AdminBookingCombinedCoachAvailabilityDayItemDocument, options);
      }
export function useAdminBookingCombinedCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>(AdminBookingCombinedCoachAvailabilityDayItemDocument, options);
        }
export type AdminBookingCombinedCoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useAdminBookingCombinedCoachAvailabilityDayItemQuery>;
export type AdminBookingCombinedCoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useAdminBookingCombinedCoachAvailabilityDayItemLazyQuery>;
export type AdminBookingCombinedCoachAvailabilityDayItemQueryResult = Apollo.QueryResult<AdminBookingCombinedCoachAvailabilityDayItemQuery, AdminBookingCombinedCoachAvailabilityDayItemQueryVariables>;
export const FormHelperBookingDocument = gql`
    query FormHelperBooking($args: FormHelperBookingArgs!) {
  formHelperBooking(args: $args) {
    clubhouses {
      clubhouseCode
      clubhouseId
      name
    }
  }
}
    `;

/**
 * __useFormHelperBookingQuery__
 *
 * To run a query within a React component, call `useFormHelperBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperBookingQuery(baseOptions: Apollo.QueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
      }
export function useFormHelperBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
        }
export type FormHelperBookingQueryHookResult = ReturnType<typeof useFormHelperBookingQuery>;
export type FormHelperBookingLazyQueryHookResult = ReturnType<typeof useFormHelperBookingLazyQuery>;
export type FormHelperBookingQueryResult = Apollo.QueryResult<FormHelperBookingQuery, FormHelperBookingQueryVariables>;
export const FormHelperNewBlackOutDocument = gql`
    query FormHelperNewBlackOut($args: FormHelperNewBlackOutArgs) {
  formHelperNewBlackOut(args: $args) {
    clubhouseCode
    date
    errorMessage
    facilities {
      facilityCode
      facilityName
      facilityType
    }
    isCreateAllowed
  }
}
    `;

/**
 * __useFormHelperNewBlackOutQuery__
 *
 * To run a query within a React component, call `useFormHelperNewBlackOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewBlackOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewBlackOutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewBlackOutQuery(baseOptions?: Apollo.QueryHookOptions<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>(FormHelperNewBlackOutDocument, options);
      }
export function useFormHelperNewBlackOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>(FormHelperNewBlackOutDocument, options);
        }
export type FormHelperNewBlackOutQueryHookResult = ReturnType<typeof useFormHelperNewBlackOutQuery>;
export type FormHelperNewBlackOutLazyQueryHookResult = ReturnType<typeof useFormHelperNewBlackOutLazyQuery>;
export type FormHelperNewBlackOutQueryResult = Apollo.QueryResult<FormHelperNewBlackOutQuery, FormHelperNewBlackOutQueryVariables>;
export const AdminBookingAvailabilityDocument = gql`
    query AdminBookingAvailability($args: AdminBookingAvailabilityArgs!) {
  adminBookingAvailability(args: $args)
}
    `;

/**
 * __useAdminBookingAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminBookingAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
      }
export function useAdminBookingAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
        }
export type AdminBookingAvailabilityQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityQuery>;
export type AdminBookingAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityLazyQuery>;
export type AdminBookingAvailabilityQueryResult = Apollo.QueryResult<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>;
export const AdminBookingDocument = gql`
    query AdminBooking($args: AdminBookingArgs!) {
  adminBooking(args: $args) {
    cancellationDateTime
    cancellationNotificationByAppSent
    cancellationNotificationByEmailSent
    cancellationNotificationBySmsSent
    cancellationNotificationMessage
    cancellationNotificationSentByAdminName
    cancellationNotificationSentDateTime
    cancellationReason
    cancelledBy
    cancelledByAdminName
    coachId
    coachName
    createdAt
    createdBy
    createdByAdminName
    date
    dateMonthStr
    dayOfWeekStr
    duration
    durationStr
    endTime
    endTimeStr
    fieldLessonDetails
    gameCourseType
    id
    lateCancellationDetails
    member
    memberIndividualId
    memberUuid
    noOfPlayers
    resourceName
    startTime
    startTimeStr
    status
    type
    venue
    yearStr
  }
}
    `;

/**
 * __useAdminBookingQuery__
 *
 * To run a query within a React component, call `useAdminBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
      }
export function useAdminBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
        }
export type AdminBookingQueryHookResult = ReturnType<typeof useAdminBookingQuery>;
export type AdminBookingLazyQueryHookResult = ReturnType<typeof useAdminBookingLazyQuery>;
export type AdminBookingQueryResult = Apollo.QueryResult<AdminBookingQuery, AdminBookingQueryVariables>;
export const AdminBookingBasicDocument = gql`
    query AdminBookingBasic($args: AdminBookingArgs!) {
  adminBooking(args: $args) {
    dateMonthStr
    dayOfWeekStr
    durationStr
    endTimeStr
    facilityType
    id
    member
    memberIndividualId
    resourceName
    startTimeStr
    venue
    yearStr
  }
}
    `;

/**
 * __useAdminBookingBasicQuery__
 *
 * To run a query within a React component, call `useAdminBookingBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingBasicQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingBasicQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>(AdminBookingBasicDocument, options);
      }
export function useAdminBookingBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>(AdminBookingBasicDocument, options);
        }
export type AdminBookingBasicQueryHookResult = ReturnType<typeof useAdminBookingBasicQuery>;
export type AdminBookingBasicLazyQueryHookResult = ReturnType<typeof useAdminBookingBasicLazyQuery>;
export type AdminBookingBasicQueryResult = Apollo.QueryResult<AdminBookingBasicQuery, AdminBookingBasicQueryVariables>;
export const AdminBookingsDocument = gql`
    query AdminBookings($args: AdminBookingsArgs!) {
  adminBookings(args: $args) {
    edges {
      cursor
      node {
        cancellationDateTime
        coachDisplayName
        date
        dateMonthStr
        dayOfWeekStr
        durationStr
        durationStr
        endTime
        endTimeStr
        gameCourseType
        id
        member {
          firstName
          lastName
        }
        resourceName
        startTime
        startTimeStr
        status
        type
        venue
        yearStr
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminBookingsQuery__
 *
 * To run a query within a React component, call `useAdminBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
      }
export function useAdminBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
        }
export type AdminBookingsQueryHookResult = ReturnType<typeof useAdminBookingsQuery>;
export type AdminBookingsLazyQueryHookResult = ReturnType<typeof useAdminBookingsLazyQuery>;
export type AdminBookingsQueryResult = Apollo.QueryResult<AdminBookingsQuery, AdminBookingsQueryVariables>;
export const AdminBookingGameCheckoutDocument = gql`
    query AdminBookingGameCheckout($args: AdminBookingGameCheckoutArgs!) {
  adminBookingGameCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingGameCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingGameCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingGameCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingGameCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingGameCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>(AdminBookingGameCheckoutDocument, options);
      }
export function useAdminBookingGameCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>(AdminBookingGameCheckoutDocument, options);
        }
export type AdminBookingGameCheckoutQueryHookResult = ReturnType<typeof useAdminBookingGameCheckoutQuery>;
export type AdminBookingGameCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingGameCheckoutLazyQuery>;
export type AdminBookingGameCheckoutQueryResult = Apollo.QueryResult<AdminBookingGameCheckoutQuery, AdminBookingGameCheckoutQueryVariables>;
export const AdminBookingLessonIndoorCheckoutDocument = gql`
    query AdminBookingLessonIndoorCheckout($args: AdminBookingLessonIndoorCheckoutArgs!) {
  adminBookingLessonIndoorCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingLessonIndoorCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingLessonIndoorCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonIndoorCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingLessonIndoorCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingLessonIndoorCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>(AdminBookingLessonIndoorCheckoutDocument, options);
      }
export function useAdminBookingLessonIndoorCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>(AdminBookingLessonIndoorCheckoutDocument, options);
        }
export type AdminBookingLessonIndoorCheckoutQueryHookResult = ReturnType<typeof useAdminBookingLessonIndoorCheckoutQuery>;
export type AdminBookingLessonIndoorCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingLessonIndoorCheckoutLazyQuery>;
export type AdminBookingLessonIndoorCheckoutQueryResult = Apollo.QueryResult<AdminBookingLessonIndoorCheckoutQuery, AdminBookingLessonIndoorCheckoutQueryVariables>;
export const AdminBookingLessonOutdoorCheckoutDocument = gql`
    query AdminBookingLessonOutdoorCheckout($args: AdminBookingLessonOutdoorCheckoutArgs!) {
  adminBookingLessonOutdoorCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingLessonOutdoorCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingLessonOutdoorCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLessonOutdoorCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingLessonOutdoorCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingLessonOutdoorCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>(AdminBookingLessonOutdoorCheckoutDocument, options);
      }
export function useAdminBookingLessonOutdoorCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>(AdminBookingLessonOutdoorCheckoutDocument, options);
        }
export type AdminBookingLessonOutdoorCheckoutQueryHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCheckoutQuery>;
export type AdminBookingLessonOutdoorCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingLessonOutdoorCheckoutLazyQuery>;
export type AdminBookingLessonOutdoorCheckoutQueryResult = Apollo.QueryResult<AdminBookingLessonOutdoorCheckoutQuery, AdminBookingLessonOutdoorCheckoutQueryVariables>;
export const AdminBookingPractiseCheckoutDocument = gql`
    query AdminBookingPractiseCheckout($args: AdminBookingPractiseCheckoutArgs!) {
  adminBookingPractiseCheckout(args: $args) {
    amountInAceCoins
    amountInCredit
    amountInLocalCurrency
    balanceBefore
    description
    rateInAceCoins
    rateInLocalCurrency
  }
}
    `;

/**
 * __useAdminBookingPractiseCheckoutQuery__
 *
 * To run a query within a React component, call `useAdminBookingPractiseCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingPractiseCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingPractiseCheckoutQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingPractiseCheckoutQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>(AdminBookingPractiseCheckoutDocument, options);
      }
export function useAdminBookingPractiseCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>(AdminBookingPractiseCheckoutDocument, options);
        }
export type AdminBookingPractiseCheckoutQueryHookResult = ReturnType<typeof useAdminBookingPractiseCheckoutQuery>;
export type AdminBookingPractiseCheckoutLazyQueryHookResult = ReturnType<typeof useAdminBookingPractiseCheckoutLazyQuery>;
export type AdminBookingPractiseCheckoutQueryResult = Apollo.QueryResult<AdminBookingPractiseCheckoutQuery, AdminBookingPractiseCheckoutQueryVariables>;
export const AdminBookingSettingsDocument = gql`
    query AdminBookingSettings($args: AdminBookingSettingsArgs!) {
  adminBookingSettings(args: $args) {
    cancellationConditions {
      GAME
      LESSON_FIELD
      LESSON_INDOOR
      LESSON_OUTDOOR
      PRACTISE
    }
  }
}
    `;

/**
 * __useAdminBookingSettingsQuery__
 *
 * To run a query within a React component, call `useAdminBookingSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingSettingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingSettingsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>(AdminBookingSettingsDocument, options);
      }
export function useAdminBookingSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>(AdminBookingSettingsDocument, options);
        }
export type AdminBookingSettingsQueryHookResult = ReturnType<typeof useAdminBookingSettingsQuery>;
export type AdminBookingSettingsLazyQueryHookResult = ReturnType<typeof useAdminBookingSettingsLazyQuery>;
export type AdminBookingSettingsQueryResult = Apollo.QueryResult<AdminBookingSettingsQuery, AdminBookingSettingsQueryVariables>;
export const AdminStaffsDocument = gql`
    query AdminStaffs($args: AdminStaffsArgs) {
  adminStaffs(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        createdAt
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminStaffsQuery__
 *
 * To run a query within a React component, call `useAdminStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStaffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStaffsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminStaffsQuery(baseOptions?: Apollo.QueryHookOptions<AdminStaffsQuery, AdminStaffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStaffsQuery, AdminStaffsQueryVariables>(AdminStaffsDocument, options);
      }
export function useAdminStaffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStaffsQuery, AdminStaffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStaffsQuery, AdminStaffsQueryVariables>(AdminStaffsDocument, options);
        }
export type AdminStaffsQueryHookResult = ReturnType<typeof useAdminStaffsQuery>;
export type AdminStaffsLazyQueryHookResult = ReturnType<typeof useAdminStaffsLazyQuery>;
export type AdminStaffsQueryResult = Apollo.QueryResult<AdminStaffsQuery, AdminStaffsQueryVariables>;
export const AdminClientSetupDocument = gql`
    mutation AdminClientSetup($input: AdminClientSetupInput!) {
  adminClientSetup(input: $input)
}
    `;
export type AdminClientSetupMutationFn = Apollo.MutationFunction<AdminClientSetupMutation, AdminClientSetupMutationVariables>;

/**
 * __useAdminClientSetupMutation__
 *
 * To run a mutation, you first call `useAdminClientSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminClientSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminClientSetupMutation, { data, loading, error }] = useAdminClientSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminClientSetupMutation(baseOptions?: Apollo.MutationHookOptions<AdminClientSetupMutation, AdminClientSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminClientSetupMutation, AdminClientSetupMutationVariables>(AdminClientSetupDocument, options);
      }
export type AdminClientSetupMutationHookResult = ReturnType<typeof useAdminClientSetupMutation>;
export type AdminClientSetupMutationResult = Apollo.MutationResult<AdminClientSetupMutation>;
export type AdminClientSetupMutationOptions = Apollo.BaseMutationOptions<AdminClientSetupMutation, AdminClientSetupMutationVariables>;
export const AdminUpdateFacilityDocument = gql`
    mutation AdminUpdateFacility($input: AdminUpdateFacilityInput!) {
  adminUpdateFacility(input: $input)
}
    `;
export type AdminUpdateFacilityMutationFn = Apollo.MutationFunction<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>;

/**
 * __useAdminUpdateFacilityMutation__
 *
 * To run a mutation, you first call `useAdminUpdateFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateFacilityMutation, { data, loading, error }] = useAdminUpdateFacilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateFacilityMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>(AdminUpdateFacilityDocument, options);
      }
export type AdminUpdateFacilityMutationHookResult = ReturnType<typeof useAdminUpdateFacilityMutation>;
export type AdminUpdateFacilityMutationResult = Apollo.MutationResult<AdminUpdateFacilityMutation>;
export type AdminUpdateFacilityMutationOptions = Apollo.BaseMutationOptions<AdminUpdateFacilityMutation, AdminUpdateFacilityMutationVariables>;
export const AdminClubhousesDocument = gql`
    query AdminClubhouses($args: AdminClubhousesArgs!) {
  adminClubhouses(args: $args) {
    edges {
      cursor
      node {
        addressCountry
        clubhouseCode
        clubhouseId
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminClubhousesQuery__
 *
 * To run a query within a React component, call `useAdminClubhousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhousesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhousesQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhousesQuery, AdminClubhousesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhousesQuery, AdminClubhousesQueryVariables>(AdminClubhousesDocument, options);
      }
export function useAdminClubhousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhousesQuery, AdminClubhousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhousesQuery, AdminClubhousesQueryVariables>(AdminClubhousesDocument, options);
        }
export type AdminClubhousesQueryHookResult = ReturnType<typeof useAdminClubhousesQuery>;
export type AdminClubhousesLazyQueryHookResult = ReturnType<typeof useAdminClubhousesLazyQuery>;
export type AdminClubhousesQueryResult = Apollo.QueryResult<AdminClubhousesQuery, AdminClubhousesQueryVariables>;
export const AdminClubhouseDocument = gql`
    query AdminClubhouse($args: AdminClubhouseArgs!) {
  adminClubhouse(args: $args) {
    addressCity
    addressCountry
    addressCountryIso
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    clubhouseCode
    clubhouseId
    colorCode
    createdAt
    email
    kGolfClientId
    kGolfClientSecret
    kGolfPassword
    kGolfShopGuid
    kGolfUsername
    name
    noOfPrivateRooms
    noOfPuttingGreen
    noOfSimulators
    organization {
      businessName
      id
    }
    organizationId
    phoneNumber
    updatedAt
  }
}
    `;

/**
 * __useAdminClubhouseQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseQuery, AdminClubhouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseQuery, AdminClubhouseQueryVariables>(AdminClubhouseDocument, options);
      }
export function useAdminClubhouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseQuery, AdminClubhouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseQuery, AdminClubhouseQueryVariables>(AdminClubhouseDocument, options);
        }
export type AdminClubhouseQueryHookResult = ReturnType<typeof useAdminClubhouseQuery>;
export type AdminClubhouseLazyQueryHookResult = ReturnType<typeof useAdminClubhouseLazyQuery>;
export type AdminClubhouseQueryResult = Apollo.QueryResult<AdminClubhouseQuery, AdminClubhouseQueryVariables>;
export const AdminClubhouseFacilitiesDocument = gql`
    query AdminClubhouseFacilities($args: AdminClubhouseFacilitiesArgs!) {
  adminClubhouseFacilities(args: $args) {
    clientGuid
    clientName
    clientOrder
    facilityCode
    facilityName
    facilityType
    id
  }
}
    `;

/**
 * __useAdminClubhouseFacilitiesQuery__
 *
 * To run a query within a React component, call `useAdminClubhouseFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClubhouseFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClubhouseFacilitiesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClubhouseFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>(AdminClubhouseFacilitiesDocument, options);
      }
export function useAdminClubhouseFacilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>(AdminClubhouseFacilitiesDocument, options);
        }
export type AdminClubhouseFacilitiesQueryHookResult = ReturnType<typeof useAdminClubhouseFacilitiesQuery>;
export type AdminClubhouseFacilitiesLazyQueryHookResult = ReturnType<typeof useAdminClubhouseFacilitiesLazyQuery>;
export type AdminClubhouseFacilitiesQueryResult = Apollo.QueryResult<AdminClubhouseFacilitiesQuery, AdminClubhouseFacilitiesQueryVariables>;
export const AdminDeleteCoachDocument = gql`
    mutation AdminDeleteCoach($input: AdminDeleteCoachInput) {
  adminDeleteCoach(input: $input)
}
    `;
export type AdminDeleteCoachMutationFn = Apollo.MutationFunction<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>;

/**
 * __useAdminDeleteCoachMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCoachMutation, { data, loading, error }] = useAdminDeleteCoachMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteCoachMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>(AdminDeleteCoachDocument, options);
      }
export type AdminDeleteCoachMutationHookResult = ReturnType<typeof useAdminDeleteCoachMutation>;
export type AdminDeleteCoachMutationResult = Apollo.MutationResult<AdminDeleteCoachMutation>;
export type AdminDeleteCoachMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCoachMutation, AdminDeleteCoachMutationVariables>;
export const AdminUpdateCoachBookableDocument = gql`
    mutation AdminUpdateCoachBookable($args: AdminUpdateCoachArgs!, $input: AdminUpdateCoachBookableInput!) {
  adminUpdateCoachBookable(args: $args, input: $input) {
    isBookable
  }
}
    `;
export type AdminUpdateCoachBookableMutationFn = Apollo.MutationFunction<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>;

/**
 * __useAdminUpdateCoachBookableMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCoachBookableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCoachBookableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCoachBookableMutation, { data, loading, error }] = useAdminUpdateCoachBookableMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCoachBookableMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>(AdminUpdateCoachBookableDocument, options);
      }
export type AdminUpdateCoachBookableMutationHookResult = ReturnType<typeof useAdminUpdateCoachBookableMutation>;
export type AdminUpdateCoachBookableMutationResult = Apollo.MutationResult<AdminUpdateCoachBookableMutation>;
export type AdminUpdateCoachBookableMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCoachBookableMutation, AdminUpdateCoachBookableMutationVariables>;
export const AdminUpdateCoachDocument = gql`
    mutation AdminUpdateCoach($args: AdminUpdateCoachArgs!, $input: AdminUpdateCoachInput!) {
  adminUpdateCoach(args: $args, input: $input) {
    coach {
      baseCountryCode
      coachBirthdate
      coachBirthPlace
      coachExperiences
      coachExpertise
      coachLanguages
      coachLevel
      coachListOrder
      coachPGANo
      coachPGAType
      coachPGAYear
      coachPublished
      createdAt
      displayName
      email
      firstName
      gender
      lastAccessTokenDate
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organization {
        businessName
        clubhouses {
          clubhouseCode
          name
        }
        id
      }
      profileImageUrl
      slug
      status
      updatedAt
      userId
      userType
    }
    fileUploadCredentials {
      fields
      signedUrl
    }
  }
}
    `;
export type AdminUpdateCoachMutationFn = Apollo.MutationFunction<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>;

/**
 * __useAdminUpdateCoachMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCoachMutation, { data, loading, error }] = useAdminUpdateCoachMutation({
 *   variables: {
 *      args: // value for 'args'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCoachMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>(AdminUpdateCoachDocument, options);
      }
export type AdminUpdateCoachMutationHookResult = ReturnType<typeof useAdminUpdateCoachMutation>;
export type AdminUpdateCoachMutationResult = Apollo.MutationResult<AdminUpdateCoachMutation>;
export type AdminUpdateCoachMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCoachMutation, AdminUpdateCoachMutationVariables>;
export const CoachAvailabilityDayUpsertDocument = gql`
    mutation CoachAvailabilityDayUpsert($input: CoachAvailabilityDayUpsertInput!) {
  coachAvailabilityDayUpsert(input: $input) {
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    date
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
  }
}
    `;
export type CoachAvailabilityDayUpsertMutationFn = Apollo.MutationFunction<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>;

/**
 * __useCoachAvailabilityDayUpsertMutation__
 *
 * To run a mutation, you first call `useCoachAvailabilityDayUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilityDayUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachAvailabilityDayUpsertMutation, { data, loading, error }] = useCoachAvailabilityDayUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachAvailabilityDayUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>(CoachAvailabilityDayUpsertDocument, options);
      }
export type CoachAvailabilityDayUpsertMutationHookResult = ReturnType<typeof useCoachAvailabilityDayUpsertMutation>;
export type CoachAvailabilityDayUpsertMutationResult = Apollo.MutationResult<CoachAvailabilityDayUpsertMutation>;
export type CoachAvailabilityDayUpsertMutationOptions = Apollo.BaseMutationOptions<CoachAvailabilityDayUpsertMutation, CoachAvailabilityDayUpsertMutationVariables>;
export const FormHelperNewCoachDocument = gql`
    query FormHelperNewCoach($args: FormHelperNewCoachArgs!) {
  formHelperNewCoach(args: $args) {
    countries
  }
}
    `;

/**
 * __useFormHelperNewCoachQuery__
 *
 * To run a query within a React component, call `useFormHelperNewCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewCoachQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>(FormHelperNewCoachDocument, options);
      }
export function useFormHelperNewCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>(FormHelperNewCoachDocument, options);
        }
export type FormHelperNewCoachQueryHookResult = ReturnType<typeof useFormHelperNewCoachQuery>;
export type FormHelperNewCoachLazyQueryHookResult = ReturnType<typeof useFormHelperNewCoachLazyQuery>;
export type FormHelperNewCoachQueryResult = Apollo.QueryResult<FormHelperNewCoachQuery, FormHelperNewCoachQueryVariables>;
export const AdminCoachDocument = gql`
    query AdminCoach($args: AdminCoachArgs!) {
  adminCoach(args: $args) {
    baseCountryCode
    clubhouses {
      clubhouseCode
      displayName
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    coachBirthdate
    coachBirthPlace
    coachExperiences
    coachExpertise
    coachLanguages
    coachLevel
    coachListOrder
    coachPGANo
    coachPGAType
    coachPGAYear
    coachPublished
    createdAt
    displayName
    email
    firstName
    gender
    lastAccessTokenDate
    lastLogin {
      city
      ipAddress
      time
    }
    lastLoginDate
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organization {
      businessName
      clubhouses {
        clubhouseCode
        name
      }
      id
    }
    profileImageUrl
    slug
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useAdminCoachQuery__
 *
 * To run a query within a React component, call `useAdminCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachQuery(baseOptions: Apollo.QueryHookOptions<AdminCoachQuery, AdminCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachQuery, AdminCoachQueryVariables>(AdminCoachDocument, options);
      }
export function useAdminCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachQuery, AdminCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachQuery, AdminCoachQueryVariables>(AdminCoachDocument, options);
        }
export type AdminCoachQueryHookResult = ReturnType<typeof useAdminCoachQuery>;
export type AdminCoachLazyQueryHookResult = ReturnType<typeof useAdminCoachLazyQuery>;
export type AdminCoachQueryResult = Apollo.QueryResult<AdminCoachQuery, AdminCoachQueryVariables>;
export const AdminCoachesDocument = gql`
    query AdminCoaches($args: AdminCoachesArgs) {
  adminCoaches(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        coachPublished
        createdAt
        displayName
        firstName
        lastAccessTokenDate
        lastLoginDate
        lastName
        organization {
          businessName
          clubhouses {
            clubhouseCode
            name
          }
          id
        }
        profileImageUrl
        status
        userId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminCoachesQuery__
 *
 * To run a query within a React component, call `useAdminCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachesQuery(baseOptions?: Apollo.QueryHookOptions<AdminCoachesQuery, AdminCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachesQuery, AdminCoachesQueryVariables>(AdminCoachesDocument, options);
      }
export function useAdminCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachesQuery, AdminCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachesQuery, AdminCoachesQueryVariables>(AdminCoachesDocument, options);
        }
export type AdminCoachesQueryHookResult = ReturnType<typeof useAdminCoachesQuery>;
export type AdminCoachesLazyQueryHookResult = ReturnType<typeof useAdminCoachesLazyQuery>;
export type AdminCoachesQueryResult = Apollo.QueryResult<AdminCoachesQuery, AdminCoachesQueryVariables>;
export const AdminCoachAvailabilityCalendarItemsDocument = gql`
    query AdminCoachAvailabilityCalendarItems($args: AdminCoachAvailabilityCalendarItemsArgs) {
  adminCoachAvailabilityCalendarItems(args: $args) {
    clubhouses
    date
    hasIndoorBooking
    hasOutdoorBooking
    isBlocked
    isIndoorBookingFull
  }
}
    `;

/**
 * __useAdminCoachAvailabilityCalendarItemsQuery__
 *
 * To run a query within a React component, call `useAdminCoachAvailabilityCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCoachAvailabilityCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCoachAvailabilityCalendarItemsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCoachAvailabilityCalendarItemsQuery(baseOptions?: Apollo.QueryHookOptions<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>(AdminCoachAvailabilityCalendarItemsDocument, options);
      }
export function useAdminCoachAvailabilityCalendarItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>(AdminCoachAvailabilityCalendarItemsDocument, options);
        }
export type AdminCoachAvailabilityCalendarItemsQueryHookResult = ReturnType<typeof useAdminCoachAvailabilityCalendarItemsQuery>;
export type AdminCoachAvailabilityCalendarItemsLazyQueryHookResult = ReturnType<typeof useAdminCoachAvailabilityCalendarItemsLazyQuery>;
export type AdminCoachAvailabilityCalendarItemsQueryResult = Apollo.QueryResult<AdminCoachAvailabilityCalendarItemsQuery, AdminCoachAvailabilityCalendarItemsQueryVariables>;
export const CoachAvailabilityDayItemDocument = gql`
    query CoachAvailabilityDayItem($args: CoachAvailabilityDayItemArgs!) {
  coachAvailabilityDayItem(args: $args) {
    bi0900
    bi1000
    bi1100
    bi1200
    bi1300
    bi1400
    bi1500
    bi1600
    bi1700
    bi1800
    bi1900
    bi2000
    biOutdoor
    bs0900
    bs1000
    bs1100
    bs1200
    bs1300
    bs1400
    bs1500
    bs1600
    bs1700
    bs1800
    bs1900
    bs2000
    date
    hasOutdoorBooking
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
  }
}
    `;

/**
 * __useCoachAvailabilityDayItemQuery__
 *
 * To run a query within a React component, call `useCoachAvailabilityDayItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilityDayItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachAvailabilityDayItemQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachAvailabilityDayItemQuery(baseOptions: Apollo.QueryHookOptions<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>(CoachAvailabilityDayItemDocument, options);
      }
export function useCoachAvailabilityDayItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>(CoachAvailabilityDayItemDocument, options);
        }
export type CoachAvailabilityDayItemQueryHookResult = ReturnType<typeof useCoachAvailabilityDayItemQuery>;
export type CoachAvailabilityDayItemLazyQueryHookResult = ReturnType<typeof useCoachAvailabilityDayItemLazyQuery>;
export type CoachAvailabilityDayItemQueryResult = Apollo.QueryResult<CoachAvailabilityDayItemQuery, CoachAvailabilityDayItemQueryVariables>;
export const DevGraphqlUtilityMutation1Document = gql`
    mutation DevGraphqlUtilityMutation1 {
  devGraphqlUtilityMutation1
}
    `;
export type DevGraphqlUtilityMutation1MutationFn = Apollo.MutationFunction<DevGraphqlUtilityMutation1Mutation, DevGraphqlUtilityMutation1MutationVariables>;

/**
 * __useDevGraphqlUtilityMutation1Mutation__
 *
 * To run a mutation, you first call `useDevGraphqlUtilityMutation1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityMutation1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devGraphqlUtilityMutation1Mutation, { data, loading, error }] = useDevGraphqlUtilityMutation1Mutation({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityMutation1Mutation(baseOptions?: Apollo.MutationHookOptions<DevGraphqlUtilityMutation1Mutation, DevGraphqlUtilityMutation1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevGraphqlUtilityMutation1Mutation, DevGraphqlUtilityMutation1MutationVariables>(DevGraphqlUtilityMutation1Document, options);
      }
export type DevGraphqlUtilityMutation1MutationHookResult = ReturnType<typeof useDevGraphqlUtilityMutation1Mutation>;
export type DevGraphqlUtilityMutation1MutationResult = Apollo.MutationResult<DevGraphqlUtilityMutation1Mutation>;
export type DevGraphqlUtilityMutation1MutationOptions = Apollo.BaseMutationOptions<DevGraphqlUtilityMutation1Mutation, DevGraphqlUtilityMutation1MutationVariables>;
export const DevGraphqlUtilityMutation2Document = gql`
    mutation DevGraphqlUtilityMutation2 {
  devGraphqlUtilityMutation2
}
    `;
export type DevGraphqlUtilityMutation2MutationFn = Apollo.MutationFunction<DevGraphqlUtilityMutation2Mutation, DevGraphqlUtilityMutation2MutationVariables>;

/**
 * __useDevGraphqlUtilityMutation2Mutation__
 *
 * To run a mutation, you first call `useDevGraphqlUtilityMutation2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityMutation2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devGraphqlUtilityMutation2Mutation, { data, loading, error }] = useDevGraphqlUtilityMutation2Mutation({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityMutation2Mutation(baseOptions?: Apollo.MutationHookOptions<DevGraphqlUtilityMutation2Mutation, DevGraphqlUtilityMutation2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevGraphqlUtilityMutation2Mutation, DevGraphqlUtilityMutation2MutationVariables>(DevGraphqlUtilityMutation2Document, options);
      }
export type DevGraphqlUtilityMutation2MutationHookResult = ReturnType<typeof useDevGraphqlUtilityMutation2Mutation>;
export type DevGraphqlUtilityMutation2MutationResult = Apollo.MutationResult<DevGraphqlUtilityMutation2Mutation>;
export type DevGraphqlUtilityMutation2MutationOptions = Apollo.BaseMutationOptions<DevGraphqlUtilityMutation2Mutation, DevGraphqlUtilityMutation2MutationVariables>;
export const DevGraphqlUtilityMutation3Document = gql`
    mutation DevGraphqlUtilityMutation3 {
  devGraphqlUtilityMutation3
}
    `;
export type DevGraphqlUtilityMutation3MutationFn = Apollo.MutationFunction<DevGraphqlUtilityMutation3Mutation, DevGraphqlUtilityMutation3MutationVariables>;

/**
 * __useDevGraphqlUtilityMutation3Mutation__
 *
 * To run a mutation, you first call `useDevGraphqlUtilityMutation3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityMutation3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devGraphqlUtilityMutation3Mutation, { data, loading, error }] = useDevGraphqlUtilityMutation3Mutation({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityMutation3Mutation(baseOptions?: Apollo.MutationHookOptions<DevGraphqlUtilityMutation3Mutation, DevGraphqlUtilityMutation3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevGraphqlUtilityMutation3Mutation, DevGraphqlUtilityMutation3MutationVariables>(DevGraphqlUtilityMutation3Document, options);
      }
export type DevGraphqlUtilityMutation3MutationHookResult = ReturnType<typeof useDevGraphqlUtilityMutation3Mutation>;
export type DevGraphqlUtilityMutation3MutationResult = Apollo.MutationResult<DevGraphqlUtilityMutation3Mutation>;
export type DevGraphqlUtilityMutation3MutationOptions = Apollo.BaseMutationOptions<DevGraphqlUtilityMutation3Mutation, DevGraphqlUtilityMutation3MutationVariables>;
export const DevGraphqlUtilityMutation4Document = gql`
    mutation DevGraphqlUtilityMutation4 {
  devGraphqlUtilityMutation4
}
    `;
export type DevGraphqlUtilityMutation4MutationFn = Apollo.MutationFunction<DevGraphqlUtilityMutation4Mutation, DevGraphqlUtilityMutation4MutationVariables>;

/**
 * __useDevGraphqlUtilityMutation4Mutation__
 *
 * To run a mutation, you first call `useDevGraphqlUtilityMutation4Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityMutation4Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devGraphqlUtilityMutation4Mutation, { data, loading, error }] = useDevGraphqlUtilityMutation4Mutation({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityMutation4Mutation(baseOptions?: Apollo.MutationHookOptions<DevGraphqlUtilityMutation4Mutation, DevGraphqlUtilityMutation4MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevGraphqlUtilityMutation4Mutation, DevGraphqlUtilityMutation4MutationVariables>(DevGraphqlUtilityMutation4Document, options);
      }
export type DevGraphqlUtilityMutation4MutationHookResult = ReturnType<typeof useDevGraphqlUtilityMutation4Mutation>;
export type DevGraphqlUtilityMutation4MutationResult = Apollo.MutationResult<DevGraphqlUtilityMutation4Mutation>;
export type DevGraphqlUtilityMutation4MutationOptions = Apollo.BaseMutationOptions<DevGraphqlUtilityMutation4Mutation, DevGraphqlUtilityMutation4MutationVariables>;
export const DevGraphqlUtilityQuery1Document = gql`
    query DevGraphqlUtilityQuery1 {
  devGraphqlUtilityQuery1
}
    `;

/**
 * __useDevGraphqlUtilityQuery1Query__
 *
 * To run a query within a React component, call `useDevGraphqlUtilityQuery1Query` and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityQuery1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevGraphqlUtilityQuery1Query({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityQuery1Query(baseOptions?: Apollo.QueryHookOptions<DevGraphqlUtilityQuery1Query, DevGraphqlUtilityQuery1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevGraphqlUtilityQuery1Query, DevGraphqlUtilityQuery1QueryVariables>(DevGraphqlUtilityQuery1Document, options);
      }
export function useDevGraphqlUtilityQuery1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevGraphqlUtilityQuery1Query, DevGraphqlUtilityQuery1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevGraphqlUtilityQuery1Query, DevGraphqlUtilityQuery1QueryVariables>(DevGraphqlUtilityQuery1Document, options);
        }
export type DevGraphqlUtilityQuery1QueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery1Query>;
export type DevGraphqlUtilityQuery1LazyQueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery1LazyQuery>;
export type DevGraphqlUtilityQuery1QueryResult = Apollo.QueryResult<DevGraphqlUtilityQuery1Query, DevGraphqlUtilityQuery1QueryVariables>;
export const DevGraphqlUtilityQuery2Document = gql`
    query DevGraphqlUtilityQuery2 {
  devGraphqlUtilityQuery2
}
    `;

/**
 * __useDevGraphqlUtilityQuery2Query__
 *
 * To run a query within a React component, call `useDevGraphqlUtilityQuery2Query` and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityQuery2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevGraphqlUtilityQuery2Query({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityQuery2Query(baseOptions?: Apollo.QueryHookOptions<DevGraphqlUtilityQuery2Query, DevGraphqlUtilityQuery2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevGraphqlUtilityQuery2Query, DevGraphqlUtilityQuery2QueryVariables>(DevGraphqlUtilityQuery2Document, options);
      }
export function useDevGraphqlUtilityQuery2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevGraphqlUtilityQuery2Query, DevGraphqlUtilityQuery2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevGraphqlUtilityQuery2Query, DevGraphqlUtilityQuery2QueryVariables>(DevGraphqlUtilityQuery2Document, options);
        }
export type DevGraphqlUtilityQuery2QueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery2Query>;
export type DevGraphqlUtilityQuery2LazyQueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery2LazyQuery>;
export type DevGraphqlUtilityQuery2QueryResult = Apollo.QueryResult<DevGraphqlUtilityQuery2Query, DevGraphqlUtilityQuery2QueryVariables>;
export const DevGraphqlUtilityQuery3Document = gql`
    query DevGraphqlUtilityQuery3 {
  devGraphqlUtilityQuery3
}
    `;

/**
 * __useDevGraphqlUtilityQuery3Query__
 *
 * To run a query within a React component, call `useDevGraphqlUtilityQuery3Query` and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityQuery3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevGraphqlUtilityQuery3Query({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityQuery3Query(baseOptions?: Apollo.QueryHookOptions<DevGraphqlUtilityQuery3Query, DevGraphqlUtilityQuery3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevGraphqlUtilityQuery3Query, DevGraphqlUtilityQuery3QueryVariables>(DevGraphqlUtilityQuery3Document, options);
      }
export function useDevGraphqlUtilityQuery3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevGraphqlUtilityQuery3Query, DevGraphqlUtilityQuery3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevGraphqlUtilityQuery3Query, DevGraphqlUtilityQuery3QueryVariables>(DevGraphqlUtilityQuery3Document, options);
        }
export type DevGraphqlUtilityQuery3QueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery3Query>;
export type DevGraphqlUtilityQuery3LazyQueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery3LazyQuery>;
export type DevGraphqlUtilityQuery3QueryResult = Apollo.QueryResult<DevGraphqlUtilityQuery3Query, DevGraphqlUtilityQuery3QueryVariables>;
export const DevGraphqlUtilityQuery4Document = gql`
    query DevGraphqlUtilityQuery4 {
  devGraphqlUtilityQuery4
}
    `;

/**
 * __useDevGraphqlUtilityQuery4Query__
 *
 * To run a query within a React component, call `useDevGraphqlUtilityQuery4Query` and pass it any options that fit your needs.
 * When your component renders, `useDevGraphqlUtilityQuery4Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevGraphqlUtilityQuery4Query({
 *   variables: {
 *   },
 * });
 */
export function useDevGraphqlUtilityQuery4Query(baseOptions?: Apollo.QueryHookOptions<DevGraphqlUtilityQuery4Query, DevGraphqlUtilityQuery4QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevGraphqlUtilityQuery4Query, DevGraphqlUtilityQuery4QueryVariables>(DevGraphqlUtilityQuery4Document, options);
      }
export function useDevGraphqlUtilityQuery4LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevGraphqlUtilityQuery4Query, DevGraphqlUtilityQuery4QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevGraphqlUtilityQuery4Query, DevGraphqlUtilityQuery4QueryVariables>(DevGraphqlUtilityQuery4Document, options);
        }
export type DevGraphqlUtilityQuery4QueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery4Query>;
export type DevGraphqlUtilityQuery4LazyQueryHookResult = ReturnType<typeof useDevGraphqlUtilityQuery4LazyQuery>;
export type DevGraphqlUtilityQuery4QueryResult = Apollo.QueryResult<DevGraphqlUtilityQuery4Query, DevGraphqlUtilityQuery4QueryVariables>;
export const DevEMenuImportOrdersDocument = gql`
    mutation DevEMenuImportOrders($input: DevEMenuImportOrdersInput!) {
  devEMenuImportOrders(input: $input)
}
    `;
export type DevEMenuImportOrdersMutationFn = Apollo.MutationFunction<DevEMenuImportOrdersMutation, DevEMenuImportOrdersMutationVariables>;

/**
 * __useDevEMenuImportOrdersMutation__
 *
 * To run a mutation, you first call `useDevEMenuImportOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevEMenuImportOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devEMenuImportOrdersMutation, { data, loading, error }] = useDevEMenuImportOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevEMenuImportOrdersMutation(baseOptions?: Apollo.MutationHookOptions<DevEMenuImportOrdersMutation, DevEMenuImportOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevEMenuImportOrdersMutation, DevEMenuImportOrdersMutationVariables>(DevEMenuImportOrdersDocument, options);
      }
export type DevEMenuImportOrdersMutationHookResult = ReturnType<typeof useDevEMenuImportOrdersMutation>;
export type DevEMenuImportOrdersMutationResult = Apollo.MutationResult<DevEMenuImportOrdersMutation>;
export type DevEMenuImportOrdersMutationOptions = Apollo.BaseMutationOptions<DevEMenuImportOrdersMutation, DevEMenuImportOrdersMutationVariables>;
export const DevEMenuMatchOrdersDocument = gql`
    mutation DevEMenuMatchOrders($input: DevEMenuMatchOrdersInput!) {
  devEMenuMatchOrders(input: $input) {
    numberOfOrdersMatched
  }
}
    `;
export type DevEMenuMatchOrdersMutationFn = Apollo.MutationFunction<DevEMenuMatchOrdersMutation, DevEMenuMatchOrdersMutationVariables>;

/**
 * __useDevEMenuMatchOrdersMutation__
 *
 * To run a mutation, you first call `useDevEMenuMatchOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevEMenuMatchOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devEMenuMatchOrdersMutation, { data, loading, error }] = useDevEMenuMatchOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevEMenuMatchOrdersMutation(baseOptions?: Apollo.MutationHookOptions<DevEMenuMatchOrdersMutation, DevEMenuMatchOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevEMenuMatchOrdersMutation, DevEMenuMatchOrdersMutationVariables>(DevEMenuMatchOrdersDocument, options);
      }
export type DevEMenuMatchOrdersMutationHookResult = ReturnType<typeof useDevEMenuMatchOrdersMutation>;
export type DevEMenuMatchOrdersMutationResult = Apollo.MutationResult<DevEMenuMatchOrdersMutation>;
export type DevEMenuMatchOrdersMutationOptions = Apollo.BaseMutationOptions<DevEMenuMatchOrdersMutation, DevEMenuMatchOrdersMutationVariables>;
export const DevEMenuUpsertCreditTransactionsDocument = gql`
    mutation DevEMenuUpsertCreditTransactions($input: DevEMenuUpsertCreditTransactionsInput) {
  devEMenuUpsertCreditTransactions(input: $input)
}
    `;
export type DevEMenuUpsertCreditTransactionsMutationFn = Apollo.MutationFunction<DevEMenuUpsertCreditTransactionsMutation, DevEMenuUpsertCreditTransactionsMutationVariables>;

/**
 * __useDevEMenuUpsertCreditTransactionsMutation__
 *
 * To run a mutation, you first call `useDevEMenuUpsertCreditTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevEMenuUpsertCreditTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devEMenuUpsertCreditTransactionsMutation, { data, loading, error }] = useDevEMenuUpsertCreditTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevEMenuUpsertCreditTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<DevEMenuUpsertCreditTransactionsMutation, DevEMenuUpsertCreditTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevEMenuUpsertCreditTransactionsMutation, DevEMenuUpsertCreditTransactionsMutationVariables>(DevEMenuUpsertCreditTransactionsDocument, options);
      }
export type DevEMenuUpsertCreditTransactionsMutationHookResult = ReturnType<typeof useDevEMenuUpsertCreditTransactionsMutation>;
export type DevEMenuUpsertCreditTransactionsMutationResult = Apollo.MutationResult<DevEMenuUpsertCreditTransactionsMutation>;
export type DevEMenuUpsertCreditTransactionsMutationOptions = Apollo.BaseMutationOptions<DevEMenuUpsertCreditTransactionsMutation, DevEMenuUpsertCreditTransactionsMutationVariables>;
export const DevKGolfMemberJoinDocument = gql`
    mutation DevKGolfMemberJoin {
  devKGolfMemberJoin {
    kGolfAccountCreationError
    kGolfPassword
    kGolfUserId
    nickname
  }
}
    `;
export type DevKGolfMemberJoinMutationFn = Apollo.MutationFunction<DevKGolfMemberJoinMutation, DevKGolfMemberJoinMutationVariables>;

/**
 * __useDevKGolfMemberJoinMutation__
 *
 * To run a mutation, you first call `useDevKGolfMemberJoinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevKGolfMemberJoinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devKGolfMemberJoinMutation, { data, loading, error }] = useDevKGolfMemberJoinMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevKGolfMemberJoinMutation(baseOptions?: Apollo.MutationHookOptions<DevKGolfMemberJoinMutation, DevKGolfMemberJoinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevKGolfMemberJoinMutation, DevKGolfMemberJoinMutationVariables>(DevKGolfMemberJoinDocument, options);
      }
export type DevKGolfMemberJoinMutationHookResult = ReturnType<typeof useDevKGolfMemberJoinMutation>;
export type DevKGolfMemberJoinMutationResult = Apollo.MutationResult<DevKGolfMemberJoinMutation>;
export type DevKGolfMemberJoinMutationOptions = Apollo.BaseMutationOptions<DevKGolfMemberJoinMutation, DevKGolfMemberJoinMutationVariables>;
export const DevKGolfMemberLoginDocument = gql`
    mutation DevKGolfMemberLogin {
  devKGolfMemberLogin {
    accessToken
    cdn
    ewxpiresIn
    gender
    guid
    nickname
    profilePath
    refreshToken
    scope
    tokenType
  }
}
    `;
export type DevKGolfMemberLoginMutationFn = Apollo.MutationFunction<DevKGolfMemberLoginMutation, DevKGolfMemberLoginMutationVariables>;

/**
 * __useDevKGolfMemberLoginMutation__
 *
 * To run a mutation, you first call `useDevKGolfMemberLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevKGolfMemberLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devKGolfMemberLoginMutation, { data, loading, error }] = useDevKGolfMemberLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevKGolfMemberLoginMutation(baseOptions?: Apollo.MutationHookOptions<DevKGolfMemberLoginMutation, DevKGolfMemberLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevKGolfMemberLoginMutation, DevKGolfMemberLoginMutationVariables>(DevKGolfMemberLoginDocument, options);
      }
export type DevKGolfMemberLoginMutationHookResult = ReturnType<typeof useDevKGolfMemberLoginMutation>;
export type DevKGolfMemberLoginMutationResult = Apollo.MutationResult<DevKGolfMemberLoginMutation>;
export type DevKGolfMemberLoginMutationOptions = Apollo.BaseMutationOptions<DevKGolfMemberLoginMutation, DevKGolfMemberLoginMutationVariables>;
export const DevKGolfMemberGetDocument = gql`
    query DevKGolfMemberGet {
  devKGolfMemberGet {
    address1
    address2
    birthday
    cdn
    city
    country
    email
    gender
    isTermsAgreeNotificationSMS
    mobilePhone
    mobilePhoneCountry
    nickname
    profilePath
    province
    zipcode
  }
}
    `;

/**
 * __useDevKGolfMemberGetQuery__
 *
 * To run a query within a React component, call `useDevKGolfMemberGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevKGolfMemberGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevKGolfMemberGetQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevKGolfMemberGetQuery(baseOptions?: Apollo.QueryHookOptions<DevKGolfMemberGetQuery, DevKGolfMemberGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevKGolfMemberGetQuery, DevKGolfMemberGetQueryVariables>(DevKGolfMemberGetDocument, options);
      }
export function useDevKGolfMemberGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevKGolfMemberGetQuery, DevKGolfMemberGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevKGolfMemberGetQuery, DevKGolfMemberGetQueryVariables>(DevKGolfMemberGetDocument, options);
        }
export type DevKGolfMemberGetQueryHookResult = ReturnType<typeof useDevKGolfMemberGetQuery>;
export type DevKGolfMemberGetLazyQueryHookResult = ReturnType<typeof useDevKGolfMemberGetLazyQuery>;
export type DevKGolfMemberGetQueryResult = Apollo.QueryResult<DevKGolfMemberGetQuery, DevKGolfMemberGetQueryVariables>;
export const DevKGolfCreateAccountsDocument = gql`
    mutation DevKGolfCreateAccounts {
  devKGolfCreateAccounts {
    noOfKGolfAccountCreated
  }
}
    `;
export type DevKGolfCreateAccountsMutationFn = Apollo.MutationFunction<DevKGolfCreateAccountsMutation, DevKGolfCreateAccountsMutationVariables>;

/**
 * __useDevKGolfCreateAccountsMutation__
 *
 * To run a mutation, you first call `useDevKGolfCreateAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevKGolfCreateAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devKGolfCreateAccountsMutation, { data, loading, error }] = useDevKGolfCreateAccountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevKGolfCreateAccountsMutation(baseOptions?: Apollo.MutationHookOptions<DevKGolfCreateAccountsMutation, DevKGolfCreateAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevKGolfCreateAccountsMutation, DevKGolfCreateAccountsMutationVariables>(DevKGolfCreateAccountsDocument, options);
      }
export type DevKGolfCreateAccountsMutationHookResult = ReturnType<typeof useDevKGolfCreateAccountsMutation>;
export type DevKGolfCreateAccountsMutationResult = Apollo.MutationResult<DevKGolfCreateAccountsMutation>;
export type DevKGolfCreateAccountsMutationOptions = Apollo.BaseMutationOptions<DevKGolfCreateAccountsMutation, DevKGolfCreateAccountsMutationVariables>;
export const DevKGolfShopLoginDocument = gql`
    mutation DevKGolfShopLogin {
  devKGolfShopLogin {
    accessToken
    country
    expiresIn
    managerId
    managerIdx
    managerName
    managerType
    refreshToken
    scope
    shopGuid
    shopName
    tokenType
  }
}
    `;
export type DevKGolfShopLoginMutationFn = Apollo.MutationFunction<DevKGolfShopLoginMutation, DevKGolfShopLoginMutationVariables>;

/**
 * __useDevKGolfShopLoginMutation__
 *
 * To run a mutation, you first call `useDevKGolfShopLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevKGolfShopLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devKGolfShopLoginMutation, { data, loading, error }] = useDevKGolfShopLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevKGolfShopLoginMutation(baseOptions?: Apollo.MutationHookOptions<DevKGolfShopLoginMutation, DevKGolfShopLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevKGolfShopLoginMutation, DevKGolfShopLoginMutationVariables>(DevKGolfShopLoginDocument, options);
      }
export type DevKGolfShopLoginMutationHookResult = ReturnType<typeof useDevKGolfShopLoginMutation>;
export type DevKGolfShopLoginMutationResult = Apollo.MutationResult<DevKGolfShopLoginMutation>;
export type DevKGolfShopLoginMutationOptions = Apollo.BaseMutationOptions<DevKGolfShopLoginMutation, DevKGolfShopLoginMutationVariables>;
export const DevNotificationAppSendDocument = gql`
    mutation DevNotificationAppSend($input: DevNotificationAppSendInput!) {
  devNotificationAppSend(input: $input)
}
    `;
export type DevNotificationAppSendMutationFn = Apollo.MutationFunction<DevNotificationAppSendMutation, DevNotificationAppSendMutationVariables>;

/**
 * __useDevNotificationAppSendMutation__
 *
 * To run a mutation, you first call `useDevNotificationAppSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevNotificationAppSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devNotificationAppSendMutation, { data, loading, error }] = useDevNotificationAppSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevNotificationAppSendMutation(baseOptions?: Apollo.MutationHookOptions<DevNotificationAppSendMutation, DevNotificationAppSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevNotificationAppSendMutation, DevNotificationAppSendMutationVariables>(DevNotificationAppSendDocument, options);
      }
export type DevNotificationAppSendMutationHookResult = ReturnType<typeof useDevNotificationAppSendMutation>;
export type DevNotificationAppSendMutationResult = Apollo.MutationResult<DevNotificationAppSendMutation>;
export type DevNotificationAppSendMutationOptions = Apollo.BaseMutationOptions<DevNotificationAppSendMutation, DevNotificationAppSendMutationVariables>;
export const AdminLoginDocument = gql`
    mutation AdminLogin($input: AdminLoginInput!) {
  adminLogin(input: $input) {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminLoginMutationFn = Apollo.MutationFunction<AdminLoginMutation, AdminLoginMutationVariables>;

/**
 * __useAdminLoginMutation__
 *
 * To run a mutation, you first call `useAdminLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLoginMutation, { data, loading, error }] = useAdminLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminLoginMutation(baseOptions?: Apollo.MutationHookOptions<AdminLoginMutation, AdminLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLoginMutation, AdminLoginMutationVariables>(AdminLoginDocument, options);
      }
export type AdminLoginMutationHookResult = ReturnType<typeof useAdminLoginMutation>;
export type AdminLoginMutationResult = Apollo.MutationResult<AdminLoginMutation>;
export type AdminLoginMutationOptions = Apollo.BaseMutationOptions<AdminLoginMutation, AdminLoginMutationVariables>;
export const AdminLogoutDocument = gql`
    mutation AdminLogout {
  adminLogout
}
    `;
export type AdminLogoutMutationFn = Apollo.MutationFunction<AdminLogoutMutation, AdminLogoutMutationVariables>;

/**
 * __useAdminLogoutMutation__
 *
 * To run a mutation, you first call `useAdminLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLogoutMutation, { data, loading, error }] = useAdminLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AdminLogoutMutation, AdminLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLogoutMutation, AdminLogoutMutationVariables>(AdminLogoutDocument, options);
      }
export type AdminLogoutMutationHookResult = ReturnType<typeof useAdminLogoutMutation>;
export type AdminLogoutMutationResult = Apollo.MutationResult<AdminLogoutMutation>;
export type AdminLogoutMutationOptions = Apollo.BaseMutationOptions<AdminLogoutMutation, AdminLogoutMutationVariables>;
export const AdminRefreshAccessTokenDocument = gql`
    mutation AdminRefreshAccessToken {
  adminRefreshAccessToken {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminRefreshAccessTokenMutationFn = Apollo.MutationFunction<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;

/**
 * __useAdminRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useAdminRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefreshAccessTokenMutation, { data, loading, error }] = useAdminRefreshAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>(AdminRefreshAccessTokenDocument, options);
      }
export type AdminRefreshAccessTokenMutationHookResult = ReturnType<typeof useAdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationResult = Apollo.MutationResult<AdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;
export const AdminForgotPasswordDocument = gql`
    mutation AdminForgotPassword($input: AdminForgotPasswordInput!) {
  adminForgotPassword(input: $input) {
    email
    resetToken
  }
}
    `;
export type AdminForgotPasswordMutationFn = Apollo.MutationFunction<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;

/**
 * __useAdminForgotPasswordMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordMutation, { data, loading, error }] = useAdminForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>(AdminForgotPasswordDocument, options);
      }
export type AdminForgotPasswordMutationHookResult = ReturnType<typeof useAdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationResult = Apollo.MutationResult<AdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;
export const AdminForgotPasswordSubmitDocument = gql`
    mutation AdminForgotPasswordSubmit($input: AdminForgotPasswordSubmitInput!) {
  adminForgotPasswordSubmit(input: $input)
}
    `;
export type AdminForgotPasswordSubmitMutationFn = Apollo.MutationFunction<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;

/**
 * __useAdminForgotPasswordSubmitMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordSubmitMutation, { data, loading, error }] = useAdminForgotPasswordSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordSubmitMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>(AdminForgotPasswordSubmitDocument, options);
      }
export type AdminForgotPasswordSubmitMutationHookResult = ReturnType<typeof useAdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationResult = Apollo.MutationResult<AdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;
export const AdminShopTokensDocument = gql`
    mutation AdminShopTokens($input: AdminShopTokensInput) {
  adminShopTokens(input: $input) {
    expires
    shops
    ud
  }
}
    `;
export type AdminShopTokensMutationFn = Apollo.MutationFunction<AdminShopTokensMutation, AdminShopTokensMutationVariables>;

/**
 * __useAdminShopTokensMutation__
 *
 * To run a mutation, you first call `useAdminShopTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopTokensMutation, { data, loading, error }] = useAdminShopTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopTokensMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopTokensMutation, AdminShopTokensMutationVariables>(AdminShopTokensDocument, options);
      }
export type AdminShopTokensMutationHookResult = ReturnType<typeof useAdminShopTokensMutation>;
export type AdminShopTokensMutationResult = Apollo.MutationResult<AdminShopTokensMutation>;
export type AdminShopTokensMutationOptions = Apollo.BaseMutationOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>;
export const AdminDeleteMembershipDocument = gql`
    mutation AdminDeleteMembership($input: AdminDeleteMembershipInput!) {
  adminDeleteMembership(input: $input)
}
    `;
export type AdminDeleteMembershipMutationFn = Apollo.MutationFunction<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>;

/**
 * __useAdminDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMembershipMutation, { data, loading, error }] = useAdminDeleteMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminDeleteMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>(AdminDeleteMembershipDocument, options);
      }
export type AdminDeleteMembershipMutationHookResult = ReturnType<typeof useAdminDeleteMembershipMutation>;
export type AdminDeleteMembershipMutationResult = Apollo.MutationResult<AdminDeleteMembershipMutation>;
export type AdminDeleteMembershipMutationOptions = Apollo.BaseMutationOptions<AdminDeleteMembershipMutation, AdminDeleteMembershipMutationVariables>;
export const AdminMemberCreditUpdateDocument = gql`
    mutation AdminMemberCreditUpdate($input: AdminMemberCreditUpdateInput) {
  adminMemberCreditUpdate(input: $input)
}
    `;
export type AdminMemberCreditUpdateMutationFn = Apollo.MutationFunction<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>;

/**
 * __useAdminMemberCreditUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberCreditUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberCreditUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberCreditUpdateMutation, { data, loading, error }] = useAdminMemberCreditUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberCreditUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>(AdminMemberCreditUpdateDocument, options);
      }
export type AdminMemberCreditUpdateMutationHookResult = ReturnType<typeof useAdminMemberCreditUpdateMutation>;
export type AdminMemberCreditUpdateMutationResult = Apollo.MutationResult<AdminMemberCreditUpdateMutation>;
export type AdminMemberCreditUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberCreditUpdateMutation, AdminMemberCreditUpdateMutationVariables>;
export const AdminMemberSendResetPasswordEmailDocument = gql`
    mutation AdminMemberSendResetPasswordEmail($input: AdminMemberSendResetPasswordEmailInput!) {
  adminMemberSendResetPasswordEmail(input: $input)
}
    `;
export type AdminMemberSendResetPasswordEmailMutationFn = Apollo.MutationFunction<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>;

/**
 * __useAdminMemberSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useAdminMemberSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberSendResetPasswordEmailMutation, { data, loading, error }] = useAdminMemberSendResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>(AdminMemberSendResetPasswordEmailDocument, options);
      }
export type AdminMemberSendResetPasswordEmailMutationHookResult = ReturnType<typeof useAdminMemberSendResetPasswordEmailMutation>;
export type AdminMemberSendResetPasswordEmailMutationResult = Apollo.MutationResult<AdminMemberSendResetPasswordEmailMutation>;
export type AdminMemberSendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<AdminMemberSendResetPasswordEmailMutation, AdminMemberSendResetPasswordEmailMutationVariables>;
export const AdminMemberProfileUpdateDocument = gql`
    mutation AdminMemberProfileUpdate($input: AdminMemberProfileUpdateInput!) {
  adminMemberProfileUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    member {
      accountType
      activationLineItems {
        itemName
        salesPrice
      }
      activationOrderNo
      activationPrice
      addressCity
      addressCountry
      addressPostalCode
      addressState
      addressStreet1
      addressStreet2
      birthday
      companyContactPersonEmail
      companyContactPersonFirstName
      companyContactPersonLastName
      companyName
      createdAt
      createdBy
      createdByAdminId
      createdByAdminName
      credit
      creditSpent
      email
      firstName
      gameCredit
      gender
      handed
      hasSubscriptions
      individualId
      kGolfAccountCreationError
      lastName
      locker
      members {
        accountType
        firstName
        id
        individualId
        lastName
      }
      membershipStatus
      membershipType {
        baseCountryCode
        internalName
        isCorporate
        tagBgColorCode
        tagText
        tagTextColorCode
      }
      membershipUuid
      memberStatus
      memberUuid
      mobileNumber
      nationality
      nickname
      partialNricOrFin
      practiseCredit
      profileImageUrl
      pushTokens
      relationshipToMainMember
      serviceNote
      signUpSidasInsoles
      startDate
      voucherField
      voucherIndoor
    }
  }
}
    `;
export type AdminMemberProfileUpdateMutationFn = Apollo.MutationFunction<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>;

/**
 * __useAdminMemberProfileUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberProfileUpdateMutation, { data, loading, error }] = useAdminMemberProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>(AdminMemberProfileUpdateDocument, options);
      }
export type AdminMemberProfileUpdateMutationHookResult = ReturnType<typeof useAdminMemberProfileUpdateMutation>;
export type AdminMemberProfileUpdateMutationResult = Apollo.MutationResult<AdminMemberProfileUpdateMutation>;
export type AdminMemberProfileUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberProfileUpdateMutation, AdminMemberProfileUpdateMutationVariables>;
export const AdminMemberTierUpdateDocument = gql`
    mutation AdminMemberTierUpdate($input: AdminMemberTierUpdateInput!) {
  adminMemberTierUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    member {
      accountType
      activationLineItems {
        itemName
        salesPrice
      }
      activationOrderNo
      activationPrice
      addressCity
      addressCountry
      addressPostalCode
      addressState
      addressStreet1
      addressStreet2
      birthday
      companyContactPersonEmail
      companyContactPersonFirstName
      companyContactPersonLastName
      companyName
      createdAt
      createdBy
      createdByAdminId
      createdByAdminName
      credit
      creditSpent
      email
      firstName
      gameCredit
      gender
      handed
      hasSubscriptions
      individualId
      kGolfAccountCreationError
      lastName
      locker
      members {
        accountType
        firstName
        id
        individualId
        lastName
      }
      membershipStatus
      membershipType {
        baseCountryCode
        internalName
        isCorporate
        tagBgColorCode
        tagText
        tagTextColorCode
      }
      membershipUuid
      memberStatus
      memberUuid
      mobileNumber
      nationality
      nickname
      partialNricOrFin
      practiseCredit
      profileImageUrl
      pushTokens
      relationshipToMainMember
      serviceNote
      signUpSidasInsoles
      startDate
      voucherField
      voucherIndoor
    }
  }
}
    `;
export type AdminMemberTierUpdateMutationFn = Apollo.MutationFunction<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>;

/**
 * __useAdminMemberTierUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberTierUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberTierUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberTierUpdateMutation, { data, loading, error }] = useAdminMemberTierUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberTierUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>(AdminMemberTierUpdateDocument, options);
      }
export type AdminMemberTierUpdateMutationHookResult = ReturnType<typeof useAdminMemberTierUpdateMutation>;
export type AdminMemberTierUpdateMutationResult = Apollo.MutationResult<AdminMemberTierUpdateMutation>;
export type AdminMemberTierUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberTierUpdateMutation, AdminMemberTierUpdateMutationVariables>;
export const AdminUpdateSidasInsolesDocument = gql`
    mutation AdminUpdateSidasInsoles($input: AdminUpdateSidasInsolesInput!) {
  adminUpdateSidasInsoles(input: $input)
}
    `;
export type AdminUpdateSidasInsolesMutationFn = Apollo.MutationFunction<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>;

/**
 * __useAdminUpdateSidasInsolesMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSidasInsolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSidasInsolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSidasInsolesMutation, { data, loading, error }] = useAdminUpdateSidasInsolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateSidasInsolesMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>(AdminUpdateSidasInsolesDocument, options);
      }
export type AdminUpdateSidasInsolesMutationHookResult = ReturnType<typeof useAdminUpdateSidasInsolesMutation>;
export type AdminUpdateSidasInsolesMutationResult = Apollo.MutationResult<AdminUpdateSidasInsolesMutation>;
export type AdminUpdateSidasInsolesMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSidasInsolesMutation, AdminUpdateSidasInsolesMutationVariables>;
export const AdminUpdateNicknameDocument = gql`
    mutation AdminUpdateNickname($input: AdminUpdateNicknameInput!) {
  adminUpdateNickname(input: $input)
}
    `;
export type AdminUpdateNicknameMutationFn = Apollo.MutationFunction<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>;

/**
 * __useAdminUpdateNicknameMutation__
 *
 * To run a mutation, you first call `useAdminUpdateNicknameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateNicknameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateNicknameMutation, { data, loading, error }] = useAdminUpdateNicknameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateNicknameMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>(AdminUpdateNicknameDocument, options);
      }
export type AdminUpdateNicknameMutationHookResult = ReturnType<typeof useAdminUpdateNicknameMutation>;
export type AdminUpdateNicknameMutationResult = Apollo.MutationResult<AdminUpdateNicknameMutation>;
export type AdminUpdateNicknameMutationOptions = Apollo.BaseMutationOptions<AdminUpdateNicknameMutation, AdminUpdateNicknameMutationVariables>;
export const AdminPaySubscriptionsDocument = gql`
    mutation AdminPaySubscriptions($input: AdminPaySubscriptionsInput!) {
  adminPaySubscriptions(input: $input)
}
    `;
export type AdminPaySubscriptionsMutationFn = Apollo.MutationFunction<AdminPaySubscriptionsMutation, AdminPaySubscriptionsMutationVariables>;

/**
 * __useAdminPaySubscriptionsMutation__
 *
 * To run a mutation, you first call `useAdminPaySubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPaySubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPaySubscriptionsMutation, { data, loading, error }] = useAdminPaySubscriptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminPaySubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminPaySubscriptionsMutation, AdminPaySubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPaySubscriptionsMutation, AdminPaySubscriptionsMutationVariables>(AdminPaySubscriptionsDocument, options);
      }
export type AdminPaySubscriptionsMutationHookResult = ReturnType<typeof useAdminPaySubscriptionsMutation>;
export type AdminPaySubscriptionsMutationResult = Apollo.MutationResult<AdminPaySubscriptionsMutation>;
export type AdminPaySubscriptionsMutationOptions = Apollo.BaseMutationOptions<AdminPaySubscriptionsMutation, AdminPaySubscriptionsMutationVariables>;
export const AdminUpdateSubscriptionDocument = gql`
    mutation AdminUpdateSubscription($input: AdmnUpdateSubscriptionInput!) {
  adminUpdateSubscription(input: $input)
}
    `;
export type AdminUpdateSubscriptionMutationFn = Apollo.MutationFunction<AdminUpdateSubscriptionMutation, AdminUpdateSubscriptionMutationVariables>;

/**
 * __useAdminUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSubscriptionMutation, { data, loading, error }] = useAdminUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSubscriptionMutation, AdminUpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSubscriptionMutation, AdminUpdateSubscriptionMutationVariables>(AdminUpdateSubscriptionDocument, options);
      }
export type AdminUpdateSubscriptionMutationHookResult = ReturnType<typeof useAdminUpdateSubscriptionMutation>;
export type AdminUpdateSubscriptionMutationResult = Apollo.MutationResult<AdminUpdateSubscriptionMutation>;
export type AdminUpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSubscriptionMutation, AdminUpdateSubscriptionMutationVariables>;
export const AdminMemberResendOnboardingEmailDocument = gql`
    mutation AdminMemberResendOnboardingEmail($input: AdminMemberResendOnboardingEmailInput!) {
  adminMemberResendOnboardingEmail(input: $input)
}
    `;
export type AdminMemberResendOnboardingEmailMutationFn = Apollo.MutationFunction<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>;

/**
 * __useAdminMemberResendOnboardingEmailMutation__
 *
 * To run a mutation, you first call `useAdminMemberResendOnboardingEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberResendOnboardingEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberResendOnboardingEmailMutation, { data, loading, error }] = useAdminMemberResendOnboardingEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberResendOnboardingEmailMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>(AdminMemberResendOnboardingEmailDocument, options);
      }
export type AdminMemberResendOnboardingEmailMutationHookResult = ReturnType<typeof useAdminMemberResendOnboardingEmailMutation>;
export type AdminMemberResendOnboardingEmailMutationResult = Apollo.MutationResult<AdminMemberResendOnboardingEmailMutation>;
export type AdminMemberResendOnboardingEmailMutationOptions = Apollo.BaseMutationOptions<AdminMemberResendOnboardingEmailMutation, AdminMemberResendOnboardingEmailMutationVariables>;
export const AdminMemberUpdatePasswordDocument = gql`
    mutation AdminMemberUpdatePassword($input: AdminMemberUpdatePasswordInput!) {
  adminMemberUpdatePassword(input: $input)
}
    `;
export type AdminMemberUpdatePasswordMutationFn = Apollo.MutationFunction<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>;

/**
 * __useAdminMemberUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAdminMemberUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberUpdatePasswordMutation, { data, loading, error }] = useAdminMemberUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>(AdminMemberUpdatePasswordDocument, options);
      }
export type AdminMemberUpdatePasswordMutationHookResult = ReturnType<typeof useAdminMemberUpdatePasswordMutation>;
export type AdminMemberUpdatePasswordMutationResult = Apollo.MutationResult<AdminMemberUpdatePasswordMutation>;
export type AdminMemberUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AdminMemberUpdatePasswordMutation, AdminMemberUpdatePasswordMutationVariables>;
export const AdminMemberReassignMembershipIdDocument = gql`
    mutation AdminMemberReassignMembershipId($input: AdminMemberReassignMembershipIdInput!) {
  adminMemberReassignMembershipId(input: $input)
}
    `;
export type AdminMemberReassignMembershipIdMutationFn = Apollo.MutationFunction<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>;

/**
 * __useAdminMemberReassignMembershipIdMutation__
 *
 * To run a mutation, you first call `useAdminMemberReassignMembershipIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberReassignMembershipIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberReassignMembershipIdMutation, { data, loading, error }] = useAdminMemberReassignMembershipIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberReassignMembershipIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>(AdminMemberReassignMembershipIdDocument, options);
      }
export type AdminMemberReassignMembershipIdMutationHookResult = ReturnType<typeof useAdminMemberReassignMembershipIdMutation>;
export type AdminMemberReassignMembershipIdMutationResult = Apollo.MutationResult<AdminMemberReassignMembershipIdMutation>;
export type AdminMemberReassignMembershipIdMutationOptions = Apollo.BaseMutationOptions<AdminMemberReassignMembershipIdMutation, AdminMemberReassignMembershipIdMutationVariables>;
export const AdminMemberServiceUpdateDocument = gql`
    mutation AdminMemberServiceUpdate($input: AdminMemberServiceUpdateInput!) {
  adminMemberServiceUpdate(input: $input)
}
    `;
export type AdminMemberServiceUpdateMutationFn = Apollo.MutationFunction<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>;

/**
 * __useAdminMemberServiceUpdateMutation__
 *
 * To run a mutation, you first call `useAdminMemberServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMemberServiceUpdateMutation, { data, loading, error }] = useAdminMemberServiceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMemberServiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>(AdminMemberServiceUpdateDocument, options);
      }
export type AdminMemberServiceUpdateMutationHookResult = ReturnType<typeof useAdminMemberServiceUpdateMutation>;
export type AdminMemberServiceUpdateMutationResult = Apollo.MutationResult<AdminMemberServiceUpdateMutation>;
export type AdminMemberServiceUpdateMutationOptions = Apollo.BaseMutationOptions<AdminMemberServiceUpdateMutation, AdminMemberServiceUpdateMutationVariables>;
export const AdminMembersDocument = gql`
    query AdminMembers($args: AdminMembersArgs!) {
  adminMembers(args: $args) {
    edges {
      cursor
      node {
        accountType
        appVersion
        companyContactPersonFirstName
        companyContactPersonLastName
        companyName
        createdAt
        firstName
        id
        individualId
        kGolfAccountCreationError
        lastName
        membershipId
        membershipType {
          baseCountryCode
          internalName
          isCorporate
          tagBgColorCode
          tagText
          tagTextColorCode
        }
        memberStatus
        startDate
      }
    }
    pageInfo {
      endCursor
      failedKGolfAccounts
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMembersQuery__
 *
 * To run a query within a React component, call `useAdminMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembersQuery(baseOptions: Apollo.QueryHookOptions<AdminMembersQuery, AdminMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembersQuery, AdminMembersQueryVariables>(AdminMembersDocument, options);
      }
export function useAdminMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembersQuery, AdminMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembersQuery, AdminMembersQueryVariables>(AdminMembersDocument, options);
        }
export type AdminMembersQueryHookResult = ReturnType<typeof useAdminMembersQuery>;
export type AdminMembersLazyQueryHookResult = ReturnType<typeof useAdminMembersLazyQuery>;
export type AdminMembersQueryResult = Apollo.QueryResult<AdminMembersQuery, AdminMembersQueryVariables>;
export const AdminMemberDocument = gql`
    query AdminMember($args: AdminMemberArgs!) {
  adminMember(args: $args) {
    accountType
    activationLineItems {
      itemName
      salesPrice
    }
    activationOrderNo
    activationPrice
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    birthday
    companyContactPersonEmail
    companyContactPersonFirstName
    companyContactPersonLastName
    companyName
    createdAt
    createdBy
    createdByAdminId
    createdByAdminName
    credit
    creditSpent
    email
    firstName
    gameCredit
    gender
    handed
    hasSubscriptions
    individualId
    kGolfAccountCreationError
    lastName
    locker
    members {
      accountType
      firstName
      id
      individualId
      lastName
    }
    membershipStatus
    membershipType {
      baseCountryCode
      internalName
      isCorporate
      price
      tagBgColorCode
      tagText
      tagTextColorCode
    }
    membershipUuid
    memberStatus
    memberUuid
    mobileNumber
    nationality
    nickname
    partialNricOrFin
    practiseCredit
    profileImageUrl
    pushTokens
    relationshipToMainMember
    serviceNote
    signUpSidasInsoles
    startDate
    termEndDate
    voucherField
    voucherIndoor
  }
}
    `;

/**
 * __useAdminMemberQuery__
 *
 * To run a query within a React component, call `useAdminMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberQuery, AdminMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberQuery, AdminMemberQueryVariables>(AdminMemberDocument, options);
      }
export function useAdminMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberQuery, AdminMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberQuery, AdminMemberQueryVariables>(AdminMemberDocument, options);
        }
export type AdminMemberQueryHookResult = ReturnType<typeof useAdminMemberQuery>;
export type AdminMemberLazyQueryHookResult = ReturnType<typeof useAdminMemberLazyQuery>;
export type AdminMemberQueryResult = Apollo.QueryResult<AdminMemberQuery, AdminMemberQueryVariables>;
export const AdminCreditTransactionsDocument = gql`
    query AdminCreditTransactions($args: AdminCreditTransactionsArgs!) {
  adminCreditTransactions(args: $args) {
    edges {
      cursor
      node {
        amount
        authorizedAdjuster
        createdAt
        description
        id
        isSpent
        type
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminCreditTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminCreditTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCreditTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCreditTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminCreditTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminCreditTransactionsQuery, AdminCreditTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCreditTransactionsQuery, AdminCreditTransactionsQueryVariables>(AdminCreditTransactionsDocument, options);
      }
export function useAdminCreditTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCreditTransactionsQuery, AdminCreditTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCreditTransactionsQuery, AdminCreditTransactionsQueryVariables>(AdminCreditTransactionsDocument, options);
        }
export type AdminCreditTransactionsQueryHookResult = ReturnType<typeof useAdminCreditTransactionsQuery>;
export type AdminCreditTransactionsLazyQueryHookResult = ReturnType<typeof useAdminCreditTransactionsLazyQuery>;
export type AdminCreditTransactionsQueryResult = Apollo.QueryResult<AdminCreditTransactionsQuery, AdminCreditTransactionsQueryVariables>;
export const AdminKGolfMemberDocument = gql`
    query AdminKGolfMember($args: AdminKGolfMemberArgs) {
  adminKGolfMember(args: $args) {
    address1
    address2
    birthday
    cdn
    city
    connectKakao
    connectWechat
    country
    email
    gender
    handed
    id
    isTermsAgreeNotificationEmail
    isTermsAgreeNotificationSMS
    mobilePhone
    mobilePhoneCountry
    nickname
    profilePath
    province
    zipcode
  }
}
    `;

/**
 * __useAdminKGolfMemberQuery__
 *
 * To run a query within a React component, call `useAdminKGolfMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminKGolfMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminKGolfMemberQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminKGolfMemberQuery(baseOptions?: Apollo.QueryHookOptions<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>(AdminKGolfMemberDocument, options);
      }
export function useAdminKGolfMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>(AdminKGolfMemberDocument, options);
        }
export type AdminKGolfMemberQueryHookResult = ReturnType<typeof useAdminKGolfMemberQuery>;
export type AdminKGolfMemberLazyQueryHookResult = ReturnType<typeof useAdminKGolfMemberLazyQuery>;
export type AdminKGolfMemberQueryResult = Apollo.QueryResult<AdminKGolfMemberQuery, AdminKGolfMemberQueryVariables>;
export const AdminMembershipSubscriptionsDocument = gql`
    query AdminMembershipSubscriptions($args: AdminMembershipSubscriptionsArgs!) {
  adminMembershipSubscriptions(args: $args) {
    edges {
      cursor
      node {
        credit
        endDate
        mainMemberMainId
        mainMemberName
        membershipUuid
        memberUuid
        status
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMembershipSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminMembershipSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipSubscriptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>(AdminMembershipSubscriptionsDocument, options);
      }
export function useAdminMembershipSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>(AdminMembershipSubscriptionsDocument, options);
        }
export type AdminMembershipSubscriptionsQueryHookResult = ReturnType<typeof useAdminMembershipSubscriptionsQuery>;
export type AdminMembershipSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminMembershipSubscriptionsLazyQuery>;
export type AdminMembershipSubscriptionsQueryResult = Apollo.QueryResult<AdminMembershipSubscriptionsQuery, AdminMembershipSubscriptionsQueryVariables>;
export const AdminMemberSubscriptionsDocument = gql`
    query AdminMemberSubscriptions($args: AdminMemberSubscriptionsArgs!) {
  adminMemberSubscriptions(args: $args) {
    balance
    credit
    daysLeft
    edges {
      cursor
      node {
        amount
        creditDeducted
        days
        description
        endDate
        id
        startDate
      }
    }
    endDate
    mainMemberName
    membershipId
    membershipUuid
    pageInfo {
      endCursor
      hasNextPage
      total
    }
    startDate
    status
    subscriptionEndDate
  }
}
    `;

/**
 * __useAdminMemberSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberSubscriptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>(AdminMemberSubscriptionsDocument, options);
      }
export function useAdminMemberSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>(AdminMemberSubscriptionsDocument, options);
        }
export type AdminMemberSubscriptionsQueryHookResult = ReturnType<typeof useAdminMemberSubscriptionsQuery>;
export type AdminMemberSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminMemberSubscriptionsLazyQuery>;
export type AdminMemberSubscriptionsQueryResult = Apollo.QueryResult<AdminMemberSubscriptionsQuery, AdminMemberSubscriptionsQueryVariables>;
export const AdminMembershipServicesDocument = gql`
    query AdminMembershipServices($args: AdminMembershipServicesArgs!) {
  adminMembershipServices(args: $args) {
    services {
      amount
      dateAdded
      expiryDate
      hasExtended
      orderNo
      serviceId
      serviceName
      unitType
    }
  }
}
    `;

/**
 * __useAdminMembershipServicesQuery__
 *
 * To run a query within a React component, call `useAdminMembershipServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipServicesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipServicesQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>(AdminMembershipServicesDocument, options);
      }
export function useAdminMembershipServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>(AdminMembershipServicesDocument, options);
        }
export type AdminMembershipServicesQueryHookResult = ReturnType<typeof useAdminMembershipServicesQuery>;
export type AdminMembershipServicesLazyQueryHookResult = ReturnType<typeof useAdminMembershipServicesLazyQuery>;
export type AdminMembershipServicesQueryResult = Apollo.QueryResult<AdminMembershipServicesQuery, AdminMembershipServicesQueryVariables>;
export const AdminMemberServiceTransactionsDocument = gql`
    query AdminMemberServiceTransactions($args: AdminMemberServiceTransactionsArgs!) {
  adminMemberServiceTransactions(args: $args) {
    edges {
      cursor
      node {
        amount
        comment
        date
        id
        serviceType
        transactionType
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberServiceTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminMemberServiceTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberServiceTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberServiceTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberServiceTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>(AdminMemberServiceTransactionsDocument, options);
      }
export function useAdminMemberServiceTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>(AdminMemberServiceTransactionsDocument, options);
        }
export type AdminMemberServiceTransactionsQueryHookResult = ReturnType<typeof useAdminMemberServiceTransactionsQuery>;
export type AdminMemberServiceTransactionsLazyQueryHookResult = ReturnType<typeof useAdminMemberServiceTransactionsLazyQuery>;
export type AdminMemberServiceTransactionsQueryResult = Apollo.QueryResult<AdminMemberServiceTransactionsQuery, AdminMemberServiceTransactionsQueryVariables>;
export const AdminUpdateMembershipTypeDocument = gql`
    mutation AdminUpdateMembershipType($input: AdminUpdateMembershipTypeInput!) {
  adminUpdateMembershipType(input: $input) {
    baseCountryCode
    compDailySimulatorUse
    compDailySimulatorUseType
    compFieldLessons
    compIndoorLessons
    compLocker
    designatedPrivateRoom
    discount
    id
    imageUrl
    initialCredits
    internalName
    isCorporate
    isEnabled
    lineItemCode
    loungeAccess
    mainTypeSlug
    monthlySub
    price
    publicName
    signupProductSidasInsoles
    subscriptionlineItemCode
    supplementaryTypeSlug
    tagBgColorCode
    tagText
    tagTextColorCode
    tier
    versionSlug
  }
}
    `;
export type AdminUpdateMembershipTypeMutationFn = Apollo.MutationFunction<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>;

/**
 * __useAdminUpdateMembershipTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMembershipTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMembershipTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMembershipTypeMutation, { data, loading, error }] = useAdminUpdateMembershipTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateMembershipTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>(AdminUpdateMembershipTypeDocument, options);
      }
export type AdminUpdateMembershipTypeMutationHookResult = ReturnType<typeof useAdminUpdateMembershipTypeMutation>;
export type AdminUpdateMembershipTypeMutationResult = Apollo.MutationResult<AdminUpdateMembershipTypeMutation>;
export type AdminUpdateMembershipTypeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateMembershipTypeMutation, AdminUpdateMembershipTypeMutationVariables>;
export const AdminMembershipTypesDocument = gql`
    query AdminMembershipTypes($args: AdminMembershipTypesArgs!) {
  adminMembershipTypes(args: $args) {
    lifestyle {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
    numberOfTypes
    premium {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
    vip {
      baseCountryCode
      id
      internalName
      price
      tier
      versionSlug
    }
  }
}
    `;

/**
 * __useAdminMembershipTypesQuery__
 *
 * To run a query within a React component, call `useAdminMembershipTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipTypesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipTypesQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>(AdminMembershipTypesDocument, options);
      }
export function useAdminMembershipTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>(AdminMembershipTypesDocument, options);
        }
export type AdminMembershipTypesQueryHookResult = ReturnType<typeof useAdminMembershipTypesQuery>;
export type AdminMembershipTypesLazyQueryHookResult = ReturnType<typeof useAdminMembershipTypesLazyQuery>;
export type AdminMembershipTypesQueryResult = Apollo.QueryResult<AdminMembershipTypesQuery, AdminMembershipTypesQueryVariables>;
export const AdminMembershipTypeDocument = gql`
    query AdminMembershipType($args: AdminMembershipTypeArgs!) {
  adminMembershipType(args: $args) {
    baseCountryCode
    compDailySimulatorUse
    compDailySimulatorUseType
    compFieldLessons
    compIndoorLessons
    compLocker
    designatedPrivateRoom
    discount
    id
    imageUrl
    initialCredits
    internalName
    isCorporate
    isEnabled
    lineItemCode
    loungeAccess
    mainTypeSlug
    monthlySub
    price
    publicName
    signupProductSidasInsoles
    subscriptionlineItemCode
    supplementaryTypeSlug
    tagBgColorCode
    tagText
    tagTextColorCode
    tier
    versionSlug
  }
}
    `;

/**
 * __useAdminMembershipTypeQuery__
 *
 * To run a query within a React component, call `useAdminMembershipTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMembershipTypeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMembershipTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>(AdminMembershipTypeDocument, options);
      }
export function useAdminMembershipTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>(AdminMembershipTypeDocument, options);
        }
export type AdminMembershipTypeQueryHookResult = ReturnType<typeof useAdminMembershipTypeQuery>;
export type AdminMembershipTypeLazyQueryHookResult = ReturnType<typeof useAdminMembershipTypeLazyQuery>;
export type AdminMembershipTypeQueryResult = Apollo.QueryResult<AdminMembershipTypeQuery, AdminMembershipTypeQueryVariables>;
export const AdminActivateMembershipDocument = gql`
    mutation AdminActivateMembership($input: AdminActivateMembershipInput) {
  adminActivateMembership(input: $input) {
    payment {
      checkoutUrl
      requestId
    }
  }
}
    `;
export type AdminActivateMembershipMutationFn = Apollo.MutationFunction<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>;

/**
 * __useAdminActivateMembershipMutation__
 *
 * To run a mutation, you first call `useAdminActivateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminActivateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminActivateMembershipMutation, { data, loading, error }] = useAdminActivateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminActivateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>(AdminActivateMembershipDocument, options);
      }
export type AdminActivateMembershipMutationHookResult = ReturnType<typeof useAdminActivateMembershipMutation>;
export type AdminActivateMembershipMutationResult = Apollo.MutationResult<AdminActivateMembershipMutation>;
export type AdminActivateMembershipMutationOptions = Apollo.BaseMutationOptions<AdminActivateMembershipMutation, AdminActivateMembershipMutationVariables>;
export const AdminCreateMembershipDocument = gql`
    mutation AdminCreateMembership($input: AdminCreateMembershipInput!) {
  adminCreateMembership(input: $input) {
    fileUploadCredentials {
      mainMembers {
        assetUrl
        clientImageFieldName
        fields
        index
        signedUrl
      }
      subMembers {
        assetUrl
        clientImageFieldName
        fields
        index
        signedUrl
      }
    }
    memberUuid
    payment {
      checkoutUrl
      requestId
    }
  }
}
    `;
export type AdminCreateMembershipMutationFn = Apollo.MutationFunction<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>;

/**
 * __useAdminCreateMembershipMutation__
 *
 * To run a mutation, you first call `useAdminCreateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMembershipMutation, { data, loading, error }] = useAdminCreateMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>(AdminCreateMembershipDocument, options);
      }
export type AdminCreateMembershipMutationHookResult = ReturnType<typeof useAdminCreateMembershipMutation>;
export type AdminCreateMembershipMutationResult = Apollo.MutationResult<AdminCreateMembershipMutation>;
export type AdminCreateMembershipMutationOptions = Apollo.BaseMutationOptions<AdminCreateMembershipMutation, AdminCreateMembershipMutationVariables>;
export const AdminUpdateReservedIdDocument = gql`
    mutation AdminUpdateReservedId($input: AdminUpdateReservedIdInput) {
  adminUpdateReservedId(input: $input) {
    onHoldExpiresAt
  }
}
    `;
export type AdminUpdateReservedIdMutationFn = Apollo.MutationFunction<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>;

/**
 * __useAdminUpdateReservedIdMutation__
 *
 * To run a mutation, you first call `useAdminUpdateReservedIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateReservedIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateReservedIdMutation, { data, loading, error }] = useAdminUpdateReservedIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateReservedIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>(AdminUpdateReservedIdDocument, options);
      }
export type AdminUpdateReservedIdMutationHookResult = ReturnType<typeof useAdminUpdateReservedIdMutation>;
export type AdminUpdateReservedIdMutationResult = Apollo.MutationResult<AdminUpdateReservedIdMutation>;
export type AdminUpdateReservedIdMutationOptions = Apollo.BaseMutationOptions<AdminUpdateReservedIdMutation, AdminUpdateReservedIdMutationVariables>;
export const AdminMembershipSubscriptionPauseDocument = gql`
    mutation AdminMembershipSubscriptionPause($input: AdminMembershipSubscriptionPauseInput!) {
  adminMembershipSubscriptionPause(input: $input)
}
    `;
export type AdminMembershipSubscriptionPauseMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>;

/**
 * __useAdminMembershipSubscriptionPauseMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionPauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionPauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionPauseMutation, { data, loading, error }] = useAdminMembershipSubscriptionPauseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionPauseMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>(AdminMembershipSubscriptionPauseDocument, options);
      }
export type AdminMembershipSubscriptionPauseMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionPauseMutation>;
export type AdminMembershipSubscriptionPauseMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionPauseMutation>;
export type AdminMembershipSubscriptionPauseMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionPauseMutation, AdminMembershipSubscriptionPauseMutationVariables>;
export const AdminMembershipSubscriptionStartDocument = gql`
    mutation AdminMembershipSubscriptionStart($input: AdminMembershipSubscriptionStartInput!) {
  adminMembershipSubscriptionStart(input: $input)
}
    `;
export type AdminMembershipSubscriptionStartMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>;

/**
 * __useAdminMembershipSubscriptionStartMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionStartMutation, { data, loading, error }] = useAdminMembershipSubscriptionStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionStartMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>(AdminMembershipSubscriptionStartDocument, options);
      }
export type AdminMembershipSubscriptionStartMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionStartMutation>;
export type AdminMembershipSubscriptionStartMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionStartMutation>;
export type AdminMembershipSubscriptionStartMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionStartMutation, AdminMembershipSubscriptionStartMutationVariables>;
export const AdminMembershipSubscriptionPayOutstandingDocument = gql`
    mutation AdminMembershipSubscriptionPayOutstanding($input: AdminMembershipSubscriptionPayOutstandingInput!) {
  adminMembershipSubscriptionPayOutstanding(input: $input)
}
    `;
export type AdminMembershipSubscriptionPayOutstandingMutationFn = Apollo.MutationFunction<AdminMembershipSubscriptionPayOutstandingMutation, AdminMembershipSubscriptionPayOutstandingMutationVariables>;

/**
 * __useAdminMembershipSubscriptionPayOutstandingMutation__
 *
 * To run a mutation, you first call `useAdminMembershipSubscriptionPayOutstandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminMembershipSubscriptionPayOutstandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminMembershipSubscriptionPayOutstandingMutation, { data, loading, error }] = useAdminMembershipSubscriptionPayOutstandingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminMembershipSubscriptionPayOutstandingMutation(baseOptions?: Apollo.MutationHookOptions<AdminMembershipSubscriptionPayOutstandingMutation, AdminMembershipSubscriptionPayOutstandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminMembershipSubscriptionPayOutstandingMutation, AdminMembershipSubscriptionPayOutstandingMutationVariables>(AdminMembershipSubscriptionPayOutstandingDocument, options);
      }
export type AdminMembershipSubscriptionPayOutstandingMutationHookResult = ReturnType<typeof useAdminMembershipSubscriptionPayOutstandingMutation>;
export type AdminMembershipSubscriptionPayOutstandingMutationResult = Apollo.MutationResult<AdminMembershipSubscriptionPayOutstandingMutation>;
export type AdminMembershipSubscriptionPayOutstandingMutationOptions = Apollo.BaseMutationOptions<AdminMembershipSubscriptionPayOutstandingMutation, AdminMembershipSubscriptionPayOutstandingMutationVariables>;
export const FormHelperNewMembershipDocument = gql`
    query FormHelperNewMembership($args: FormHelperNewMembershipArgs!) {
  formHelperNewMembership(args: $args) {
    membershipTypes {
      baseCountryCode
      hasReservedIds
      id
      internalName
      isCorporate
      price
      supplementaryTypePrice
      supplementaryTypeSlug
      versionSlug
    }
  }
}
    `;

/**
 * __useFormHelperNewMembershipQuery__
 *
 * To run a query within a React component, call `useFormHelperNewMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperNewMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperNewMembershipQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperNewMembershipQuery(baseOptions: Apollo.QueryHookOptions<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>(FormHelperNewMembershipDocument, options);
      }
export function useFormHelperNewMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>(FormHelperNewMembershipDocument, options);
        }
export type FormHelperNewMembershipQueryHookResult = ReturnType<typeof useFormHelperNewMembershipQuery>;
export type FormHelperNewMembershipLazyQueryHookResult = ReturnType<typeof useFormHelperNewMembershipLazyQuery>;
export type FormHelperNewMembershipQueryResult = Apollo.QueryResult<FormHelperNewMembershipQuery, FormHelperNewMembershipQueryVariables>;
export const AdminReservedIdsDocument = gql`
    query AdminReservedIds($args: AdminReservedIdsArgs) {
  adminReservedIds(args: $args) {
    idOnHold
    idOnHoldExpiresAt
    reservedIds {
      id
      membershipId
      onHoldExpiresAt
      onHoldFor
      status
      updatedAt
    }
  }
}
    `;

/**
 * __useAdminReservedIdsQuery__
 *
 * To run a query within a React component, call `useAdminReservedIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReservedIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReservedIdsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReservedIdsQuery(baseOptions?: Apollo.QueryHookOptions<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>(AdminReservedIdsDocument, options);
      }
export function useAdminReservedIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>(AdminReservedIdsDocument, options);
        }
export type AdminReservedIdsQueryHookResult = ReturnType<typeof useAdminReservedIdsQuery>;
export type AdminReservedIdsLazyQueryHookResult = ReturnType<typeof useAdminReservedIdsLazyQuery>;
export type AdminReservedIdsQueryResult = Apollo.QueryResult<AdminReservedIdsQuery, AdminReservedIdsQueryVariables>;
export const SelfUpdateDocument = gql`
    mutation SelfUpdate($input: SelfUpdateInput!) {
  selfUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    self {
      createdAt
      email
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organizationId
      organizationName
      profileImageUrl
      status
      updatedAt
      userId
      userType
    }
  }
}
    `;
export type SelfUpdateMutationFn = Apollo.MutationFunction<SelfUpdateMutation, SelfUpdateMutationVariables>;

/**
 * __useSelfUpdateMutation__
 *
 * To run a mutation, you first call `useSelfUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdateMutation, { data, loading, error }] = useSelfUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdateMutation, SelfUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdateMutation, SelfUpdateMutationVariables>(SelfUpdateDocument, options);
      }
export type SelfUpdateMutationHookResult = ReturnType<typeof useSelfUpdateMutation>;
export type SelfUpdateMutationResult = Apollo.MutationResult<SelfUpdateMutation>;
export type SelfUpdateMutationOptions = Apollo.BaseMutationOptions<SelfUpdateMutation, SelfUpdateMutationVariables>;
export const SelfUpdatePasswordDocument = gql`
    mutation SelfUpdatePassword($input: SelfUpdatePasswordInput!) {
  selfUpdatePassword(input: $input)
}
    `;
export type SelfUpdatePasswordMutationFn = Apollo.MutationFunction<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;

/**
 * __useSelfUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useSelfUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdatePasswordMutation, { data, loading, error }] = useSelfUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>(SelfUpdatePasswordDocument, options);
      }
export type SelfUpdatePasswordMutationHookResult = ReturnType<typeof useSelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationResult = Apollo.MutationResult<SelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;
export const SelfDocument = gql`
    query Self {
  self {
    baseCountryCode
    createdAt
    email
    firstName
    lastLogin {
      city
      ipAddress
      time
    }
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organizationId
    organizationName
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: Apollo.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
      }
export function useSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfQueryResult = Apollo.QueryResult<SelfQuery, SelfQueryVariables>;
export const SelfBasicDocument = gql`
    query SelfBasic {
  self {
    baseCountryCode
    baseGmtOffset
    clubhouses {
      clubhouseCode
      name
    }
    countries {
      countryCode
      name
    }
    lastLogin {
      city
      ipAddress
      time
    }
  }
}
    `;

/**
 * __useSelfBasicQuery__
 *
 * To run a query within a React component, call `useSelfBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfBasicQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfBasicQuery(baseOptions?: Apollo.QueryHookOptions<SelfBasicQuery, SelfBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfBasicQuery, SelfBasicQueryVariables>(SelfBasicDocument, options);
      }
export function useSelfBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfBasicQuery, SelfBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfBasicQuery, SelfBasicQueryVariables>(SelfBasicDocument, options);
        }
export type SelfBasicQueryHookResult = ReturnType<typeof useSelfBasicQuery>;
export type SelfBasicLazyQueryHookResult = ReturnType<typeof useSelfBasicLazyQuery>;
export type SelfBasicQueryResult = Apollo.QueryResult<SelfBasicQuery, SelfBasicQueryVariables>;
export const AdminNotificationCreateDocument = gql`
    mutation AdminNotificationCreate($input: AdminNotificationCreateInput!) {
  adminNotificationCreate(input: $input)
}
    `;
export type AdminNotificationCreateMutationFn = Apollo.MutationFunction<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>;

/**
 * __useAdminNotificationCreateMutation__
 *
 * To run a mutation, you first call `useAdminNotificationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationCreateMutation, { data, loading, error }] = useAdminNotificationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationCreateMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>(AdminNotificationCreateDocument, options);
      }
export type AdminNotificationCreateMutationHookResult = ReturnType<typeof useAdminNotificationCreateMutation>;
export type AdminNotificationCreateMutationResult = Apollo.MutationResult<AdminNotificationCreateMutation>;
export type AdminNotificationCreateMutationOptions = Apollo.BaseMutationOptions<AdminNotificationCreateMutation, AdminNotificationCreateMutationVariables>;
export const AdminNotificationDeleteDocument = gql`
    mutation AdminNotificationDelete($input: AdminNotificationDeleteInput!) {
  adminNotificationDelete(input: $input)
}
    `;
export type AdminNotificationDeleteMutationFn = Apollo.MutationFunction<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>;

/**
 * __useAdminNotificationDeleteMutation__
 *
 * To run a mutation, you first call `useAdminNotificationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationDeleteMutation, { data, loading, error }] = useAdminNotificationDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>(AdminNotificationDeleteDocument, options);
      }
export type AdminNotificationDeleteMutationHookResult = ReturnType<typeof useAdminNotificationDeleteMutation>;
export type AdminNotificationDeleteMutationResult = Apollo.MutationResult<AdminNotificationDeleteMutation>;
export type AdminNotificationDeleteMutationOptions = Apollo.BaseMutationOptions<AdminNotificationDeleteMutation, AdminNotificationDeleteMutationVariables>;
export const AdminNotificationMemberDeleteDocument = gql`
    mutation AdminNotificationMemberDelete($input: AdminNotificationMemberDeleteInput!) {
  adminNotificationMemberDelete(input: $input)
}
    `;
export type AdminNotificationMemberDeleteMutationFn = Apollo.MutationFunction<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>;

/**
 * __useAdminNotificationMemberDeleteMutation__
 *
 * To run a mutation, you first call `useAdminNotificationMemberDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationMemberDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminNotificationMemberDeleteMutation, { data, loading, error }] = useAdminNotificationMemberDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminNotificationMemberDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>(AdminNotificationMemberDeleteDocument, options);
      }
export type AdminNotificationMemberDeleteMutationHookResult = ReturnType<typeof useAdminNotificationMemberDeleteMutation>;
export type AdminNotificationMemberDeleteMutationResult = Apollo.MutationResult<AdminNotificationMemberDeleteMutation>;
export type AdminNotificationMemberDeleteMutationOptions = Apollo.BaseMutationOptions<AdminNotificationMemberDeleteMutation, AdminNotificationMemberDeleteMutationVariables>;
export const AdminMemberNotificationsDocument = gql`
    query AdminMemberNotifications($args: AdminMemberNotificationsArgs!) {
  adminMemberNotifications(args: $args) {
    edges {
      cursor
      node {
        createdAt
        createdBy
        createdByAdminId
        createdByAdminName
        expiry
        expiryDate
        id
        message
        mode
        title
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminMemberNotificationsQuery__
 *
 * To run a query within a React component, call `useAdminMemberNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMemberNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMemberNotificationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminMemberNotificationsQuery(baseOptions: Apollo.QueryHookOptions<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>(AdminMemberNotificationsDocument, options);
      }
export function useAdminMemberNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>(AdminMemberNotificationsDocument, options);
        }
export type AdminMemberNotificationsQueryHookResult = ReturnType<typeof useAdminMemberNotificationsQuery>;
export type AdminMemberNotificationsLazyQueryHookResult = ReturnType<typeof useAdminMemberNotificationsLazyQuery>;
export type AdminMemberNotificationsQueryResult = Apollo.QueryResult<AdminMemberNotificationsQuery, AdminMemberNotificationsQueryVariables>;
export const AdminNotificationDocument = gql`
    query AdminNotification($args: AdminNotificationArgs!) {
  adminNotification(args: $args) {
    createdAt
    createdBy
    createdByAdminId
    createdByAdminName
    expiry
    expiryDate
    id
    message
    mode
    title
    updatedAt
  }
}
    `;

/**
 * __useAdminNotificationQuery__
 *
 * To run a query within a React component, call `useAdminNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotificationQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminNotificationQuery(baseOptions: Apollo.QueryHookOptions<AdminNotificationQuery, AdminNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNotificationQuery, AdminNotificationQueryVariables>(AdminNotificationDocument, options);
      }
export function useAdminNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotificationQuery, AdminNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNotificationQuery, AdminNotificationQueryVariables>(AdminNotificationDocument, options);
        }
export type AdminNotificationQueryHookResult = ReturnType<typeof useAdminNotificationQuery>;
export type AdminNotificationLazyQueryHookResult = ReturnType<typeof useAdminNotificationLazyQuery>;
export type AdminNotificationQueryResult = Apollo.QueryResult<AdminNotificationQuery, AdminNotificationQueryVariables>;
export const AdminNotificationsDocument = gql`
    query AdminNotifications($args: AdminNotificationsArgs!) {
  adminNotifications(args: $args) {
    edges {
      cursor
      node {
        createdAt
        createdBy
        createdByAdminId
        createdByAdminName
        expiry
        expiryDate
        id
        message
        title
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminNotificationsQuery__
 *
 * To run a query within a React component, call `useAdminNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminNotificationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminNotificationsQuery(baseOptions: Apollo.QueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
      }
export function useAdminNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminNotificationsQuery, AdminNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminNotificationsQuery, AdminNotificationsQueryVariables>(AdminNotificationsDocument, options);
        }
export type AdminNotificationsQueryHookResult = ReturnType<typeof useAdminNotificationsQuery>;
export type AdminNotificationsLazyQueryHookResult = ReturnType<typeof useAdminNotificationsLazyQuery>;
export type AdminNotificationsQueryResult = Apollo.QueryResult<AdminNotificationsQuery, AdminNotificationsQueryVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($input: AdminUpdateOrganizationInput!) {
  adminUpdateOrganization(input: $input) {
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    businessName
    createdAt
    email
    id
    organizationNumber
    phoneNumber
    updatedAt
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = Apollo.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const OrganizationDocument = gql`
    query Organization {
  organization {
    addressCity
    addressCountry
    addressPostalCode
    addressState
    addressStreet1
    addressStreet2
    businessName
    createdAt
    email
    id
    organizationNumber
    phoneNumber
    updatedAt
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const AdminUpdatePricingDocument = gql`
    mutation AdminUpdatePricing($input: AdminUpdatePricingInput!) {
  adminUpdatePricing(input: $input) {
    sgBayHourlyRate
    sgBayHourlyRateVIP
    sgBayMaxHours
    sgBayMaxPlayers
    sgBookingCancellationPenalty
    sgBookingLapsedPenalty
    sgHole18MaxHours
    sgHole18MaxPlayers
    sgHole18PerPlayerRate
    sgHole18PerPlayerRateVIP
    sgHole9MaxHours
    sgHole9MaxPlayers
    sgHole9PerPlayerRate
    sgHole9PerPlayerRateVIP
    sgLessonField
    sgLessonFieldVIP
    sgLessonIndoor
    sgLessonIndoorPuttingGreen
    sgLessonIndoorPuttingGreenVIP
    sgLessonIndoorVIP
    sgPrivateRoomHourlyRate
    sgPrivateRoomHourlyRateVIP
    sgPrivateRoomMaxHours
    sgPrivateRoomMaxPlayers
    sgPuttingGreenHourlyRate
    sgPuttingGreenHourlyRateVIP
    sgPuttingGreenMaxMins
    sgPuttingGreenMaxPlayers
    viBayHourlyRate
    viBayHourlyRateVIP
    viBayMaxHours
    viBayMaxPlayers
    viBookingCancellationPenalty
    viBookingLapsedPenalty
    viHole18MaxHours
    viHole18MaxPlayers
    viHole18PerPlayerRate
    viHole18PerPlayerRateVIP
    viHole9MaxHours
    viHole9MaxPlayers
    viHole9PerPlayerRate
    viHole9PerPlayerRateVIP
    viLessonField
    viLessonFieldVIP
    viLessonIndoor
    viLessonIndoorPuttingGreen
    viLessonIndoorPuttingGreenVIP
    viLessonIndoorVIP
    viPrivateRoomHourlyRate
    viPrivateRoomHourlyRateVIP
    viPrivateRoomMaxHours
    viPrivateRoomMaxPlayers
    viPuttingGreenHourlyRate
    viPuttingGreenHourlyRateVIP
    viPuttingGreenMaxMins
    viPuttingGreenMaxPlayers
  }
}
    `;
export type AdminUpdatePricingMutationFn = Apollo.MutationFunction<AdminUpdatePricingMutation, AdminUpdatePricingMutationVariables>;

/**
 * __useAdminUpdatePricingMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePricingMutation, { data, loading, error }] = useAdminUpdatePricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdatePricingMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePricingMutation, AdminUpdatePricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePricingMutation, AdminUpdatePricingMutationVariables>(AdminUpdatePricingDocument, options);
      }
export type AdminUpdatePricingMutationHookResult = ReturnType<typeof useAdminUpdatePricingMutation>;
export type AdminUpdatePricingMutationResult = Apollo.MutationResult<AdminUpdatePricingMutation>;
export type AdminUpdatePricingMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePricingMutation, AdminUpdatePricingMutationVariables>;
export const PricingDocument = gql`
    query Pricing {
  pricing {
    sgBayHourlyRate
    sgBayHourlyRateVIP
    sgBayMaxHours
    sgBayMaxPlayers
    sgBookingCancellationPenalty
    sgBookingLapsedPenalty
    sgHole18MaxHours
    sgHole18MaxPlayers
    sgHole18PerPlayerRate
    sgHole18PerPlayerRateVIP
    sgHole9MaxHours
    sgHole9MaxPlayers
    sgHole9PerPlayerRate
    sgHole9PerPlayerRateVIP
    sgLessonField
    sgLessonFieldVIP
    sgLessonIndoor
    sgLessonIndoorPuttingGreen
    sgLessonIndoorPuttingGreenVIP
    sgLessonIndoorVIP
    sgPrivateRoomHourlyRate
    sgPrivateRoomHourlyRateVIP
    sgPrivateRoomMaxHours
    sgPrivateRoomMaxPlayers
    sgPuttingGreenHourlyRate
    sgPuttingGreenHourlyRateVIP
    sgPuttingGreenMaxMins
    sgPuttingGreenMaxPlayers
    viBayHourlyRate
    viBayHourlyRateVIP
    viBayMaxHours
    viBayMaxPlayers
    viBookingCancellationPenalty
    viBookingLapsedPenalty
    viHole18MaxHours
    viHole18MaxPlayers
    viHole18PerPlayerRate
    viHole18PerPlayerRateVIP
    viHole9MaxHours
    viHole9MaxPlayers
    viHole9PerPlayerRate
    viHole9PerPlayerRateVIP
    viLessonField
    viLessonFieldVIP
    viLessonIndoor
    viLessonIndoorPuttingGreen
    viLessonIndoorPuttingGreenVIP
    viLessonIndoorVIP
    viPrivateRoomHourlyRate
    viPrivateRoomHourlyRateVIP
    viPrivateRoomMaxHours
    viPrivateRoomMaxPlayers
    viPuttingGreenHourlyRate
    viPuttingGreenHourlyRateVIP
    viPuttingGreenMaxMins
    viPuttingGreenMaxPlayers
  }
}
    `;

/**
 * __usePricingQuery__
 *
 * To run a query within a React component, call `usePricingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePricingQuery(baseOptions?: Apollo.QueryHookOptions<PricingQuery, PricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingQuery, PricingQueryVariables>(PricingDocument, options);
      }
export function usePricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingQuery, PricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingQuery, PricingQueryVariables>(PricingDocument, options);
        }
export type PricingQueryHookResult = ReturnType<typeof usePricingQuery>;
export type PricingLazyQueryHookResult = ReturnType<typeof usePricingLazyQuery>;
export type PricingQueryResult = Apollo.QueryResult<PricingQuery, PricingQueryVariables>;
export const AdminProductPackageAddDocument = gql`
    mutation AdminProductPackageAdd($input: AdminProductPackageAddInput!) {
  adminProductPackageAdd(input: $input)
}
    `;
export type AdminProductPackageAddMutationFn = Apollo.MutationFunction<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>;

/**
 * __useAdminProductPackageAddMutation__
 *
 * To run a mutation, you first call `useAdminProductPackageAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductPackageAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductPackageAddMutation, { data, loading, error }] = useAdminProductPackageAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductPackageAddMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>(AdminProductPackageAddDocument, options);
      }
export type AdminProductPackageAddMutationHookResult = ReturnType<typeof useAdminProductPackageAddMutation>;
export type AdminProductPackageAddMutationResult = Apollo.MutationResult<AdminProductPackageAddMutation>;
export type AdminProductPackageAddMutationOptions = Apollo.BaseMutationOptions<AdminProductPackageAddMutation, AdminProductPackageAddMutationVariables>;
export const AdminProductPackageManageDocument = gql`
    mutation AdminProductPackageManage($input: AdminProductPackageManageInput!) {
  adminProductPackageManage(input: $input)
}
    `;
export type AdminProductPackageManageMutationFn = Apollo.MutationFunction<AdminProductPackageManageMutation, AdminProductPackageManageMutationVariables>;

/**
 * __useAdminProductPackageManageMutation__
 *
 * To run a mutation, you first call `useAdminProductPackageManageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductPackageManageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductPackageManageMutation, { data, loading, error }] = useAdminProductPackageManageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductPackageManageMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductPackageManageMutation, AdminProductPackageManageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductPackageManageMutation, AdminProductPackageManageMutationVariables>(AdminProductPackageManageDocument, options);
      }
export type AdminProductPackageManageMutationHookResult = ReturnType<typeof useAdminProductPackageManageMutation>;
export type AdminProductPackageManageMutationResult = Apollo.MutationResult<AdminProductPackageManageMutation>;
export type AdminProductPackageManageMutationOptions = Apollo.BaseMutationOptions<AdminProductPackageManageMutation, AdminProductPackageManageMutationVariables>;
export const AdminProductsDocument = gql`
    query AdminProducts($args: AdminProductsArgs!) {
  adminProducts(args: $args) {
    edges {
      cursor
      node {
        baseCountryCode
        itemCode
        name
        price
        validity
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminProductsQuery__
 *
 * To run a query within a React component, call `useAdminProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminProductsQuery(baseOptions: Apollo.QueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
      }
export function useAdminProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export type AdminProductsQueryHookResult = ReturnType<typeof useAdminProductsQuery>;
export type AdminProductsLazyQueryHookResult = ReturnType<typeof useAdminProductsLazyQuery>;
export type AdminProductsQueryResult = Apollo.QueryResult<AdminProductsQuery, AdminProductsQueryVariables>;
export const AdminProductPackageExtensionsDocument = gql`
    query AdminProductPackageExtensions($args: AdminProductPackageExtensionsArgs!) {
  adminProductPackageExtensions(args: $args) {
    extensions {
      authorizedAdjusterName
      comment
      dateExtended
      daysAdded
      newExpiryDate
      prevExpiryDate
    }
  }
}
    `;

/**
 * __useAdminProductPackageExtensionsQuery__
 *
 * To run a query within a React component, call `useAdminProductPackageExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductPackageExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductPackageExtensionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminProductPackageExtensionsQuery(baseOptions: Apollo.QueryHookOptions<AdminProductPackageExtensionsQuery, AdminProductPackageExtensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductPackageExtensionsQuery, AdminProductPackageExtensionsQueryVariables>(AdminProductPackageExtensionsDocument, options);
      }
export function useAdminProductPackageExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductPackageExtensionsQuery, AdminProductPackageExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductPackageExtensionsQuery, AdminProductPackageExtensionsQueryVariables>(AdminProductPackageExtensionsDocument, options);
        }
export type AdminProductPackageExtensionsQueryHookResult = ReturnType<typeof useAdminProductPackageExtensionsQuery>;
export type AdminProductPackageExtensionsLazyQueryHookResult = ReturnType<typeof useAdminProductPackageExtensionsLazyQuery>;
export type AdminProductPackageExtensionsQueryResult = Apollo.QueryResult<AdminProductPackageExtensionsQuery, AdminProductPackageExtensionsQueryVariables>;
export const AdminReportUpdateOrderConnectionDocument = gql`
    mutation AdminReportUpdateOrderConnection($input: AdminReportUpdateOrderConnectionInput!) {
  adminReportUpdateOrderConnection(input: $input)
}
    `;
export type AdminReportUpdateOrderConnectionMutationFn = Apollo.MutationFunction<AdminReportUpdateOrderConnectionMutation, AdminReportUpdateOrderConnectionMutationVariables>;

/**
 * __useAdminReportUpdateOrderConnectionMutation__
 *
 * To run a mutation, you first call `useAdminReportUpdateOrderConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReportUpdateOrderConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReportUpdateOrderConnectionMutation, { data, loading, error }] = useAdminReportUpdateOrderConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminReportUpdateOrderConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AdminReportUpdateOrderConnectionMutation, AdminReportUpdateOrderConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminReportUpdateOrderConnectionMutation, AdminReportUpdateOrderConnectionMutationVariables>(AdminReportUpdateOrderConnectionDocument, options);
      }
export type AdminReportUpdateOrderConnectionMutationHookResult = ReturnType<typeof useAdminReportUpdateOrderConnectionMutation>;
export type AdminReportUpdateOrderConnectionMutationResult = Apollo.MutationResult<AdminReportUpdateOrderConnectionMutation>;
export type AdminReportUpdateOrderConnectionMutationOptions = Apollo.BaseMutationOptions<AdminReportUpdateOrderConnectionMutation, AdminReportUpdateOrderConnectionMutationVariables>;
export const AdminReportOrderRecordStatusUpdateDocument = gql`
    mutation AdminReportOrderRecordStatusUpdate($input: AdminReportOrderRecordStatusUpdateInput!) {
  adminReportOrderRecordStatusUpdate(input: $input) {
    status
  }
}
    `;
export type AdminReportOrderRecordStatusUpdateMutationFn = Apollo.MutationFunction<AdminReportOrderRecordStatusUpdateMutation, AdminReportOrderRecordStatusUpdateMutationVariables>;

/**
 * __useAdminReportOrderRecordStatusUpdateMutation__
 *
 * To run a mutation, you first call `useAdminReportOrderRecordStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReportOrderRecordStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReportOrderRecordStatusUpdateMutation, { data, loading, error }] = useAdminReportOrderRecordStatusUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminReportOrderRecordStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AdminReportOrderRecordStatusUpdateMutation, AdminReportOrderRecordStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminReportOrderRecordStatusUpdateMutation, AdminReportOrderRecordStatusUpdateMutationVariables>(AdminReportOrderRecordStatusUpdateDocument, options);
      }
export type AdminReportOrderRecordStatusUpdateMutationHookResult = ReturnType<typeof useAdminReportOrderRecordStatusUpdateMutation>;
export type AdminReportOrderRecordStatusUpdateMutationResult = Apollo.MutationResult<AdminReportOrderRecordStatusUpdateMutation>;
export type AdminReportOrderRecordStatusUpdateMutationOptions = Apollo.BaseMutationOptions<AdminReportOrderRecordStatusUpdateMutation, AdminReportOrderRecordStatusUpdateMutationVariables>;
export const AdminSimulatorUsageDocument = gql`
    query AdminSimulatorUsage($args: AdminSimulatorUsageArgs!) {
  adminSimulatorUsage(args: $args)
}
    `;

/**
 * __useAdminSimulatorUsageQuery__
 *
 * To run a query within a React component, call `useAdminSimulatorUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSimulatorUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSimulatorUsageQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminSimulatorUsageQuery(baseOptions: Apollo.QueryHookOptions<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>(AdminSimulatorUsageDocument, options);
      }
export function useAdminSimulatorUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>(AdminSimulatorUsageDocument, options);
        }
export type AdminSimulatorUsageQueryHookResult = ReturnType<typeof useAdminSimulatorUsageQuery>;
export type AdminSimulatorUsageLazyQueryHookResult = ReturnType<typeof useAdminSimulatorUsageLazyQuery>;
export type AdminSimulatorUsageQueryResult = Apollo.QueryResult<AdminSimulatorUsageQuery, AdminSimulatorUsageQueryVariables>;
export const AdminReportCreditTransactionsDocument = gql`
    query AdminReportCreditTransactions($args: AdminReportCreditTransactionsArgs!) {
  adminReportCreditTransactions(args: $args) {
    edges {
      cursor
      node {
        amount
        createdAt
        description
        id
        member {
          firstName
          individualId
          lastName
        }
        memberId
        membershipId
        type
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportCreditTransactionsQuery__
 *
 * To run a query within a React component, call `useAdminReportCreditTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportCreditTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportCreditTransactionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportCreditTransactionsQuery(baseOptions: Apollo.QueryHookOptions<AdminReportCreditTransactionsQuery, AdminReportCreditTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportCreditTransactionsQuery, AdminReportCreditTransactionsQueryVariables>(AdminReportCreditTransactionsDocument, options);
      }
export function useAdminReportCreditTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportCreditTransactionsQuery, AdminReportCreditTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportCreditTransactionsQuery, AdminReportCreditTransactionsQueryVariables>(AdminReportCreditTransactionsDocument, options);
        }
export type AdminReportCreditTransactionsQueryHookResult = ReturnType<typeof useAdminReportCreditTransactionsQuery>;
export type AdminReportCreditTransactionsLazyQueryHookResult = ReturnType<typeof useAdminReportCreditTransactionsLazyQuery>;
export type AdminReportCreditTransactionsQueryResult = Apollo.QueryResult<AdminReportCreditTransactionsQuery, AdminReportCreditTransactionsQueryVariables>;
export const AdminReportHitPayChargesDocument = gql`
    query AdminReportHitPayCharges($args: AdminReportHitPayChargesArgs!) {
  adminReportHitPayCharges(args: $args) {
    edges {
      cursor
      node {
        amount
        buyer_email
        buyer_name
        buyer_phone
        created_at
        currency
        fees
        id
        payment_method
        payment_type
        quantity
        refunded_amount
        status
        updated_at
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportHitPayChargesQuery__
 *
 * To run a query within a React component, call `useAdminReportHitPayChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportHitPayChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportHitPayChargesQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportHitPayChargesQuery(baseOptions: Apollo.QueryHookOptions<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>(AdminReportHitPayChargesDocument, options);
      }
export function useAdminReportHitPayChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>(AdminReportHitPayChargesDocument, options);
        }
export type AdminReportHitPayChargesQueryHookResult = ReturnType<typeof useAdminReportHitPayChargesQuery>;
export type AdminReportHitPayChargesLazyQueryHookResult = ReturnType<typeof useAdminReportHitPayChargesLazyQuery>;
export type AdminReportHitPayChargesQueryResult = Apollo.QueryResult<AdminReportHitPayChargesQuery, AdminReportHitPayChargesQueryVariables>;
export const AdminReportMemberStatsDocument = gql`
    query AdminReportMemberStats($args: AdminReportMemberStatsArgs!) {
  adminReportMemberStats(args: $args) {
    edges {
      cursor
      node {
        firstName
        id
        individualId
        lastName
        stat
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportMemberStatsQuery__
 *
 * To run a query within a React component, call `useAdminReportMemberStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportMemberStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportMemberStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportMemberStatsQuery(baseOptions: Apollo.QueryHookOptions<AdminReportMemberStatsQuery, AdminReportMemberStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportMemberStatsQuery, AdminReportMemberStatsQueryVariables>(AdminReportMemberStatsDocument, options);
      }
export function useAdminReportMemberStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportMemberStatsQuery, AdminReportMemberStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportMemberStatsQuery, AdminReportMemberStatsQueryVariables>(AdminReportMemberStatsDocument, options);
        }
export type AdminReportMemberStatsQueryHookResult = ReturnType<typeof useAdminReportMemberStatsQuery>;
export type AdminReportMemberStatsLazyQueryHookResult = ReturnType<typeof useAdminReportMemberStatsLazyQuery>;
export type AdminReportMemberStatsQueryResult = Apollo.QueryResult<AdminReportMemberStatsQuery, AdminReportMemberStatsQueryVariables>;
export const AdminReportOrderDocument = gql`
    query AdminReportOrder($args: AdminReportOrderArgs!) {
  adminReportOrder(args: $args) {
    additionalDiscount
    date
    discountPercent
    eMenuCustomerName
    eMenuMemberCardNo
    gst
    isEMenuOrder
    lineItems {
      brand
      category
      date
      eMenuId
      id
      itemCode
      itemName
      mainCategory
      mCategoryId
      orderId
      price
      qty
      salesPrice
      transactionId
      vendor
    }
    memberDiscount
    memberId
    memberIndividualId
    memberName
    membershipId
    metadata
    nonMemberCustomer
    orderNo
    paymentCurrency
    paymentMethod
    serviceCharge
    subTotal
    total
    venue
  }
}
    `;

/**
 * __useAdminReportOrderQuery__
 *
 * To run a query within a React component, call `useAdminReportOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportOrderQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportOrderQuery(baseOptions: Apollo.QueryHookOptions<AdminReportOrderQuery, AdminReportOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportOrderQuery, AdminReportOrderQueryVariables>(AdminReportOrderDocument, options);
      }
export function useAdminReportOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportOrderQuery, AdminReportOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportOrderQuery, AdminReportOrderQueryVariables>(AdminReportOrderDocument, options);
        }
export type AdminReportOrderQueryHookResult = ReturnType<typeof useAdminReportOrderQuery>;
export type AdminReportOrderLazyQueryHookResult = ReturnType<typeof useAdminReportOrderLazyQuery>;
export type AdminReportOrderQueryResult = Apollo.QueryResult<AdminReportOrderQuery, AdminReportOrderQueryVariables>;
export const AdminReportOrdersDocument = gql`
    query AdminReportOrders($args: AdminReportOrdersArgs!) {
  adminReportOrders(args: $args) {
    edges {
      cursor
      node {
        date
        eMenuCustomerName
        memberName
        metadata
        nonMemberCustomer
        orderNo
        paymentCurrency
        paymentMethod
        status
        subTotal
        total
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      noOfNonConnectedOrders
      total
    }
  }
}
    `;

/**
 * __useAdminReportOrdersQuery__
 *
 * To run a query within a React component, call `useAdminReportOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportOrdersQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportOrdersQuery(baseOptions: Apollo.QueryHookOptions<AdminReportOrdersQuery, AdminReportOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportOrdersQuery, AdminReportOrdersQueryVariables>(AdminReportOrdersDocument, options);
      }
export function useAdminReportOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportOrdersQuery, AdminReportOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportOrdersQuery, AdminReportOrdersQueryVariables>(AdminReportOrdersDocument, options);
        }
export type AdminReportOrdersQueryHookResult = ReturnType<typeof useAdminReportOrdersQuery>;
export type AdminReportOrdersLazyQueryHookResult = ReturnType<typeof useAdminReportOrdersLazyQuery>;
export type AdminReportOrdersQueryResult = Apollo.QueryResult<AdminReportOrdersQuery, AdminReportOrdersQueryVariables>;
export const AdminReportSubscriptionsDocument = gql`
    query AdminReportSubscriptions($args: AdminReportSubscriptionsArgs!) {
  adminReportSubscriptions(args: $args) {
    edges {
      cursor
      node {
        amount
        creditDeducted
        description
        endDate
        id
        membershipId
        startDate
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminReportSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAdminReportSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminReportSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminReportSubscriptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminReportSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AdminReportSubscriptionsQuery, AdminReportSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminReportSubscriptionsQuery, AdminReportSubscriptionsQueryVariables>(AdminReportSubscriptionsDocument, options);
      }
export function useAdminReportSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminReportSubscriptionsQuery, AdminReportSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminReportSubscriptionsQuery, AdminReportSubscriptionsQueryVariables>(AdminReportSubscriptionsDocument, options);
        }
export type AdminReportSubscriptionsQueryHookResult = ReturnType<typeof useAdminReportSubscriptionsQuery>;
export type AdminReportSubscriptionsLazyQueryHookResult = ReturnType<typeof useAdminReportSubscriptionsLazyQuery>;
export type AdminReportSubscriptionsQueryResult = Apollo.QueryResult<AdminReportSubscriptionsQuery, AdminReportSubscriptionsQueryVariables>;
export const AdminClientLoginGuestDocument = gql`
    mutation AdminClientLoginGuest($input: AdminClientLoginGuestInput!) {
  adminClientLoginGuest(input: $input)
}
    `;
export type AdminClientLoginGuestMutationFn = Apollo.MutationFunction<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>;

/**
 * __useAdminClientLoginGuestMutation__
 *
 * To run a mutation, you first call `useAdminClientLoginGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminClientLoginGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminClientLoginGuestMutation, { data, loading, error }] = useAdminClientLoginGuestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminClientLoginGuestMutation(baseOptions?: Apollo.MutationHookOptions<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>(AdminClientLoginGuestDocument, options);
      }
export type AdminClientLoginGuestMutationHookResult = ReturnType<typeof useAdminClientLoginGuestMutation>;
export type AdminClientLoginGuestMutationResult = Apollo.MutationResult<AdminClientLoginGuestMutation>;
export type AdminClientLoginGuestMutationOptions = Apollo.BaseMutationOptions<AdminClientLoginGuestMutation, AdminClientLoginGuestMutationVariables>;
export const AdminExtendClientTimeDocument = gql`
    mutation AdminExtendClientTime($input: AdminExtendClientTimeInput!) {
  adminExtendClientTime(input: $input)
}
    `;
export type AdminExtendClientTimeMutationFn = Apollo.MutationFunction<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>;

/**
 * __useAdminExtendClientTimeMutation__
 *
 * To run a mutation, you first call `useAdminExtendClientTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminExtendClientTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminExtendClientTimeMutation, { data, loading, error }] = useAdminExtendClientTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminExtendClientTimeMutation(baseOptions?: Apollo.MutationHookOptions<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>(AdminExtendClientTimeDocument, options);
      }
export type AdminExtendClientTimeMutationHookResult = ReturnType<typeof useAdminExtendClientTimeMutation>;
export type AdminExtendClientTimeMutationResult = Apollo.MutationResult<AdminExtendClientTimeMutation>;
export type AdminExtendClientTimeMutationOptions = Apollo.BaseMutationOptions<AdminExtendClientTimeMutation, AdminExtendClientTimeMutationVariables>;
export const AdminLockClientDocument = gql`
    mutation AdminLockClient($input: AdminLockClientInput!) {
  adminLockClient(input: $input)
}
    `;
export type AdminLockClientMutationFn = Apollo.MutationFunction<AdminLockClientMutation, AdminLockClientMutationVariables>;

/**
 * __useAdminLockClientMutation__
 *
 * To run a mutation, you first call `useAdminLockClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLockClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLockClientMutation, { data, loading, error }] = useAdminLockClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminLockClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminLockClientMutation, AdminLockClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLockClientMutation, AdminLockClientMutationVariables>(AdminLockClientDocument, options);
      }
export type AdminLockClientMutationHookResult = ReturnType<typeof useAdminLockClientMutation>;
export type AdminLockClientMutationResult = Apollo.MutationResult<AdminLockClientMutation>;
export type AdminLockClientMutationOptions = Apollo.BaseMutationOptions<AdminLockClientMutation, AdminLockClientMutationVariables>;
export const AdminShopSendNotificationDocument = gql`
    mutation AdminShopSendNotification($input: AdminShopSendNotificationInput!) {
  adminShopSendNotification(input: $input)
}
    `;
export type AdminShopSendNotificationMutationFn = Apollo.MutationFunction<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>;

/**
 * __useAdminShopSendNotificationMutation__
 *
 * To run a mutation, you first call `useAdminShopSendNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopSendNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopSendNotificationMutation, { data, loading, error }] = useAdminShopSendNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopSendNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>(AdminShopSendNotificationDocument, options);
      }
export type AdminShopSendNotificationMutationHookResult = ReturnType<typeof useAdminShopSendNotificationMutation>;
export type AdminShopSendNotificationMutationResult = Apollo.MutationResult<AdminShopSendNotificationMutation>;
export type AdminShopSendNotificationMutationOptions = Apollo.BaseMutationOptions<AdminShopSendNotificationMutation, AdminShopSendNotificationMutationVariables>;
export const AdminUnlockClientDocument = gql`
    mutation AdminUnlockClient($input: AdminUnlockClientInput!) {
  adminUnlockClient(input: $input)
}
    `;
export type AdminUnlockClientMutationFn = Apollo.MutationFunction<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>;

/**
 * __useAdminUnlockClientMutation__
 *
 * To run a mutation, you first call `useAdminUnlockClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUnlockClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUnlockClientMutation, { data, loading, error }] = useAdminUnlockClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUnlockClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>(AdminUnlockClientDocument, options);
      }
export type AdminUnlockClientMutationHookResult = ReturnType<typeof useAdminUnlockClientMutation>;
export type AdminUnlockClientMutationResult = Apollo.MutationResult<AdminUnlockClientMutation>;
export type AdminUnlockClientMutationOptions = Apollo.BaseMutationOptions<AdminUnlockClientMutation, AdminUnlockClientMutationVariables>;
export const AdminUpdateClientContentLimitDocument = gql`
    mutation AdminUpdateClientContentLimit($input: AdminUpdateClientContentLimitInput!) {
  adminUpdateClientContentLimit(input: $input)
}
    `;
export type AdminUpdateClientContentLimitMutationFn = Apollo.MutationFunction<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>;

/**
 * __useAdminUpdateClientContentLimitMutation__
 *
 * To run a mutation, you first call `useAdminUpdateClientContentLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateClientContentLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateClientContentLimitMutation, { data, loading, error }] = useAdminUpdateClientContentLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateClientContentLimitMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>(AdminUpdateClientContentLimitDocument, options);
      }
export type AdminUpdateClientContentLimitMutationHookResult = ReturnType<typeof useAdminUpdateClientContentLimitMutation>;
export type AdminUpdateClientContentLimitMutationResult = Apollo.MutationResult<AdminUpdateClientContentLimitMutation>;
export type AdminUpdateClientContentLimitMutationOptions = Apollo.BaseMutationOptions<AdminUpdateClientContentLimitMutation, AdminUpdateClientContentLimitMutationVariables>;
export const AdminUpdateShopDetailsDocument = gql`
    mutation AdminUpdateShopDetails($input: AdminUpdateShopDetailsInput!) {
  adminUpdateShopDetails(input: $input) {
    address1
    address2
    CDN
    clientType {
      lesson
      practice
      screen
    }
    country
    currency
    isEquipmentStorage
    isLeftHanded
    isParking
    isProLesson
    isShopCloseNextDay
    isSwingplate
    ownerEmail
    ownerMobilePhone
    ownerMobilePhoneCountry
    ownerName
    shopCloseTime
    shopGuid
    shopName
    shopOpenTime
    shopPhone
    zipcode
  }
}
    `;
export type AdminUpdateShopDetailsMutationFn = Apollo.MutationFunction<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>;

/**
 * __useAdminUpdateShopDetailsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopDetailsMutation, { data, loading, error }] = useAdminUpdateShopDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>(AdminUpdateShopDetailsDocument, options);
      }
export type AdminUpdateShopDetailsMutationHookResult = ReturnType<typeof useAdminUpdateShopDetailsMutation>;
export type AdminUpdateShopDetailsMutationResult = Apollo.MutationResult<AdminUpdateShopDetailsMutation>;
export type AdminUpdateShopDetailsMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopDetailsMutation, AdminUpdateShopDetailsMutationVariables>;
export const AdminUpdateShopOptionsDrivingRangeDocument = gql`
    mutation AdminUpdateShopOptionsDrivingRange($input: AdminUpdateShopOptionsDrivingRangeInput!) {
  adminUpdateShopOptionsDrivingRange(input: $input) {
    courseId
    difficulty
    distanceUnit
    isBallTrajectory
    isFixedCamera
    isSwingVideo
    teeHeight
    useSwingPlate
    windSpeed
  }
}
    `;
export type AdminUpdateShopOptionsDrivingRangeMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>;

/**
 * __useAdminUpdateShopOptionsDrivingRangeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsDrivingRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsDrivingRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsDrivingRangeMutation, { data, loading, error }] = useAdminUpdateShopOptionsDrivingRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsDrivingRangeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>(AdminUpdateShopOptionsDrivingRangeDocument, options);
      }
export type AdminUpdateShopOptionsDrivingRangeMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsDrivingRangeMutation>;
export type AdminUpdateShopOptionsDrivingRangeMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsDrivingRangeMutation>;
export type AdminUpdateShopOptionsDrivingRangeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsDrivingRangeMutation, AdminUpdateShopOptionsDrivingRangeMutationVariables>;
export const AdminUpdateShopOptionsRealTimeDocument = gql`
    mutation AdminUpdateShopOptionsRealTime($input: AdminUpdateShopOptionsRealTimeInput!) {
  adminUpdateShopOptionsRealTime(input: $input) {
    drivingRangeTimeLimit
    gameHoleTypeLimit
    gameTypeLimit
    isContentLimit
    paymentType
    playerCountLimit
    usageTime
  }
}
    `;
export type AdminUpdateShopOptionsRealTimeMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>;

/**
 * __useAdminUpdateShopOptionsRealTimeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsRealTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsRealTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsRealTimeMutation, { data, loading, error }] = useAdminUpdateShopOptionsRealTimeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsRealTimeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>(AdminUpdateShopOptionsRealTimeDocument, options);
      }
export type AdminUpdateShopOptionsRealTimeMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsRealTimeMutation>;
export type AdminUpdateShopOptionsRealTimeMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsRealTimeMutation>;
export type AdminUpdateShopOptionsRealTimeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsRealTimeMutation, AdminUpdateShopOptionsRealTimeMutationVariables>;
export const AdminUpdateShopOptionsRoundDocument = gql`
    mutation AdminUpdateShopOptionsRound($input: AdminUpdateShopOptionsRoundInput!) {
  adminUpdateShopOptionsRound(input: $input) {
    concede
    distanceUnit
    greenLocation
    greenSpeed
    holeCupLocation
    isBestVideo
    isCaddyVoice
    isUseObHazardTee
    mulliganCount
    puttingLine
    useSwingPlate
    windSpeed
  }
}
    `;
export type AdminUpdateShopOptionsRoundMutationFn = Apollo.MutationFunction<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>;

/**
 * __useAdminUpdateShopOptionsRoundMutation__
 *
 * To run a mutation, you first call `useAdminUpdateShopOptionsRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateShopOptionsRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateShopOptionsRoundMutation, { data, loading, error }] = useAdminUpdateShopOptionsRoundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateShopOptionsRoundMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>(AdminUpdateShopOptionsRoundDocument, options);
      }
export type AdminUpdateShopOptionsRoundMutationHookResult = ReturnType<typeof useAdminUpdateShopOptionsRoundMutation>;
export type AdminUpdateShopOptionsRoundMutationResult = Apollo.MutationResult<AdminUpdateShopOptionsRoundMutation>;
export type AdminUpdateShopOptionsRoundMutationOptions = Apollo.BaseMutationOptions<AdminUpdateShopOptionsRoundMutation, AdminUpdateShopOptionsRoundMutationVariables>;
export const AdminShopGetNotificationDocument = gql`
    mutation AdminShopGetNotification($input: AdminShopGetNotificationInput!) {
  adminShopGetNotification(input: $input) {
    message
  }
}
    `;
export type AdminShopGetNotificationMutationFn = Apollo.MutationFunction<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>;

/**
 * __useAdminShopGetNotificationMutation__
 *
 * To run a mutation, you first call `useAdminShopGetNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopGetNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopGetNotificationMutation, { data, loading, error }] = useAdminShopGetNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopGetNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>(AdminShopGetNotificationDocument, options);
      }
export type AdminShopGetNotificationMutationHookResult = ReturnType<typeof useAdminShopGetNotificationMutation>;
export type AdminShopGetNotificationMutationResult = Apollo.MutationResult<AdminShopGetNotificationMutation>;
export type AdminShopGetNotificationMutationOptions = Apollo.BaseMutationOptions<AdminShopGetNotificationMutation, AdminShopGetNotificationMutationVariables>;
export const AdminGameHistoryDocument = gql`
    query AdminGameHistory($args: AdminGameHistoryArgs!) {
  adminGameHistory(args: $args) {
    currentPage
    list {
      clientName
      completeHoleCount
      endTime
      gameRoundId
      gameType
      gameTypeCode
      playerCount
      startTime
    }
    maxPage
    totalCount
  }
}
    `;

/**
 * __useAdminGameHistoryQuery__
 *
 * To run a query within a React component, call `useAdminGameHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGameHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGameHistoryQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminGameHistoryQuery(baseOptions: Apollo.QueryHookOptions<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>(AdminGameHistoryDocument, options);
      }
export function useAdminGameHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>(AdminGameHistoryDocument, options);
        }
export type AdminGameHistoryQueryHookResult = ReturnType<typeof useAdminGameHistoryQuery>;
export type AdminGameHistoryLazyQueryHookResult = ReturnType<typeof useAdminGameHistoryLazyQuery>;
export type AdminGameHistoryQueryResult = Apollo.QueryResult<AdminGameHistoryQuery, AdminGameHistoryQueryVariables>;
export const AdminClientStatusDocument = gql`
    query AdminClientStatus($args: AdminClientStatusArgs!) {
  adminClientStatus(args: $args) {
    clients
    shopGuid
  }
}
    `;

/**
 * __useAdminClientStatusQuery__
 *
 * To run a query within a React component, call `useAdminClientStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClientStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClientStatusQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminClientStatusQuery(baseOptions: Apollo.QueryHookOptions<AdminClientStatusQuery, AdminClientStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminClientStatusQuery, AdminClientStatusQueryVariables>(AdminClientStatusDocument, options);
      }
export function useAdminClientStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminClientStatusQuery, AdminClientStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminClientStatusQuery, AdminClientStatusQueryVariables>(AdminClientStatusDocument, options);
        }
export type AdminClientStatusQueryHookResult = ReturnType<typeof useAdminClientStatusQuery>;
export type AdminClientStatusLazyQueryHookResult = ReturnType<typeof useAdminClientStatusLazyQuery>;
export type AdminClientStatusQueryResult = Apollo.QueryResult<AdminClientStatusQuery, AdminClientStatusQueryVariables>;
export const AdminScoreCardDocument = gql`
    query AdminScoreCard($args: AdminScoreCardArgs!) {
  adminScoreCard(args: $args)
}
    `;

/**
 * __useAdminScoreCardQuery__
 *
 * To run a query within a React component, call `useAdminScoreCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminScoreCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminScoreCardQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminScoreCardQuery(baseOptions: Apollo.QueryHookOptions<AdminScoreCardQuery, AdminScoreCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminScoreCardQuery, AdminScoreCardQueryVariables>(AdminScoreCardDocument, options);
      }
export function useAdminScoreCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminScoreCardQuery, AdminScoreCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminScoreCardQuery, AdminScoreCardQueryVariables>(AdminScoreCardDocument, options);
        }
export type AdminScoreCardQueryHookResult = ReturnType<typeof useAdminScoreCardQuery>;
export type AdminScoreCardLazyQueryHookResult = ReturnType<typeof useAdminScoreCardLazyQuery>;
export type AdminScoreCardQueryResult = Apollo.QueryResult<AdminScoreCardQuery, AdminScoreCardQueryVariables>;
export const AdminShopDetailsDocument = gql`
    query AdminShopDetails($args: AdminShopDetailsArg!) {
  adminShopDetails(args: $args) {
    address1
    address2
    CDN
    clientType {
      lesson
      practice
      screen
    }
    country
    currency
    isEquipmentStorage
    isLeftHanded
    isParking
    isProLesson
    isShopCloseNextDay
    isSwingplate
    ownerEmail
    ownerMobilePhone
    ownerMobilePhoneCountry
    ownerName
    shopCloseTime
    shopGuid
    shopName
    shopOpenTime
    shopPhone
    zipcode
  }
}
    `;

/**
 * __useAdminShopDetailsQuery__
 *
 * To run a query within a React component, call `useAdminShopDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopDetailsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>(AdminShopDetailsDocument, options);
      }
export function useAdminShopDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>(AdminShopDetailsDocument, options);
        }
export type AdminShopDetailsQueryHookResult = ReturnType<typeof useAdminShopDetailsQuery>;
export type AdminShopDetailsLazyQueryHookResult = ReturnType<typeof useAdminShopDetailsLazyQuery>;
export type AdminShopDetailsQueryResult = Apollo.QueryResult<AdminShopDetailsQuery, AdminShopDetailsQueryVariables>;
export const AdminShopOptionsDrivingRangeDocument = gql`
    query AdminShopOptionsDrivingRange($args: AdminShopOptionsDrivingRangeArgs!) {
  adminShopOptionsDrivingRange(args: $args) {
    courseId
    difficulty
    distanceUnit
    isBallTrajectory
    isFixedCamera
    isSwingVideo
    teeHeight
    useSwingPlate
    windSpeed
  }
}
    `;

/**
 * __useAdminShopOptionsDrivingRangeQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsDrivingRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsDrivingRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsDrivingRangeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsDrivingRangeQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>(AdminShopOptionsDrivingRangeDocument, options);
      }
export function useAdminShopOptionsDrivingRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>(AdminShopOptionsDrivingRangeDocument, options);
        }
export type AdminShopOptionsDrivingRangeQueryHookResult = ReturnType<typeof useAdminShopOptionsDrivingRangeQuery>;
export type AdminShopOptionsDrivingRangeLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsDrivingRangeLazyQuery>;
export type AdminShopOptionsDrivingRangeQueryResult = Apollo.QueryResult<AdminShopOptionsDrivingRangeQuery, AdminShopOptionsDrivingRangeQueryVariables>;
export const AdminShopOptionsRealTimeDocument = gql`
    query AdminShopOptionsRealTime($args: AdminShopOptionsRealTimeArgs!) {
  adminShopOptionsRealTime(args: $args) {
    drivingRangeTimeLimit
    gameHoleTypeLimit
    gameTypeLimit
    isContentLimit
    paymentType
    playerCountLimit
    usageTime
  }
}
    `;

/**
 * __useAdminShopOptionsRealTimeQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsRealTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsRealTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsRealTimeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsRealTimeQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>(AdminShopOptionsRealTimeDocument, options);
      }
export function useAdminShopOptionsRealTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>(AdminShopOptionsRealTimeDocument, options);
        }
export type AdminShopOptionsRealTimeQueryHookResult = ReturnType<typeof useAdminShopOptionsRealTimeQuery>;
export type AdminShopOptionsRealTimeLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsRealTimeLazyQuery>;
export type AdminShopOptionsRealTimeQueryResult = Apollo.QueryResult<AdminShopOptionsRealTimeQuery, AdminShopOptionsRealTimeQueryVariables>;
export const AdminShopOptionsRoundDocument = gql`
    query AdminShopOptionsRound($args: AdminShopOptionsRoundArgs!) {
  adminShopOptionsRound(args: $args) {
    concede
    distanceUnit
    greenLocation
    greenSpeed
    holeCupLocation
    isBestVideo
    isCaddyVoice
    isUseObHazardTee
    mulliganCount
    puttingLine
    useSwingPlate
    windSpeed
  }
}
    `;

/**
 * __useAdminShopOptionsRoundQuery__
 *
 * To run a query within a React component, call `useAdminShopOptionsRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopOptionsRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminShopOptionsRoundQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminShopOptionsRoundQuery(baseOptions: Apollo.QueryHookOptions<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>(AdminShopOptionsRoundDocument, options);
      }
export function useAdminShopOptionsRoundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>(AdminShopOptionsRoundDocument, options);
        }
export type AdminShopOptionsRoundQueryHookResult = ReturnType<typeof useAdminShopOptionsRoundQuery>;
export type AdminShopOptionsRoundLazyQueryHookResult = ReturnType<typeof useAdminShopOptionsRoundLazyQuery>;
export type AdminShopOptionsRoundQueryResult = Apollo.QueryResult<AdminShopOptionsRoundQuery, AdminShopOptionsRoundQueryVariables>;
export const DevManagementSystemAdminNotificationSendDocument = gql`
    mutation DevManagementSystemAdminNotificationSend($input: DevManagementSystemAdminNotificationSendInput!) {
  devManagementSystemAdminNotificationSend(input: $input)
}
    `;
export type DevManagementSystemAdminNotificationSendMutationFn = Apollo.MutationFunction<DevManagementSystemAdminNotificationSendMutation, DevManagementSystemAdminNotificationSendMutationVariables>;

/**
 * __useDevManagementSystemAdminNotificationSendMutation__
 *
 * To run a mutation, you first call `useDevManagementSystemAdminNotificationSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemAdminNotificationSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devManagementSystemAdminNotificationSendMutation, { data, loading, error }] = useDevManagementSystemAdminNotificationSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevManagementSystemAdminNotificationSendMutation(baseOptions?: Apollo.MutationHookOptions<DevManagementSystemAdminNotificationSendMutation, DevManagementSystemAdminNotificationSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevManagementSystemAdminNotificationSendMutation, DevManagementSystemAdminNotificationSendMutationVariables>(DevManagementSystemAdminNotificationSendDocument, options);
      }
export type DevManagementSystemAdminNotificationSendMutationHookResult = ReturnType<typeof useDevManagementSystemAdminNotificationSendMutation>;
export type DevManagementSystemAdminNotificationSendMutationResult = Apollo.MutationResult<DevManagementSystemAdminNotificationSendMutation>;
export type DevManagementSystemAdminNotificationSendMutationOptions = Apollo.BaseMutationOptions<DevManagementSystemAdminNotificationSendMutation, DevManagementSystemAdminNotificationSendMutationVariables>;
export const DevManagementSystemServerEnvironmentsDocument = gql`
    query DevManagementSystemServerEnvironments {
  devManagementSystemServerEnvironments {
    environments
  }
}
    `;

/**
 * __useDevManagementSystemServerEnvironmentsQuery__
 *
 * To run a query within a React component, call `useDevManagementSystemServerEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemServerEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevManagementSystemServerEnvironmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevManagementSystemServerEnvironmentsQuery(baseOptions?: Apollo.QueryHookOptions<DevManagementSystemServerEnvironmentsQuery, DevManagementSystemServerEnvironmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevManagementSystemServerEnvironmentsQuery, DevManagementSystemServerEnvironmentsQueryVariables>(DevManagementSystemServerEnvironmentsDocument, options);
      }
export function useDevManagementSystemServerEnvironmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevManagementSystemServerEnvironmentsQuery, DevManagementSystemServerEnvironmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevManagementSystemServerEnvironmentsQuery, DevManagementSystemServerEnvironmentsQueryVariables>(DevManagementSystemServerEnvironmentsDocument, options);
        }
export type DevManagementSystemServerEnvironmentsQueryHookResult = ReturnType<typeof useDevManagementSystemServerEnvironmentsQuery>;
export type DevManagementSystemServerEnvironmentsLazyQueryHookResult = ReturnType<typeof useDevManagementSystemServerEnvironmentsLazyQuery>;
export type DevManagementSystemServerEnvironmentsQueryResult = Apollo.QueryResult<DevManagementSystemServerEnvironmentsQuery, DevManagementSystemServerEnvironmentsQueryVariables>;
export const DevManagementSystemServerStatusDocument = gql`
    mutation DevManagementSystemServerStatus {
  devManagementSystemServerStatus {
    dbService {
      envType
      url
    }
  }
}
    `;
export type DevManagementSystemServerStatusMutationFn = Apollo.MutationFunction<DevManagementSystemServerStatusMutation, DevManagementSystemServerStatusMutationVariables>;

/**
 * __useDevManagementSystemServerStatusMutation__
 *
 * To run a mutation, you first call `useDevManagementSystemServerStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemServerStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devManagementSystemServerStatusMutation, { data, loading, error }] = useDevManagementSystemServerStatusMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevManagementSystemServerStatusMutation(baseOptions?: Apollo.MutationHookOptions<DevManagementSystemServerStatusMutation, DevManagementSystemServerStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevManagementSystemServerStatusMutation, DevManagementSystemServerStatusMutationVariables>(DevManagementSystemServerStatusDocument, options);
      }
export type DevManagementSystemServerStatusMutationHookResult = ReturnType<typeof useDevManagementSystemServerStatusMutation>;
export type DevManagementSystemServerStatusMutationResult = Apollo.MutationResult<DevManagementSystemServerStatusMutation>;
export type DevManagementSystemServerStatusMutationOptions = Apollo.BaseMutationOptions<DevManagementSystemServerStatusMutation, DevManagementSystemServerStatusMutationVariables>;
export const DevManagementSystemAdminTelemetryRequestDocument = gql`
    mutation DevManagementSystemAdminTelemetryRequest {
  devManagementSystemAdminTelemetryRequest
}
    `;
export type DevManagementSystemAdminTelemetryRequestMutationFn = Apollo.MutationFunction<DevManagementSystemAdminTelemetryRequestMutation, DevManagementSystemAdminTelemetryRequestMutationVariables>;

/**
 * __useDevManagementSystemAdminTelemetryRequestMutation__
 *
 * To run a mutation, you first call `useDevManagementSystemAdminTelemetryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemAdminTelemetryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devManagementSystemAdminTelemetryRequestMutation, { data, loading, error }] = useDevManagementSystemAdminTelemetryRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevManagementSystemAdminTelemetryRequestMutation(baseOptions?: Apollo.MutationHookOptions<DevManagementSystemAdminTelemetryRequestMutation, DevManagementSystemAdminTelemetryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevManagementSystemAdminTelemetryRequestMutation, DevManagementSystemAdminTelemetryRequestMutationVariables>(DevManagementSystemAdminTelemetryRequestDocument, options);
      }
export type DevManagementSystemAdminTelemetryRequestMutationHookResult = ReturnType<typeof useDevManagementSystemAdminTelemetryRequestMutation>;
export type DevManagementSystemAdminTelemetryRequestMutationResult = Apollo.MutationResult<DevManagementSystemAdminTelemetryRequestMutation>;
export type DevManagementSystemAdminTelemetryRequestMutationOptions = Apollo.BaseMutationOptions<DevManagementSystemAdminTelemetryRequestMutation, DevManagementSystemAdminTelemetryRequestMutationVariables>;
export const DevManagementSystemAdminViewportReloadRequestDocument = gql`
    mutation DevManagementSystemAdminViewportReloadRequest($input: DevManagementSystemAdminViewportReloadRequestInput!) {
  devManagementSystemAdminViewportReloadRequest(input: $input)
}
    `;
export type DevManagementSystemAdminViewportReloadRequestMutationFn = Apollo.MutationFunction<DevManagementSystemAdminViewportReloadRequestMutation, DevManagementSystemAdminViewportReloadRequestMutationVariables>;

/**
 * __useDevManagementSystemAdminViewportReloadRequestMutation__
 *
 * To run a mutation, you first call `useDevManagementSystemAdminViewportReloadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemAdminViewportReloadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devManagementSystemAdminViewportReloadRequestMutation, { data, loading, error }] = useDevManagementSystemAdminViewportReloadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevManagementSystemAdminViewportReloadRequestMutation(baseOptions?: Apollo.MutationHookOptions<DevManagementSystemAdminViewportReloadRequestMutation, DevManagementSystemAdminViewportReloadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevManagementSystemAdminViewportReloadRequestMutation, DevManagementSystemAdminViewportReloadRequestMutationVariables>(DevManagementSystemAdminViewportReloadRequestDocument, options);
      }
export type DevManagementSystemAdminViewportReloadRequestMutationHookResult = ReturnType<typeof useDevManagementSystemAdminViewportReloadRequestMutation>;
export type DevManagementSystemAdminViewportReloadRequestMutationResult = Apollo.MutationResult<DevManagementSystemAdminViewportReloadRequestMutation>;
export type DevManagementSystemAdminViewportReloadRequestMutationOptions = Apollo.BaseMutationOptions<DevManagementSystemAdminViewportReloadRequestMutation, DevManagementSystemAdminViewportReloadRequestMutationVariables>;
export const DevManagementSystemUserTelemetryDocument = gql`
    subscription DevManagementSystemUserTelemetry {
  devManagementSystemUserTelemetry {
    eventId
    pageName
    resourceId
    resourceName
    resourceType
    ts
    userId
    userName
    userProfileImageUrl
  }
}
    `;

/**
 * __useDevManagementSystemUserTelemetrySubscription__
 *
 * To run a query within a React component, call `useDevManagementSystemUserTelemetrySubscription` and pass it any options that fit your needs.
 * When your component renders, `useDevManagementSystemUserTelemetrySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevManagementSystemUserTelemetrySubscription({
 *   variables: {
 *   },
 * });
 */
export function useDevManagementSystemUserTelemetrySubscription(baseOptions?: Apollo.SubscriptionHookOptions<DevManagementSystemUserTelemetrySubscription, DevManagementSystemUserTelemetrySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DevManagementSystemUserTelemetrySubscription, DevManagementSystemUserTelemetrySubscriptionVariables>(DevManagementSystemUserTelemetryDocument, options);
      }
export type DevManagementSystemUserTelemetrySubscriptionHookResult = ReturnType<typeof useDevManagementSystemUserTelemetrySubscription>;
export type DevManagementSystemUserTelemetrySubscriptionResult = Apollo.SubscriptionResult<DevManagementSystemUserTelemetrySubscription>;
export const AdminManagementSystemUserTelemetryDocument = gql`
    mutation AdminManagementSystemUserTelemetry($input: AdminManagementSystemUserTelemetryInput!) {
  adminManagementSystemUserTelemetry(input: $input)
}
    `;
export type AdminManagementSystemUserTelemetryMutationFn = Apollo.MutationFunction<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>;

/**
 * __useAdminManagementSystemUserTelemetryMutation__
 *
 * To run a mutation, you first call `useAdminManagementSystemUserTelemetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemUserTelemetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminManagementSystemUserTelemetryMutation, { data, loading, error }] = useAdminManagementSystemUserTelemetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminManagementSystemUserTelemetryMutation(baseOptions?: Apollo.MutationHookOptions<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>(AdminManagementSystemUserTelemetryDocument, options);
      }
export type AdminManagementSystemUserTelemetryMutationHookResult = ReturnType<typeof useAdminManagementSystemUserTelemetryMutation>;
export type AdminManagementSystemUserTelemetryMutationResult = Apollo.MutationResult<AdminManagementSystemUserTelemetryMutation>;
export type AdminManagementSystemUserTelemetryMutationOptions = Apollo.BaseMutationOptions<AdminManagementSystemUserTelemetryMutation, AdminManagementSystemUserTelemetryMutationVariables>;
export const AdminManagementSystemPropsDocument = gql`
    query AdminManagementSystemProps {
  adminManagementSystemProps {
    currentAppVersion
  }
}
    `;

/**
 * __useAdminManagementSystemPropsQuery__
 *
 * To run a query within a React component, call `useAdminManagementSystemPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminManagementSystemPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminManagementSystemPropsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminManagementSystemPropsQuery(baseOptions?: Apollo.QueryHookOptions<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>(AdminManagementSystemPropsDocument, options);
      }
export function useAdminManagementSystemPropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>(AdminManagementSystemPropsDocument, options);
        }
export type AdminManagementSystemPropsQueryHookResult = ReturnType<typeof useAdminManagementSystemPropsQuery>;
export type AdminManagementSystemPropsLazyQueryHookResult = ReturnType<typeof useAdminManagementSystemPropsLazyQuery>;
export type AdminManagementSystemPropsQueryResult = Apollo.QueryResult<AdminManagementSystemPropsQuery, AdminManagementSystemPropsQueryVariables>;
export const ManagementSystemDocument = gql`
    subscription ManagementSystem($args: ManagementSystemArgs!) {
  managementSystem(args: $args) {
    eventId
    operation
    payload
    ref
    userId
    userName
    userProfileImageUrl
  }
}
    `;

/**
 * __useManagementSystemSubscription__
 *
 * To run a query within a React component, call `useManagementSystemSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagementSystemSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementSystemSubscription({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useManagementSystemSubscription(baseOptions: Apollo.SubscriptionHookOptions<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>(ManagementSystemDocument, options);
      }
export type ManagementSystemSubscriptionHookResult = ReturnType<typeof useManagementSystemSubscription>;
export type ManagementSystemSubscriptionResult = Apollo.SubscriptionResult<ManagementSystemSubscription>;